// import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import LeadForm from "../Lead Page/LeadForm";
// import { useNavigate } from "react-router-dom";
// import {
//   FaEdit,
//   FaTag,
//   FaUserPlus,
//   FaClock,
//   FaTasks,
//   FaUserCheck,
//   FaUserClock,
//   FaEnvelope,
//   FaHistory,
//   FaSearch,
//   FaTimes,
//   FaSms,
//   FaBan,
//   FaPhone,
//   FaFileDownload,
//   FaWhatsapp,
//   FaEllipsisV,
// } from "react-icons/fa";
// import { PhoneCall, X } from "lucide-react";
// import ReminderForm from "../Reminder Page/ReminderForm";
// import TaskForm from "../Task page/TaskForm";
// import { Select } from "antd";
// import { jwtDecode } from "jwt-decode";
// // import { useWebRTC } from '../context/WebRTCContext';

// // ── Small date/duration helpers used by the Call History popup (same
// // formatting used on the Card/Kanban view) ─────────────────────────────────
// function formatCallDateTime(dateStr) {
//   if (!dateStr) return "—";
//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return "—";
//   return d.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// }

// function formatCallDuration(seconds) {
//   if (seconds === undefined || seconds === null) return "—";
//   const mins = Math.floor(seconds / 60);
//   const secs = seconds % 60;
//   return `${mins}m ${secs}s`;
// }

// // ── Call History popup - same /call-recordings API and same UI as the
// // Card/Kanban view's Call History modal ────────────────────────────────────
// function CallHistoryModal({ open, lead, data, loading, onClose }) {
//   if (!open) return null;

//   return (
//     <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
//       <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
//         <div className="sticky top-0 bg-white dark:bg-gray-800 p-4 border-b dark:border-gray-700 flex justify-between items-center">
//           <h3 className="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2">
//             <PhoneCall className="w-4 h-4 text-[#673AB7]" /> Call History
//           </h3>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
//           >
//             <X className="w-5 h-5" />
//           </button>
//         </div>

//         {lead && (
//           <div className="flex items-center gap-3 px-4 py-3 border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
//             <div className="w-9 h-9 rounded-full bg-[#F3E8FF] text-[#673AB7] flex items-center justify-center font-bold text-sm">
//               {(lead.name || "?").charAt(0).toUpperCase()}
//             </div>
//             <div className="min-w-0">
//               <p className="text-sm font-semibold text-gray-800 dark:text-white truncate">{lead.name}</p>
//               {lead.phone && <p className="text-xs text-gray-500 dark:text-gray-300">📞 {lead.phone}</p>}
//             </div>
//           </div>
//         )}

//         <div className="p-4 space-y-3">
//           {loading ? (
//             <div className="flex justify-center py-8">
//               <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-[#673AB7]"></div>
//             </div>
//           ) : !data || data.length === 0 ? (
//             <p className="text-center text-sm text-gray-400 py-6">No call recordings found.</p>
//           ) : (
//             data.map((item, idx) => (
//               <div
//                 key={item.callSessionId || idx}
//                 className="border border-gray-200 dark:border-gray-600 rounded-lg p-3 bg-gray-50 dark:bg-gray-700"
//               >
//                 <div className="flex items-center justify-between mb-2">
//                   <div>
//                     <p className="text-xs font-semibold text-gray-700 dark:text-gray-200">
//                       Session: {item.callSessionId}
//                     </p>
//                     <p className="text-[11px] text-gray-500 dark:text-gray-400">
//                       {formatCallDateTime(item.startTime)}
//                     </p>
//                   </div>
//                   <span
//                     className="text-white text-[11px] font-semibold px-2 py-0.5 rounded-full"
//                     style={{ backgroundColor: item.status === "answered" ? "#16a34a" : "#F46653" }}
//                   >
//                     {item.status}
//                   </span>
//                 </div>
//                 <p className="text-xs text-gray-600 dark:text-gray-300">
//                   Duration: <b>{formatCallDuration(item.callDuration)}</b>
//                 </p>
//                 {item.resourceURL && (
//                   <audio src={item.resourceURL} controls className="w-full h-9 mt-2" />
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// const EmailModal = ({
//   isEmailModalOpen,
//   templates,
//   selectedLeadForEmail,
//   setSelectedLeadForEmail,
//   selectedTemplate,
//   setSelectedTemplate,
//   templateVariables,
//   setTemplateVariables,
//   selectedTemplateData,
//   setSelectedTemplateData,
//   isSending,
//   setIsSending,
//   user,
//   fetchData,
//   onClose,
// }) => {
//   const navigate = useNavigate();
//   const handleEmailChange = (e) => {
//     setSelectedLeadForEmail(e.target.value);
//   };

//   const handleTemplateChange = async (e) => {
//     const templateId = e.target.value;
//     setSelectedTemplate(templateId);
//     const template = templates.find((t) => t.emailTemplateId === templateId);
//     setSelectedTemplateData(template);

//     if (template) {
//       const variables = {};
//       const varRegex = /\{\{(\w+)\}\}/g;
//       let match;
//       while ((match = varRegex.exec(template.body)) !== null) {
//         variables[match[1]] = "";
//       }
//       setTemplateVariables(variables);
//     } else {
//       setTemplateVariables({});
//     }
//   };

//   const handleVariableChange = (varName, value) => {
//     setTemplateVariables((prev) => ({
//       ...prev,
//       [varName]: value,
//     }));
//   };

//   const handleSubmit = async () => {
//     if (!selectedTemplate) return toast.error("Please select a template");
//     if (!selectedLeadForEmail) return toast.error("Please enter an email");

//     const emptyVars = Object.entries(templateVariables)
//       .filter(([_, val]) => !val.trim())
//       .map(([key]) => key);

//     if (emptyVars.length > 0) {
//       toast.error(`Please fill all variables: ${emptyVars.join(", ")}`);
//       return;
//     }

//     setIsSending(true);
//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//       const response = await fetch(
//         `${API_URL}/api/leads/${selectedTemplate}/sendEmail/${companyId}/${user?.id}/${selectedLeadForEmail}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(Object.values(templateVariables)),
//         },
//       );

//       if (response.ok) {
//         const contentType = response.headers.get("content-type");
//         let data = contentType?.includes("application/json")
//           ? await response.json()
//           : await response.text();

//         if (
//           data === "Email sent successfully" ||
//           data?.message === "Email sent successfully"
//         ) {
//           toast.success("Email sent successfully");
//           onClose();
//           fetchData();
//         } else {
//           toast.error("Failed to send email");
//         }
//       } else {
//         toast.error("Failed to send email. Please try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Something went wrong.");
//     } finally {
//       setIsSending(false);
//     }
//   };

//   const renderDynamicPreview = (template) => {
//     if (!template?.body) return "";
//     let updated = template.body;
//     Object.entries(templateVariables).forEach(([key, value]) => {
//       const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
//       updated = updated.replace(regex, value || `{{${key}}}`);
//     });
//     return updated;
//   };

//   if (!isEmailModalOpen) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-5xl max-h-[90vh] overflow-y-auto">
//         <h2 className="text-xl font-bold mb-6 dark:text-white">Send Email</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Left Section */}
//           <div>
//             <div className="mb-4">
//               <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                 To:
//               </label>
//               <input
//                 type="email"
//                 value={selectedLeadForEmail || ""}
//                 onChange={handleEmailChange}
//                 className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//                 required
//               />
//             </div>

//             <div className="mb-4">
//               <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                 Select Template:
//               </label>
//               <select
//                 value={selectedTemplate || ""}
//                 onChange={handleTemplateChange}
//                 className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//               >
//                 <option value="">-- Select Template --</option>
//                 {templates.map((t) => (
//                   <option key={t.emailTemplateId} value={t.emailTemplateId}>
//                     {t.title} - {t.subject}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {Object.keys(templateVariables).length > 0 && (
//               <div className="mb-4">
//                 <label className="block text-gray-700 font-medium mb-2 dark:text-white">
//                   Fill Template Variables:
//                 </label>
//                 <div className="space-y-3">
//                   {Object.entries(templateVariables).map(([key, val]) => (
//                     <div key={key}>
//                       <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">
//                         {key}:
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//                         value={val}
//                         onChange={(e) =>
//                           handleVariableChange(key, e.target.value)
//                         }
//                         placeholder={`Enter ${key}`}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Right Section - Live Preview */}
//           <div>
//             {selectedTemplateData && (
//               <div className="mb-4">
//                 <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                   Template Live Preview:
//                 </label>
//                 <div className="p-4 border rounded bg-gray-50 dark:bg-gray-900 text-sm overflow-auto min-h-[200px] whitespace-pre-wrap">
//                   <h3 className="font-bold mb-2">
//                     {selectedTemplateData.subject}
//                   </h3>
//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: renderDynamicPreview(selectedTemplateData),
//                     }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex justify-end mt-6 space-x-3">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm"
//             disabled={isSending}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm disabled:opacity-50"
//             disabled={!selectedTemplate || !selectedLeadForEmail || isSending}
//           >
//             {isSending ? "Sending..." : "Send Email"}
//           </button>
//         </div>

//         {templates.length === 0 && (
//           <div className="mt-6 text-center">
//             <button
//               onClick={() => {
//                 onClose();
//                 navigate("/emailTemplates");
//               }}
//               className="text-[#673AB7] underline"
//             >
//               Go to Templates
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const SmsModal = ({
//   isSmsModalOpen,
//   smsTemplates,
//   selectedLeadForSms,
//   setSelectedLeadForSms,
//   selectedTemplate,
//   setSelectedTemplate,
//   templateVariables,
//   setTemplateVariables,
//   selectedTemplateData,
//   setSelectedTemplateData,
//   isSending,
//   setIsSending,
//   user,
//   fetchData,
//   onClose,
// }) => {
//   const navigate = useNavigate();

//   const handleSmsChange = (e) => {
//     setSelectedLeadForSms(e.target.value);
//   };

//   const handleTemplateChange = async (e) => {
//     const messageId = e.target.value;
//     setSelectedTemplate(messageId);
//     const template = smsTemplates.find((t) => t.messageId === messageId);
//     setSelectedTemplateData(template);

//     if (template) {
//       const variables = {};
//       const varRegex = /\{\{(\w+)\}\}/g;
//       let match;
//       while ((match = varRegex.exec(template.templateText)) !== null) {
//         variables[match[1]] = "";
//       }
//       setTemplateVariables(variables);
//     } else {
//       setTemplateVariables({});
//     }
//   };

//   const handleVariableChange = (varName, value) => {
//     setTemplateVariables((prev) => ({
//       ...prev,
//       [varName]: value,
//     }));
//   };

//   const handleSubmit = async () => {
//     if (!selectedTemplate) return toast.error("Please select a template");
//     if (!selectedLeadForSms) return toast.error("Please enter a phone number");

//     const emptyVars = Object.entries(templateVariables)
//       .filter(([_, val]) => !val.trim())
//       .map(([key]) => key);

//     if (emptyVars.length > 0) {
//       toast.error(`Please fill all variables: ${emptyVars.join(", ")}`);
//       return;
//     }

//     setIsSending(true);
//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//       const response = await fetch(
//         `${API_URL}/api/smsConfig/send/${companyId}?createdById=${user?.id}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             clientNumber: [selectedLeadForSms],
//             messageId: selectedTemplate,
//             variables: Object.values(templateVariables),
//           }),
//         },
//       );

//       if (response.ok) {
//         const data = await response.json();
//         if (data.message === "SMS sent successfully") {
//           toast.success("SMS sent successfully");
//           onClose();
//           fetchData();
//         } else {
//           toast.error(data.message || "Failed to send SMS");
//         }
//       } else {
//         const errorData = await response.json();
//         toast.error(
//           errorData.message || "Failed to send SMS. Please try again.",
//         );
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Something went wrong.");
//     } finally {
//       setIsSending(false);
//     }
//   };

//   const renderDynamicPreview = (template) => {
//     if (!template?.templateText) return "";
//     let updated = template.templateText;
//     Object.entries(templateVariables).forEach(([key, value]) => {
//       const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
//       updated = updated.replace(regex, value || `{{${key}}}`);
//     });
//     return updated;
//   };

//   if (!isSmsModalOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-5xl max-h-[90vh] overflow-y-auto">
//         <h2 className="text-xl font-bold mb-6 dark:text-white">Send SMS</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Left Section */}
//           <div>
//             <div className="mb-4">
//               <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                 Phone Number:
//               </label>
//               <input
//                 type="tel"
//                 value={selectedLeadForSms || ""}
//                 onChange={handleSmsChange}
//                 className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//                 required
//               />
//             </div>

//             <div className="mb-4">
//               <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                 Select Template:
//               </label>
//               <select
//                 value={selectedTemplate || ""}
//                 onChange={handleTemplateChange}
//                 className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//               >
//                 <option value="">-- Select Template --</option>
//                 {smsTemplates.map((t) => (
//                   <option key={t.messageId} value={t.messageId}>
//                     {t.templateType}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {Object.keys(templateVariables).length > 0 && (
//               <div className="mb-4">
//                 <label className="block text-gray-700 font-medium mb-2 dark:text-white">
//                   Fill Template Variables:
//                 </label>
//                 <div className="space-y-3">
//                   {Object.entries(templateVariables).map(([key, val]) => (
//                     <div key={key}>
//                       <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">
//                         {key}:
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//                         value={val}
//                         onChange={(e) =>
//                           handleVariableChange(key, e.target.value)
//                         }
//                         placeholder={`Enter ${key}`}
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Right Section - Live Preview */}
//           <div>
//             {selectedTemplateData && (
//               <div className="mb-4">
//                 <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//                   Template Preview:
//                 </label>
//                 <div className="p-4 border rounded bg-gray-50 dark:bg-gray-900 text-sm overflow-auto min-h-[200px] whitespace-pre-wrap dark:text-white">
//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: renderDynamicPreview(selectedTemplateData),
//                     }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex justify-end mt-6 space-x-3">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm dark:text-white"
//             disabled={isSending}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm disabled:opacity-50"
//             disabled={!selectedTemplate || !selectedLeadForSms || isSending}
//           >
//             {isSending ? "Sending..." : "Send SMS"}
//           </button>
//         </div>

//         {smsTemplates.length === 0 && (
//           <div className="mt-6 text-center">
//             <button
//               onClick={() => {
//                 onClose();
//                 navigate("/smsTemplates");
//               }}
//               className="text-[#673AB7] underline"
//             >
//               Go to Templates
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const LabelModal = ({
//   isOpen,
//   onClose,
//   labels,
//   selectedProjectId,
//   setSelectedProjectId,
//   onLabelSelect,
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
//         <h2 className="text-xl font-bold mb-4">Project Name</h2>

//         {/* Dropdown with colored options */}
//         <select
//           className="w-full p-2 border rounded bg-white text-black dark:bg-gray-800 dark:text-white dark:border-gray-600"
//           value={selectedProjectId}
//           onChange={(e) => setSelectedProjectId(e.target.value)}
//         >
//           <option value="">Select a project</option>
//           {labels.map((label) => (
//             <option
//               key={label.id}
//               value={label.id}
//               style={{
//                 backgroundColor: label.color,
//                 color: "#fff", // ensure text is visible
//               }}
//             >
//               {label.name}
//             </option>
//           ))}
//         </select>

//         <div className="flex justify-end space-x-2 mt-4">
//           <button
//             className="bg-gray-300 px-4 py-2 rounded dark:bg-gray-600 dark:text-white"
//             onClick={onClose}
//           >
//             Cancel
//           </button>
//           <button
//             className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
//             onClick={() => {
//               if (selectedProjectId) {
//                 onLabelSelect(selectedProjectId);
//               } else {
//                 toast.error("Please select a label.");
//               }
//             }}
//           >
//             Submit
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DownloadReportModal = ({
//   isDownloadModalOpen,
//   setIsDownloadModalOpen,
//   downloadParams,
//   setDownloadParams,
//   users,
//   labels,
//   statuses,
//   sourceOptions,
//   handleDownloadReport,
// }) => {
//   if (!isDownloadModalOpen) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-2xl max-h-[90vh] overflow-y-auto">
//         <h2 className="text-xl font-bold mb-6 dark:text-white">
//           Download Report
//         </h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               Created By
//             </label>
//             <Select
//               allowClear
//               placeholder="Select user"
//               value={downloadParams.createdById || undefined}
//               onChange={(value) =>
//                 setDownloadParams((prev) => ({ ...prev, createdById: value }))
//               }
//               options={users.map((user) => ({
//                 value: user.id,
//                 label: `${user.fname} ${user.lname}`,
//               }))}
//               className="w-full"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               Assigned To
//             </label>
//             <Select
//               allowClear
//               placeholder="Select user"
//               value={downloadParams.assignedToId || undefined}
//               onChange={(value) =>
//                 setDownloadParams((prev) => ({ ...prev, assignedToId: value }))
//               }
//               options={users.map((user) => ({
//                 value: user.id,
//                 label: `${user.fname} ${user.lname}`,
//               }))}
//               className="w-full"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               Project Name
//             </label>
//             <Select
//               allowClear
//               placeholder="Select project"
//               value={downloadParams.projectName || undefined}
//               onChange={(value) =>
//                 setDownloadParams((prev) => ({ ...prev, projectName: value }))
//               }
//               options={labels.map((label) => ({
//                 value: label.name,
//                 label: label.name,
//               }))}
//               className="w-full"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               Status
//             </label>
//             <Select
//               allowClear
//               placeholder="Select status"
//               value={downloadParams.statusName || undefined}
//               onChange={(value) =>
//                 setDownloadParams((prev) => ({ ...prev, statusName: value }))
//               }
//               options={statuses
//                 .filter((status) => status.active === true)
//                 .map((status) => ({
//                   value: status.name,
//                   label: status.name,
//                 }))}
//               className="w-full"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               Source
//             </label>
//             <Select
//               allowClear
//               placeholder="Select source"
//               value={downloadParams.sourceName || undefined}
//               onChange={(value) =>
//                 setDownloadParams((prev) => ({ ...prev, sourceName: value }))
//               }
//               options={sourceOptions
//                 .filter((source) => source.active === true) // ✅ Only show active sources
//                 .map((source) => ({
//                   value: source.name,
//                   label: source.name,
//                 }))}
//               className="w-full"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               From Date
//             </label>
//             <input
//               type="date"
//               className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//               value={downloadParams.fromDate}
//               onChange={(e) =>
//                 setDownloadParams((prev) => ({
//                   ...prev,
//                   fromDate: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium text-gray-700 dark:text-white">
//               To Date
//             </label>
//             <input
//               type="date"
//               className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
//               value={downloadParams.toDate}
//               onChange={(e) =>
//                 setDownloadParams((prev) => ({
//                   ...prev,
//                   toDate: e.target.value,
//                 }))
//               }
//             />
//           </div>

//         </div>

//         <div className="flex justify-end mt-6 space-x-3">
//           <button
//             onClick={() => setIsDownloadModalOpen(false)}
//             className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleDownloadReport}
//             className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm"
//           >
//             Download Report
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const TableView = ({ refreshTrigger }) => {
//   const { user } = useContext(AuthContext);
//   const [data, setData] = useState([]);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
//   const [assignToUserId, setAssignToUserId] = useState("");
//   const [users, setUsers] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isFormUpdated, setIsFormUpdated] = useState(false);
//   const [formData, setFormData] = useState({});
//   const [selectedLeadId, setSelectedLeadId] = useState(null);

//   const [selectedLeadName, setSelectedLeadName] = useState("");
//   const [selectedLeadPhone, setSelectedLeadPhone] = useState("");
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [deleteReason, setDeleteReason] = useState("");
//   const [deleteLeadId, setDeleteLeadId] = useState(null);
//   const [labels, setLabels] = useState([]);
//   const [sourceOptions, setSourceOptions] = useState([]);
//   const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);
//   const [selectedLabelLeadId, setSelectedLabelLeadId] = useState([]);
//   const [selectedProjectId, setSelectedProjectId] = useState("");
//   const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
//   const [leadToConvert, setLeadToConvert] = useState(null);
//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [selectedLeadForEmail, setSelectedLeadForEmail] = useState("");
//   const [templates, setTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState("");
//   const [isSending, setIsSending] = useState(false);
//   const [historyData, setHistoryData] = useState([]);
//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(100);
//   const [totalPages, setTotalPages] = useState(0);
//   const [searchParams, setSearchParams] = useState({
//     labelName: "",
//     sourceName: "",
//     targetUserId: "",
//     statusName: "",
//     startDate: "",
//     endDate: "",
//     phone: "",
//     city: "",
//     state: "",
//     nextFollowUpDate: "",
//   });
//   const [isSearching, setIsSearching] = useState(false);
//   const [isSearchMode, setIsSearchMode] = useState(false);

//   // Search results now come from a cursor-paginated endpoint (no more totalPages/skip).
//   // searchPageCursors[i] is the cursor used to fetch search-results page i (0-based);
//   // index 0 is always null (first page has no cursor). Going "Prev" re-fetches using the
//   // cursor already recorded for that page instead of walking backwards - keyset pagination
//   // only ever moves forward against the API, so the frontend keeps its own trail of cursors
//   // to make "Prev" possible.
//   const [searchPageCursors, setSearchPageCursors] = useState([null]);
//   const [searchPageIndex, setSearchPageIndex] = useState(0);
//   const [searchHasMore, setSearchHasMore] = useState(false);

//   const [statuses, setStatuses] = useState([]);
//   const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
//   const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [expandedRows, setExpandedRows] = useState([]);
//   const [reason, setReason] = useState("");
//   const [isFollowUpModalOpen, setFollowUpModalOpen] = useState(false);
//   const [followUpData, setFollowUpData] = useState({
//     notes: "",
//     nextFollowUpDate: "",
//     nextFollowUpTime: "",
//     followedById: "",
//     followedByName: "",
//     createdById: user?.id,
//     createdByName: user?.name,
//     companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//   });
//   const [templateVariables, setTemplateVariables] = useState({});
//   const [selectedTemplateData, setSelectedTemplateData] = useState(null);
//   const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);
//   const [selectedLeadForSms, setSelectedLeadForSms] = useState("");
//   const [smsTemplates, setSmsTemplates] = useState([]);
//   const [followUpHistory, setFollowUpHistory] = useState([]);
//   const [showFollowUpHistoryModal, setShowFollowUpHistoryModal] =
//     useState(false);
//   const [loginMobileNo, setLoginMobileNo] = useState("");
//   const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
//   const [downloadParams, setDownloadParams] = useState({
//     companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//     createdById: "",
//     assignedToId: "",
//     projectName: "",
//     statusName: "",
//     sourceName: "",
//     fromDate: "",
//     toDate: "",
//   });
//   const [isWhatsappModelOpen, setIsWhatsappModelOpen] = useState(false);
//   const [template, setTemplate] = useState([]);
//   const [selectedWhatsappTemplate, setSelectedWhatsappTemplate] = useState("");
//   const [selectedWhatsappTemplateBody, setSelectedWhatsappTemplateBody] =
//     useState("");
//   const [whatsappVariableValues, setWhatsappVariableValues] = useState({});
//   const [waApiKey, setWaApiKey] = useState("");
//   const companyId = user?.accountType === "COMPANY" ? user.id : user?.companyId;
//   const [stateList, setStateList] = useState([]);
//   const [cityList, setCityList] = useState([]);

//   const [activeActionMenu, setActiveActionMenu] = useState(null);
//   const actionMenuRef = useRef(null);

//   // ── Call History popup state (same API/logic as the Card/Kanban view) ───
//   const [showCallHistoryModal, setShowCallHistoryModal] = useState(false);
//   const [callHistoryLead, setCallHistoryLead] = useState(null);
//   const [callHistoryData, setCallHistoryData] = useState([]);
//   const [callHistoryLoading, setCallHistoryLoading] = useState(false);

//   // ✅ FIX: Changed 'mousedown' to 'click' to fix the double click/toggle bug 
//   // with the 3 dots button conflicting events.
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
//         setActiveActionMenu(null);
//       }
//     };
//     document.addEventListener("click", handleClickOutside);
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, []);

//   // ✅ ADDED: Auto-scroll to show the popup fully if it opens near the bottom
//   useEffect(() => {
//     if (activeActionMenu && actionMenuRef.current) {
//       // Scrolls the menu into view smoothly
//       actionMenuRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
//     }
//   }, [activeActionMenu]);

//   const updateLeadInTable = (leadId, updatedFields) => {
//     setData((prev) =>
//       prev.map((lead) =>
//         lead.leadId === leadId
//           ? { ...lead, ...updatedFields }
//           : lead
//       )
//     );
//   };

//   useEffect(() => {
//     async function fetchStates() {
//       try {
//         const res = await fetch(`${API_URL}/api/india/states`);
//         const data = await res.json();
//         let states = [];
//         if (Array.isArray(data?.data)) {
//           states = data.data;
//         } else if (Array.isArray(data?.data?.states)) {
//           states = data.data.states.map((s) => s.name);
//         } else if (Array.isArray(data?.states)) {
//           states = data.states;
//         }

//         setStateList(states);
//       } catch (err) {
//         console.error("Error fetching states:", err);
//       }
//     }

//     fetchStates();
//   }, []);

//   useEffect(() => {
//     async function fetchCities() {
//       if (!searchParams.state) return;

//       try {
//         const res = await fetch(
//           `${API_URL}/api/india/cities?state=${encodeURIComponent(
//             searchParams.state,
//           )}`,
//         );
//         const data = await res.json();
//         if (Array.isArray(data.data)) {
//           setCityList(data.data);
//         } else {
//           setCityList([]);
//         }
//       } catch (err) {
//         console.error("Error fetching cities:", err);
//       }
//     }

//     fetchCities();
//   }, [searchParams.state]);

//   const fetchWaApiKey = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/api/whatsappConfig/${companyId}`, {
//         headers: {
//           authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       if (res.data && res.data.status === "success" && res.data.data?.apiKey) {
//         setWaApiKey(res.data.data.apiKey);
//         return res.data.data.apiKey;
//       }
//       return "";
//     } catch (error) {
//       console.warn("WhatsApp config not found or error fetching:", error?.message);
//       return "";
//     }
//   };

//   const handleWhatsappClick = async (item) => {
//     setIsWhatsappModelOpen(true);
//     setSelectedLeadId(item.phone);
//     setSelectedWhatsappTemplate("");
//     setSelectedWhatsappTemplateBody("");
//     setWhatsappVariableValues({});
//     try {
//       let apiKey = waApiKey;
//       if (!apiKey) {
//         apiKey = await fetchWaApiKey();
//       }

//       if (!apiKey) {
//         toast.error("WhatsApp API Key is not configured for this company.");
//         setTemplate([]);
//         return;
//       }

//       const res = await axios.get(
//         `https://waapi.deetyasoft.com/api/lms/whatsapp-config/getTemplate?apiKey=${apiKey}`,
//       );
//       setTemplate(res.data?.templates || res.data?.data || res.data || []);
//     } catch (error) {
//       console.error("Error fetching Templates:", error);
//       toast.error("Failed to load WhatsApp templates.");
//       setTemplate([]);
//     }
//   };

//   const handleTemplateChange = (templateName) => {
//     setSelectedWhatsappTemplate(templateName);
//     const tpl = template.find((t) => t.name === templateName);

//     if (tpl) {
//       const body =
//         tpl.components?.find((c) => c.type === "BODY")?.text ||
//         tpl.body ||
//         tpl.templateText ||
//         tpl.content ||
//         "";

//       setSelectedWhatsappTemplateBody(body);
//       setWhatsappVariableValues({});
//     } else {
//       setSelectedWhatsappTemplateBody("");
//       setWhatsappVariableValues({});
//     }
//   };

//   const extractWhatsappVariables = (text) => {
//     if (!text) return [];
//     const matches = text.match(/{{(\d+)}}/g);
//     return matches
//       ? [...new Set(matches.map((m) => m.match(/\d+/)[0]))].sort(
//         (a, b) => parseInt(a) - parseInt(b),
//       )
//       : [];
//   };

//   const getWhatsappPreviewText = (text) => {
//     if (!text) return "";
//     let updated = text;
//     Object.keys(whatsappVariableValues).forEach((key) => {
//       const regex = new RegExp(`{{${key}}}`, "g");
//       updated = updated.replace(regex, whatsappVariableValues[key] || `{{${key}}}`);
//     });
//     return updated;
//   };

//   const handleWhatsappVariableChange = (key, value) => {
//     setWhatsappVariableValues((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const handleSendWhatsapp = async (e, item) => {
//     e.preventDefault();
//     if (!selectedWhatsappTemplate) return;

//     if (!waApiKey) {
//       toast.error("WhatsApp API Key is missing!");
//       return;
//     }

//     const formatPhoneNumber = (phone) => {
//       const cleaned = phone.replace(/\D/g, "");

//       if (cleaned.startsWith("91") && cleaned.length === 12) {
//         return cleaned;
//       }

//       if (cleaned.length === 10) {
//         return `91${cleaned}`;
//       }

//       return cleaned;
//     };

//     try {
//       const formattedPhone = formatPhoneNumber(selectedLeadId);

//       const formData = new FormData();
//       formData.append("apiKey", waApiKey);
//       formData.append("templateName", selectedWhatsappTemplate);
//       formData.append("to", formattedPhone);

//       const varKeys = Object.keys(whatsappVariableValues).sort(
//         (a, b) => parseInt(a) - parseInt(b),
//       );
//       if (varKeys.length > 0) {
//         const manualVars = varKeys
//           .map((key) => whatsappVariableValues[key] || "")
//           .join(",");
//         formData.append("manualVars", manualVars);
//       }

//       await axios.post(
//         `https://waapi.deetyasoft.com/api/lms/whatsapp-config/sendVerifiedTemplates`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       toast.success("WhatsApp message sent successfully!");
//       setIsWhatsappModelOpen(false);
//       setSelectedWhatsappTemplate("");
//       setSelectedWhatsappTemplateBody("");
//       setWhatsappVariableValues({});
//     } catch (error) {
//       console.error("Error sending message:", error);
//       toast.error("Failed to send WhatsApp message");
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       const token = localStorage.getItem("token");
//       if (!token) return;

//       const apiCalls = [
//         axios
//           .get(`${API_URL}/api/leadStatus/company/${companyId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           })
//           .then((response) => {
//             setStatuses(response.data || []);
//           })
//           .catch((error) => {
//             console.error("Error fetching lead statuses:", error);
//             setStatuses([]);
//           }),

//         axios
//           .post(
//             `${API_URL}/api/ivr/sync-call-records/${companyId}`,
//             {},
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             },
//           )
//           .catch((error) => {
//             console.error("Error syncing call records:", error);
//           }),

//         axios
//           .post(
//             `${API_URL}/api/publicLeads/fetch-leads/${companyId}`,
//             {},
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             },
//           )
//           .then((response) => {
//             console.log("Public leads fetched successfully");
//           })
//           .catch((error) => {
//             console.error("Error fetching public leads:", error);
//           }),
//       ];

//       await Promise.allSettled(apiCalls);
//     };

//     fetchData();
//   }, [user?.id, user?.accountType, user?.companyId, refreshTrigger]);

//   const openStatusModal = (leadId, statusName) => {
//     const selected = statuses.find((s) => s.name === statusName);
//     if (!selected) return;
//     setSelectedLeadId(leadId);
//     setSelectedStatus(selected);
//     setShowModal(true);
//   };

//   const toggleRowExpand = (leadId) => {
//     setExpandedRows((prev) =>
//       prev.includes(leadId)
//         ? prev.filter((id) => id !== leadId)
//         : [...prev, leadId],
//     );
//   };

//   useEffect(() => {
//     async function fetchSource() {
//       if (!user) return;

//       const companyId =
//         user.accountType === "COMPANY" ? user.id : user.companyId;

//       try {
//         const response = await axios.get(
//           `${API_URL}/api/leadSource/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           },
//         );

//         setSourceOptions(response.data || []);
//       } catch (error) {
//         console.error("Error fetching source:", error);
//       }
//     }

//     fetchSource();
//   }, [user]);

//   const handleAssignMultipleLeads = (leadIds) => {
//     setSelectedLeads(leadIds);
//     setIsAssignModalOpen(true);
//   };

//   const handleModalSubmit = async () => {
//     if (!selectedLeadId || !selectedStatus || !reason.trim()) {
//       toast.error("Please provide a reason");
//       return;
//     }

//     const token = user?.token || localStorage.getItem("token");

//     try {
//       const response = await axios.put(
//         `${API_URL}/api/leads/update/${selectedLeadId}/changedBy/${user?.id}`,
//         {
//           statusName: selectedStatus.name,
//           statusColor: selectedStatus.color,
//           reason: reason.trim(),
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );


//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);

//         updateLeadInTable(selectedLeadId, {
//           statusName: selectedStatus.name,
//           statusColor: selectedStatus.color,
//         });
//         setShowModal(false);

//         setReason("");
//         setSelectedStatus(null);
//       } else {
//         throw new Error(response.data.message || "Failed to update status");
//       }
//     } catch (err) {
//       console.error("Error updating lead status:", err);
//       toast.error(err.response?.data.message);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Builds the query params for one call to the cursor-paginated search endpoint.
//   // `cursor` is either null (first page) or one of the entries in searchPageCursors -
//   // an object shaped like { cursorStatusWeight, cursorNextFollowUpDate, cursorCreatedAt,
//   // cursorLeadId }. These are opaque bookmarks from a previous response - we just echo
//   // them back verbatim, never construct or interpret them ourselves. cursorNextFollowUpDate
//   // can legitimately be null (a lead with no follow-up date), so it's dropped from the
//   // request entirely rather than sent as the literal string "null".
//   const buildSearchApiParams = (cursor) => {
//     const base = {
//       limit: pageSize,
//       ...Object.fromEntries(
//         Object.entries(searchParams).filter(([_, value]) => value !== ""),
//       ),
//     };

//     if (!cursor) {
//       return base;
//     }

//     const cursorParams = Object.fromEntries(
//       Object.entries(cursor).filter(
//         ([_, value]) => value !== null && value !== undefined,
//       ),
//     );

//     return { ...base, ...cursorParams };
//   };

//   // Pulls the "next cursor" bundle out of a search response, ready to be passed straight
//   // back into buildSearchApiParams on the following call.
//   const cursorFromSearchResponse = (payload) => ({
//     cursorStatusWeight: payload?.nextCursorStatusWeight,
//     cursorNextFollowUpDate: payload?.nextCursorNextFollowUpDate,
//     cursorCreatedAt: payload?.nextCursorCreatedAt,
//     cursorLeadId: payload?.nextCursorLeadId,
//   });

//   const runLeadSearch = useCallback(
//     async (cursor) => {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return null;

//       const token = localStorage.getItem("token");
//       if (!token) {
//         toast.error("Authentication token not found");
//         return null;
//       }

//       const response = await axios.get(
//         `${API_URL}/api/leads/search/${companyId}/${user?.id}`,
//         {
//           params: buildSearchApiParams(cursor),
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       return response.data;
//     },
//     [user, pageSize, searchParams],
//   );

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);
//     setIsSearchMode(true);
//     setSearchPageIndex(0);
//     setSearchPageCursors([null]);
//     setSearchHasMore(false);

//     try {
//       const data = await runLeadSearch(null);
//       if (!data) return;

//       setData(data.leads || []);
//       setSearchHasMore(!!data.hasMore);
//       if (data.hasMore) {
//         setSearchPageCursors([null, cursorFromSearchResponse(data)]);
//       }
//       toast.success(`Found ${data.leads?.length || 0} results`);
//     } catch (error) {
//       console.error("Search failed:", error);
//       toast.error(
//         error.response?.data?.message || "Search failed. Please try again.",
//       );
//       setData([]);
//       setSearchHasMore(false);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   // Re-fetches a page of search results using the cursor already recorded for it in
//   // searchPageCursors (index 0's cursor is always null, i.e. the first page). If this is
//   // the furthest page reached so far and there's more to load, records the cursor for the
//   // page after it so a later "Next" click doesn't need to re-derive anything.
//   const goToSearchPage = async (index) => {
//     if (index < 0 || index >= searchPageCursors.length) return;

//     try {
//       const cursor = searchPageCursors[index];
//       const data = await runLeadSearch(cursor);
//       if (!data) return;

//       setData(data.leads || []);
//       setSearchPageIndex(index);
//       setSearchHasMore(!!data.hasMore);

//       if (data.hasMore && index === searchPageCursors.length - 1) {
//         setSearchPageCursors((prev) => [...prev, cursorFromSearchResponse(data)]);
//       }
//     } catch (error) {
//       console.error("Error fetching search page:", error);
//       toast.error(error.response?.data?.message || "Failed to load page");
//     }
//   };

//   const handleClearSearch = async () => {
//     setSearchParams({
//       labelName: "",
//       targetUserId: "",
//       sourceName: "",
//       createdAt: "",
//       startDate: "",
//       endDate: "",
//       phone: "",
//       city: "",
//       state: "",
//       nextFollowUpDate: "",
//     });
//     setIsSearchMode(false);
//     setSearchPageCursors([null]);
//     setSearchPageIndex(0);
//     setSearchHasMore(false);
//     setPageNumber(0);
//     await fetchData(0);
//     toast.success("Search cleared");
//   };

//   const fetchLeadHistory = async (lead) => {
//     try {
//       setSelectedLeadId(lead.leadId);

//       const token = localStorage.getItem("token");

//       const res = await axios.get(`${API_URL}/api/leadHistory/${lead.leadId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setHistoryData(res.data.content);
//       setShowHistoryModal(true);
//     } catch (err) {
//       console.error("Error fetching lead history", err);
//       toast.error("Failed to fetch lead history");
//     }
//   };

//   // ── Call History popup - same /call-recordings API and logic as Card view ─
//   const handleOpenCallHistory = async (lead) => {
//     if (!lead?.leadId) return;
//     setCallHistoryLead(lead);
//     setCallHistoryLoading(true);
//     setShowCallHistoryModal(true);
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${API_URL}/api/leads/${lead.leadId}/call-recordings`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );
//       setCallHistoryData(response.data || []);
//     } catch (err) {
//       console.error("Error fetching call history:", err);
//       toast.error("Failed to fetch call history");
//       setCallHistoryData([]);
//     } finally {
//       setCallHistoryLoading(false);
//     }
//   };

//   const fetchEmailTemplates = useCallback(async () => {
//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/emailTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setTemplates(response.data.emailTemplates || []);
//     } catch (error) {
//       console.error("Error fetching email templates:", error);
//       toast.error("Failed to load email templates");
//     }
//   }, [user]);

//   useEffect(() => {
//     if (isEmailModalOpen) {
//       fetchEmailTemplates();
//     }
//   }, [isEmailModalOpen, fetchEmailTemplates]);

//   const handleEmailClick = (lead) => {
//     setSelectedLeadForEmail(lead.email);
//     setIsEmailModalOpen(true);
//   };

//   const handleSmsClick = (lead) => {
//     setSelectedLeadForSms(lead.phone);
//     setIsSmsModalOpen(true);
//   };

//   const fetchSmsTemplates = useCallback(async () => {
//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/smsTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       setSmsTemplates(response.data.smsTemplates || []);
//     } catch (error) {
//       console.error("Failed to fetch SMS templates:", error);
//       setSmsTemplates([]);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (isSmsModalOpen) {
//       fetchSmsTemplates();
//     }
//   }, [isSmsModalOpen, fetchSmsTemplates]);

//   const fetchData = useCallback(
//     async (page = pageNumber) => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           toast.error("Authentication token not found");
//           return;
//         }

//         const url =
//           user.accountType === "COMPANY"
//             ? `${API_URL}/api/leads/company/${user.id}`
//             : `${API_URL}/api/leads/assigned/${user.id}`;

//         const response = await axios.get(url, {
//           params: {
//             pageNumber: page,
//             pageSize: pageSize,
//           },
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const leadsData = response.data?.leads || response.data?.content || [];
//         const total = response.data?.totalPages || 1;

//         setData(leadsData);
//         setTotalPages(total);
//         setPageNumber(page);
//       } catch (error) {
//         console.error("Error fetching data", error);
//         setData([]);
//         setTotalPages(0);
//       }
//     },
//     [user, pageSize, refreshTrigger],
//   );

//   useEffect(() => {
//     const handleLeadCreated = () => {
//       fetchData();
//     };

//     window.addEventListener("leadCreated", handleLeadCreated);

//     return () => {
//       window.removeEventListener("leadCreated", handleLeadCreated);
//     };
//   }, []);

//   const fetchUsers = useCallback(async () => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setUsers(response.data);
//     } catch (error) {
//       console.error("Error fetching users", error);
//     }
//   }, [user]);

//   const fetchLabels = useCallback(async () => {
//     const companyId = user.accountType === "COMPANY" ? user.id : user.companyId;
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/projectName/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setLabels(response.data);
//     } catch (error) {
//       console.error("Error fetching labels", error);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchData();
//       fetchUsers();
//       fetchLabels();
//     }
//   }, [user?.id, isFormUpdated, fetchData, fetchLabels, fetchUsers]);

//   const handleCheckboxChange = (leadId) => {
//     setSelectedLeads((prevSelectedLeads) =>
//       prevSelectedLeads.includes(leadId)
//         ? prevSelectedLeads.filter((id) => id !== leadId)
//         : [...prevSelectedLeads, leadId],
//     );
//   };

//   const handleAssignLeadIconClick = (leadId) => {
//     setSelectedLeads([leadId]);
//     setIsAssignModalOpen(true);
//   };

//   const handleAssignLeads = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.put(
//         `${API_URL}/api/leads/assign/${assignToUserId}/${user?.id}`,
//         selectedLeads,
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         },
//       );
//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setIsAssignModalOpen(false);
//         setSelectedLeads([]);
//         fetchData();
//       } else {
//         toast.error(response.data.message || "Failed to assign leads.");
//       }
//     } catch (error) {
//       console.error("Error assigning leads:", error);
//       toast.error(error.response?.data.message);
//     }
//   };

//   const handleEdit = (id) => {
//     const lead = data.find((lead) => lead.leadId === id);
//     if (lead) {
//       setSelectedLeadId(id);
//       setFormData(lead);
//       setIsModalOpen(true);
//     }
//   };

//   const handleDeleteConfirm = async (event) => {
//     event?.preventDefault();
//     try {
//       const response = await axios.post(
//         `${API_URL}/api/blacklist`,
//         {
//           createdByName: user?.name,
//           createdById: user?.id,
//           leadId: deleteLeadId,
//           reason: deleteReason,
//           companyId:
//             user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//         },
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         },
//       );
//       fetchData();
//       setDeleteModalOpen(false);
//       setDeleteReason("");
//       toast.success(response.data.message);
//     } catch (error) {
//       console.error("Error deleting lead", error);
//       toast.error(error.response?.data.message);
//     }
//   };

//   const handleLabelIconClick = (leadId) => {
//     setSelectedLabelLeadId([leadId]);
//     setIsLabelModalOpen(true);
//   };

//   const handleLabelSelect = async (labelId) => {
//     try {
//       const response = await axios.put(
//         `${API_URL}/api/leads/assignProjectName/${labelId}/${user?.id}`,
//         selectedLabelLeadId,
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         },
//       );
//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setIsLabelModalOpen(false);
//         fetchData();
//       } else {
//         toast.error(response.data.message || "Failed to assign label.");
//       }
//     } catch (error) {
//       console.error("Error assigning label:", error);
//       toast.error(error.response?.data.message);
//     }
//   };

//   const handleConvertToCustomerClick = (lead) => {
//     setLeadToConvert(lead);
//     setIsConvertModalOpen(true);
//   };

//   const handleConfirmConversion = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${API_URL}/api/convertedLeads`,
//         {
//           leadId: leadToConvert.leadId,
//           name: leadToConvert.name,
//           email: leadToConvert.email,
//           otherContactNo: leadToConvert.otherContactNo,
//           companyName: leadToConvert.companyName,
//           companyId:
//             user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//           phone: leadToConvert.phone,
//           convertedById: user?.id,
//           convertedByName: user?.name,
//           tag: leadToConvert.tag || "",
//         },
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         },
//       );

//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setIsConvertModalOpen(false);
//         fetchData();
//       } else {
//         toast.error(response.data.message || "Failed to convert lead.");
//       }
//     } catch (error) {
//       console.error("Error converting lead:", error);
//       toast.error(error.response?.data.message);
//     }
//   };


//   // Handles normal (non-search) listing pagination only - still page-number/skip based,
//   // since that's a different backend endpoint we haven't changed. Search-mode pagination
//   // is handled separately by goToSearchPage, which drives the cursor-based search endpoint.
//   const fetchPage = useCallback(
//     async (page) => {
//       try {
//         if (!user?.id || !user?.accountType) return;

//         const token = localStorage.getItem("token");
//         if (!token) {
//           toast.error("Authentication token not found");
//           return;
//         }

//         const url =
//           user.accountType === "COMPANY"
//             ? `${API_URL}/api/leads/company/${user.id}?pageNumber=${page}&pageSize=${pageSize}`
//             : `${API_URL}/api/leads/assigned/${user.id}?pageNumber=${page}&pageSize=${pageSize}`;

//         const response = await axios.get(url, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const leadsData = response.data?.leads || response.data || [];
//         const total = response.data?.totalPages || 1;

//         setData(leadsData);
//         setTotalPages(total);
//       } catch (error) {
//         console.error("Error fetching page data:", error);
//         toast.error(error.response?.data.message);
//         setData([]);
//       }
//     },
//     [user?.id, user?.accountType, pageSize],
//   );

//   useEffect(() => {
//     if (!isSearchMode) {
//       fetchPage(pageNumber);
//     }
//   }, [pageNumber, fetchPage, isSearchMode]);

//   const handleReminderFormSubmit = async (formData) => {
//     try {
//       const response = await axios.post(`${API_URL}/api/reminders`, formData, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       toast.success(response.data.message);
//     } catch (error) {
//       console.error("Failed to submit reminder form:", error);
//     }
//   };

//   const handleTaskSubmit = async (formData) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.post(`${API_URL}/api/tasks`, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.data.status === "Successful") {
//         toast.success(response.data.message);
//         setIsTaskModalOpen(false);
//         fetchData();
//       } else {
//         throw new Error(response.data.message || "Failed to create task");
//       }
//     } catch (error) {
//       console.error("Error creating task:", error);
//       toast.error(error.response?.data.message);
//     }
//   };

//   const handleFollowUpSubmit = async () => {
//     try {
//       const followUpPayload = {
//         ...followUpData,
//         createdById: user?.id,
//         createdByName: user?.name,
//         companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//       };

//       const token = localStorage.getItem("token");
//       const response = await fetch(
//         `${API_URL}/api/leads/${selectedLeadId}/followups`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(followUpPayload),
//         },
//       );

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(result.message);
//       }

//       setFollowUpModalOpen(false);
//       setFollowUpData({
//         notes: "",
//         nextFollowUpDate: "",
//         nextFollowUpTime: "",
//         followedById: "",
//         followedByName: "",
//         createdById: user?.id,
//         createdByName: user?.name,
//         companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//       });

//       toast.success(result.message);
//       fetchData();
//     } catch (error) {
//       console.error("Error submitting follow-up:", error);
//       toast.error(error.message || error.response?.data?.message);
//     }
//   };

//   const fetchFollowUpHistory = async (leadId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${API_URL}/api/leads/${leadId}/followups`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       setFollowUpHistory(response.data || []);
//       setShowFollowUpHistoryModal(true);
//     } catch (error) {
//       console.error("Error fetching follow-up history:", error);
//       toast.error("Failed to fetch follow-up history");
//     }
//   };

//   const getLatestFollowUpDate = (followUps) => {
//     if (!followUps || followUps.length === 0) return null;

//     const sortedFollowUps = [...followUps].sort(
//       (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
//     );

//     return sortedFollowUps[0];
//   };

//   const formatFollowUpDateTime = (date, time) => {
//     if (!date) return "";

//     const dateObj = new Date(`${date}T${time || "00:00:00"}`);

//     const day = String(dateObj.getDate()).padStart(2, "0");
//     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     const year = dateObj.getFullYear();

//     const formattedDate = `${day}-${month}-${year}`;

//     const formattedTime = time ? time.substring(0, 5) : "";

//     return formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
//   };

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;

//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [user]);

//   useEffect(() => {
//     async function fetchLoginUserMobile() {
//       if (!user?.id || !user?.accountType) return;

//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await axios.get(url, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });

//         const users = response.data;

//         const currentUser = users.find((u) => u.id === user.id);
//         if (currentUser) {
//           setLoginMobileNo(currentUser.mobileNumber);
//         }
//       } catch (error) {
//         console.error("Error fetching users for mobile number:", error);
//       }
//     }

//     fetchLoginUserMobile();
//   }, [user]);

//   const fetchApiKey = async () => {
//     const token = localStorage.getItem("token");
//     const companyId =
//       user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//     const res = await axios.get(`${API_URL}/api/call-api-key/${companyId}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return res.data?.callApiKey;
//   };

//   const handlePhoneCall = async (lead) => {
//     if (!lead?.leadId) return;

//     try {
//       const token = localStorage.getItem("token");
//       let loginEmail = user?.email || "";
//       let loginAccountType = user?.accountType || "";

//       if (token) {
//         try {
//           const payload = jwtDecode(token);
//           loginEmail = payload.email || payload.sub || "";
//           loginAccountType = payload.accountType || "";
//         } catch (err) {
//           console.error("Token decoding error:", err);
//         }
//       }

//       await axios.post(
//         `${API_URL}/api/leads/${lead.leadId}/click-to-call`,
//         {
//           loginAccountType: loginAccountType,
//           loginEmail: loginEmail,
//           loginMobileNo: loginMobileNo,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       toast.success("Call initiated successfully!");
//     } catch (error) {
//       console.error("❌ Click to call Error:", error);
//       toast.error("Failed to initiate call. Please try again.");
//     }
//   };

//   const handleDownloadReport = async () => {
//     try {
//       const params = {
//         ...Object.fromEntries(
//           Object.entries(downloadParams).filter(([_, value]) => value !== ""),
//         ),
//       };

//       const token = localStorage.getItem("token");
//       const response = await axios.post(
//         `${API_URL}/api/leads/download-report`,
//         params,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           responseType: "blob",
//         },
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "leads-report.xlsx");
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       toast.success("Report downloaded successfully");
//       setIsDownloadModalOpen(false);
//     } catch (error) {
//       console.error("Error downloading report:", error);
//       toast.error(error.response?.data?.message || "Failed to download report");
//     }
//   };

//   const [showSearchFields, setShowSearchFields] = useState(
//     () => window.innerWidth >= 768,
//   );

//   useEffect(() => {
//     const handleResize = () => {
//       setShowSearchFields(window.innerWidth >= 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);


//   const [canEdit, setCanEdit] = useState(false);
//   const [canDownload, setCanDownload] = useState(false);

//   useEffect(() => {
//     checkEditPermission();
//   }, []);

//   const checkEditPermission = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         setCanEdit(false);
//         setCanDownload(false);
//         return;
//       }

//       const decoded = jwtDecode(token);
//       const accountType = decoded.accountType;
//       const userId = decoded.id;

//       console.log("User Account Type:", accountType);
//       console.log("User ID:", userId);

//       const alwaysAllowed = [
//         "SUPER_SUPER_ADMIN",
//         "COMPANY",
//         "SUPER_ADMIN",
//         "RESELLER",
//       ];

//       if (alwaysAllowed.includes(accountType)) {
//         console.log("Always allowed user type");
//         setCanEdit(true);
//         setCanDownload(true);
//         return;
//       }

//       const hierarchicalTypes = [
//         "VICE_PRESIDENT",
//         "MANAGER",
//         "TEAM_LEAD",
//         "HR",
//         "EXECUTIVE",
//       ];

//       if (hierarchicalTypes.includes(accountType)) {
//         console.log("Checking API for hierarchical user...");

//         try {
//           const response = await fetch(
//             `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${userId}&accountType=${accountType}`,
//             {
//               method: "GET",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//             },
//           );

//           if (response.ok) {
//             const data = await response.json();
//             console.log("API Response:", data);

//             if (Array.isArray(data) && data.length > 0) {
//               const userData = data[0];
//               if (
//                 userData.permission &&
//                 userData.permission.some((p) => p.leadEdit === true)
//               ) {
//                 console.log("Found leadEdit: true");
//                 setCanEdit(true);
//                 setCanDownload(true);
//                 return;
//               }
//             }
//           }
//         } catch (apiError) {
//           console.error("API Error:", apiError);
//         }
//       }

//       setCanEdit(false);
//       setCanDownload(false);
//     } catch (error) {
//       console.error("Permission check failed:", error);
//       setCanEdit(false);
//       setCanDownload(false);
//     }
//   };

//   const ConvertModal = () => {
//     if (!isConvertModalOpen) return null;
//     return (
//       <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//         <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
//           <h2 className="text-xl font-bold mb-4">Convert to Customer</h2>
//           <p className="mb-4">
//             Are you sure you want to convert this lead to a customer?
//           </p>
//           <div className="flex justify-end space-x-2 mt-4">
//             <button
//               className="bg-gray-300 px-4 py-2 rounded"
//               onClick={() => setIsConvertModalOpen(false)}
//             >
//               Cancel
//             </button>
//             <button
//               className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
//               onClick={handleConfirmConversion}
//             >
//               Confirm
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="cfg-font">
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>

//       <div className="flex items-center justify-between mb-1">
//         <h2 className="text-lg font-bold cfg-heading dark:text-white">
//           Table View
//         </h2>
//         <div className="flex items-center gap-1">
//           <Select
//             defaultValue="100"
//             style={{ width: 70 }}
//             onChange={(value) => setPageSize(Number(value))}
//             options={[
//               { value: "5", label: "5" },
//               { value: "10", label: "10" },
//               { value: "20", label: "20" },
//               { value: "50", label: "50" },
//               { value: "100", label: "100" },
//             ]}
//           />

//           <button
//             type="button"
//             onClick={() => setShowSearchFields(!showSearchFields)}
//             className="flex items-center gap-1 px-1.5 py-0.5 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] text-xs"
//           >
//             <FaSearch className="text-xs" />
//             {showSearchFields ? "Hide Search" : "Search"}
//           </button>

//           <FaUserPlus
//             title="Assign selected leads"
//             className={`cursor-pointer text-[#673AB7] text-lg ${selectedLeads.length === 0
//               ? "opacity-50 cursor-not-allowed"
//               : "hover:text-[#5E35A6]"
//               }`}
//             onClick={() => {
//               if (selectedLeads.length > 0) {
//                 handleAssignMultipleLeads(selectedLeads);
//               }
//             }}
//           />

//           {canDownload && (
//             <FaFileDownload
//               title="Download Report"
//               className="cursor-pointer text-green-600 text-lg hover:text-green-800"
//               onClick={() => setIsDownloadModalOpen(true)}
//             />
//           )}
//         </div>
//       </div>

//       {showSearchFields && (
//         <form
//           onSubmit={handleSearchSubmit}
//           className="p-1 bg-white dark:bg-gray-800 shadow rounded-md mb-3 text-xs"
//         >
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 items-end ">
//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 User
//               </label>
//               <Select
//                 showSearch
//                 allowClear
//                 placeholder="Select user"
//                 name="targetUserId"
//                 value={searchParams.targetUserId || undefined}
//                 onChange={(value) =>
//                   setSearchParams((prev) => ({ ...prev, targetUserId: value }))
//                 }
//                 options={users.map((user) => ({
//                   value: user.id,
//                   label: `${user.fname} ${user.lname}`,
//                 }))}
//                 className="w-full"
//                 filterOption={(input, option) =>
//                   option.label.toLowerCase().includes(input.toLowerCase())
//                 }
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Project Name
//               </label>
//               <Select
//                 showSearch
//                 allowClear
//                 placeholder="Select label"
//                 name="projectName"
//                 value={searchParams.projectName || undefined}
//                 onChange={(value) =>
//                   setSearchParams((prev) => ({ ...prev, projectName: value }))
//                 }
//                 options={labels.map((label) => ({
//                   value: label.name,
//                   label: (
//                     <div className="flex items-center">
//                       <div
//                         className="w-2.5 h-2.5 rounded-full mr-1"
//                         style={{ backgroundColor: label.color }}
//                       />
//                       {label.name}
//                     </div>
//                   ),
//                 }))}
//                 className="w-full"
//                 filterOption={(input, option) =>
//                   option.value.toLowerCase().includes(input.toLowerCase())
//                 }
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Source Name
//               </label>
//               <Select
//                 showSearch
//                 allowClear
//                 placeholder="Select Source"
//                 name="sourceName"
//                 value={searchParams.sourceName || undefined}
//                 onChange={(value) =>
//                   setSearchParams((prev) => ({ ...prev, sourceName: value }))
//                 }
//                 options={sourceOptions
//                   .filter((source) => source.active === true)
//                   .map((source) => ({
//                     value: source.name,
//                     label: (
//                       <div className="flex items-center">
//                         <div className="w-2.5 h-2.5 rounded-full mr-1" />
//                         {source.name}
//                       </div>
//                     ),
//                   }))}
//                 className="w-full"
//                 filterOption={(input, option) =>
//                   option.value.toLowerCase().includes(input.toLowerCase())
//                 }
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Status Name
//               </label>
//               <Select
//                 showSearch
//                 allowClear
//                 placeholder="Select Status"
//                 name="statusName"
//                 value={searchParams.statusName || undefined}
//                 onChange={(value) =>
//                   setSearchParams((prev) => ({ ...prev, statusName: value }))
//                 }
//                 options={statuses
//                   .filter((status) => status.active === true)
//                   .map((status) => ({
//                     value: status.name,
//                     label: (
//                       <div className="flex items-center">
//                         <div
//                           className="w-2.5 h-2.5 rounded-full mr-1"
//                           style={{ backgroundColor: status.color }}
//                         />
//                         {status.name}
//                       </div>
//                     ),
//                   }))}
//                 className="w-full"
//                 filterOption={(input, option) =>
//                   option.value.toLowerCase().includes(input.toLowerCase())
//                 }
//               />
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 State
//               </label>
//               <select
//                 name="state"
//                 value={searchParams.state}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded disabled:bg-gray-200 dark:disabled:bg-gray-600"
//               >
//                 <option value="">Select State</option>
//                 {stateList.map((state, index) => (
//                   <option key={index} value={state}>
//                     {state}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 City
//               </label>

//               <input
//                 list="city-list"
//                 name="city"
//                 value={searchParams.city}
//                 onChange={handleChange}
//                 placeholder={
//                   !searchParams.state
//                     ? "Select state first"
//                     : "Type or select city"
//                 }
//                 className="w-full p-2 border rounded disabled:bg-gray-200 dark:disabled:bg-gray-600"
//               />

//               <datalist id="city-list">
//                 {cityList
//                   .slice()
//                   .sort()
//                   .map((city) => (
//                     <option key={city} value={city} />
//                   ))}
//               </datalist>
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 From Date
//               </label>

//               <input
//                 type="date"
//                 name="startDate"
//                 value={searchParams.startDate}
//                 onChange={handleChange}
//                 className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 To Date
//               </label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={searchParams.endDate}
//                 onChange={handleChange}
//                 className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Created At
//               </label>
//               <input
//                 type="date"
//                 name="createdAt"
//                 value={searchParams.createdAt}
//                 onChange={handleChange}
//                 className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
//               />
//             </div>

//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Next Follow Up
//               </label>
//               <input
//                 type="date"
//                 name="nextFollowUpDate"
//                 value={searchParams.nextFollowUpDate}
//                 onChange={handleChange}
//                 className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
//               />
//             </div>
//             <div>
//               <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
//                 Phone
//               </label>
//               <input
//                 type="tel"
//                 inputMode="numeric"
//                 name="phone"
//                 placeholder="Search by phone number"
//                 value={searchParams.phone}
//                 onChange={handleChange}
//                 className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
//               />
//             </div>
//           </div>

//           <div className="flex justify-end space-x-1 mt-1">
//             <button
//               type="submit"
//               className={`px-1.5 py-0.5 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center text-xs ${isSearching ? "opacity-50 cursor-not-allowed" : ""
//                 }`}
//               disabled={isSearching}
//             >
//               {isSearching ? (
//                 <>
//                   <svg
//                     className="animate-spin -ml-1 mr-1 h-3 w-3 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Searching...
//                 </>
//               ) : (
//                 <>
//                   <FaSearch className="mr-1 text-xs" />
//                   Search
//                 </>
//               )}
//             </button>
//             <button
//               type="button"
//               onClick={handleClearSearch}
//               className="px-1.5 py-0.5 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 flex items-center text-xs"
//             >
//               <FaTimes className="mr-1 text-xs" />
//               Clear
//             </button>
//           </div>
//         </form>
//       )}
//       <div className={`${activeActionMenu ? "!overflow-visible" : "overflow-x-auto"} [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}>
//         <table className="w-full min-w-max border-collapse border border-gray-300 text-xs">
//           <thead>
//             <tr className="bg-gray-100 dark:bg-gray-900 dark:text-white text-xs">
//               <th className="p-1">
//                 <input
//                   type="checkbox"
//                   onChange={(e) =>
//                     setSelectedLeads(
//                       e.target.checked ? data.map((c) => c.leadId) : [],
//                     )
//                   }
//                   className="scale-75"
//                 />
//               </th>
//               <th className="p-1 ">S No.</th>
//               <th className="p-1  text-left ">Name</th>
//               <th className="p-1 ">Mobile</th>
//               <th className="p-1 ">Source Name</th>
//               <th className="p-1 ">Assign To</th>
//               <th className="p-1 ">Assign By</th>
//               <th className="p-1 "> Date</th>
//               <th className="p-1 ">Last Follow Up</th>
//               <th className="p-1">Next Follow Up </th>
//               <th className="p-1 ">Status</th>
//               <th className="p-1 ">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data?.map((item, index) => (
//               <React.Fragment key={item.leadId}>
//                 <tr className="border-t text-xs">
//                   <td className="p-1">
//                     <input
//                       type="checkbox"
//                       checked={selectedLeads.includes(item.leadId)}
//                       onChange={() => handleCheckboxChange(item.leadId)}
//                       className="scale-75"
//                     />
//                   </td>
//                   <td className="p-1">
//                     {(isSearchMode ? searchPageIndex : pageNumber) * pageSize +
//                       index +
//                       1}{" "}
//                     <button
//                       onClick={() => toggleRowExpand(item.leadId)}
//                       className="text-[#673AB7] font-bold text-xs"
//                     >
//                       {expandedRows.includes(item.leadId) ? "▼" : "▶"}
//                     </button>{" "}
//                   </td>
//                   <td className="p-1 max-w-[150px] truncate">
//                     <span title={item.name} className="cursor-pointer">
//                       {item.name.split(" ").slice(0, 2).join(" ")}
//                     </span>
//                   </td>

//                   <td className="p-1 flex items-center gap-2">
//                     {item.phone && (
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handlePhoneCall(item);
//                         }}
//                         className="relative flex items-center justify-center w-6 h-6 rounded-full bg-green-500 text-white hover:bg-green-600"
//                         title="Click to Call"
//                       >
//                         <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
//                         <FaPhone className="relative z-10 text-xs -scale-x-100 transform" />                      </button>
//                     )}

//                     {item.phone && (
//                       <a
//                         href={`tel:${item.phone}`}
//                         onClick={(e) => e.stopPropagation()}
//                         className="text-[#673AB7] hover:underline truncate max-w-[120px]"
//                         title={item.phone}
//                       >
//                         {item.phone}
//                       </a>
//                     )}
//                   </td>

//                   <td className="p-1">
//                     <span
//                       className="inline-block px-2 py-1 rounded-full text-white"
//                       style={{
//                         backgroundColor: item.projectNameColor || "#6b7280",
//                       }}
//                     >
//                       {item?.sourceName || "source"}
//                     </span>
//                   </td>
//                   <td className="p-1">{item.assignedToName}</td>
//                   <td className="p-1">{item.createdByName}</td>

//                   <td className="p-1">
//                     {new Date(item.leadDate)
//                       .toLocaleDateString("en-GB")
//                       .replace(/\//g, "-")}
//                   </td>

//                   <td className="p-1 text-center">
//                     {(() => {
//                       const latestFollowUp = getLatestFollowUpDate(
//                         item.followUps,
//                       );

//                       if (!latestFollowUp || !latestFollowUp.lastFollowUpDate) {
//                         return (
//                           <span className="text-gray-400 text-xs">--</span>
//                         );
//                       }

//                       return (
//                         <span className="text-xs whitespace-nowrap">
//                           {new Date(latestFollowUp.lastFollowUpDate)
//                             .toLocaleString("en-GB", {
//                               day: "2-digit",
//                               month: "2-digit",
//                               year: "numeric", // yyyy
//                             })
//                             .replace(/\//g, "-")}
//                         </span>
//                       );
//                     })()}
//                   </td>

//                   <td className="p-1 text-center">
//                     {(() => {
//                       const latestFollowUp = getLatestFollowUpDate(
//                         item.followUps,
//                       );

//                       const formatDateTime = (dateString, timeString) => {
//                         if (!dateString) return "----";

//                         const dateOnly = new Date(dateString);
//                         if (isNaN(dateOnly.getTime())) return "----";

//                         const day = String(dateOnly.getDate()).padStart(2, "0");
//                         const month = String(dateOnly.getMonth() + 1).padStart(
//                           2,
//                           "0",
//                         ); // DD-MM-YYYY
//                         const year = dateOnly.getFullYear();

//                         if (timeString) {
//                           const fullDateTime = new Date(
//                             `${dateString}T${timeString}`,
//                           );
//                           if (!isNaN(fullDateTime.getTime())) {
//                             const hours = String(
//                               fullDateTime.getHours(),
//                             ).padStart(2, "0");
//                             const minutes = String(
//                               fullDateTime.getMinutes(),
//                             ).padStart(2, "0");
//                             return `${day}-${month}-${year} ${hours}:${minutes}`;
//                           }
//                         }

//                         return `${day}-${month}-${year}`;
//                       };

//                       if (latestFollowUp && latestFollowUp.nextFollowUpDate) {
//                         const formattedDate = formatDateTime(
//                           latestFollowUp.nextFollowUpDate,
//                           latestFollowUp.nextFollowUpTime,
//                         );

//                         if (formattedDate === "----") {
//                           return <span className="text-gray-500">----</span>;
//                         }

//                         return (
//                           <button
//                             onClick={() => fetchFollowUpHistory(item.leadId)}
//                             className="text-[#673AB7] underline hover:text-[#5E35A6] cursor-pointer text-xs whitespace-nowrap"
//                             title="Click to view follow-up history"
//                           >
//                             {formattedDate}
//                           </button>
//                         );
//                       } else {
//                         return (
//                           <span className="text-gray-400 text-xs">--</span>
//                         );
//                       }
//                     })()}
//                   </td>

//                   <td className="p-1">
//                     <select
//                       className="border p-1 rounded dark:bg-gray-900 dark:text-white"
//                       style={{ backgroundColor: item.statusColor || "#ffffff" }}
//                       value={item.statusName}
//                       onChange={(e) =>
//                         openStatusModal(item.leadId, e.target.value)
//                       }
//                     >
//                       {statuses
//                         .filter((status) => status.active === true)
//                         .map((status) => (
//                           <option
//                             key={status.name}
//                             value={status.name}
//                             style={{
//                               backgroundColor: status.color,
//                               color: "black",
//                             }}
//                           >
//                             {status.name}
//                           </option>
//                         ))}
//                     </select>
//                   </td>
//                   <td className="p-1">
//                     <div className="flex items-center justify-center gap-1 relative">
//                       {canEdit && (
//                         <button
//                           type="button"
//                           title="Edit Lead"
//                           onClick={() => handleEdit(item.leadId)}
//                           className="w-7 h-7 flex items-center justify-center rounded-md text-[#8B5CF6] hover:bg-[#F3E8FF] dark:hover:bg-blue-900/30 transition-colors"
//                         >
//                           <FaEdit className="text-sm" />
//                         </button>
//                       )}

//                       <button
//                         type="button"
//                         title="Lead Follow Up"
//                         onClick={() => {
//                           setSelectedLeadName(item.name);
//                           setSelectedLeadPhone(item.phone);
//                           setSelectedLeadId(item.leadId);
//                           setFollowUpModalOpen(true);
//                         }}
//                         className="w-7 h-7 flex items-center justify-center rounded-md text-teal-600 hover:bg-teal-50 dark:hover:bg-teal-900/30 transition-colors"
//                       >
//                         {/* Replaced <FaRedo className="text-sm" /> with the new icon */}
//                         <FaUserClock className="text-sm" />
//                       </button>

//                       <button
//                         type="button"
//                         title="More Actions"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setActiveActionMenu(
//                             activeActionMenu === item.leadId ? null : item.leadId,
//                           );
//                         }}
//                         className={`w-7 h-7 flex items-center justify-center rounded-md transition-colors ${activeActionMenu === item.leadId
//                           ? "bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-white"
//                           : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
//                           }`}
//                       >
//                         <FaEllipsisV className="text-sm" />
//                       </button>

//                       {activeActionMenu === item.leadId && (
//                         <div
//                           ref={actionMenuRef}
//                           className="absolute right-0 top-8 z-50 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl py-1.5 text-left"
//                         >
//                           <div className="px-3 pt-1 pb-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
//                             Communicate
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleEmailClick(item);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaEnvelope className="text-red-500 text-sm shrink-0" />
//                             Send Email
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleSmsClick(item);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaSms className="text-green-600 text-sm shrink-0" />
//                             Send SMS
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleWhatsappClick(item);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaWhatsapp className="text-green-500 text-sm shrink-0" />
//                             WhatsApp Message
//                           </button>

//                           {/* ── NEW: Call History (3rd position) - same popup/API as Card view ── */}
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleOpenCallHistory(item);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <PhoneCall className="w-3.5 h-3.5 text-purple-500 shrink-0" />
//                             Call History
//                           </button>

//                           <div className="border-t border-gray-100 dark:border-gray-700 my-1" />

//                           <div className="px-3 pt-1 pb-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
//                             Manage Lead
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleLabelIconClick(item.leadId);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaTag className="text-green-500 text-sm shrink-0" />
//                             Add Project
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               handleAssignLeadIconClick(item.leadId);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaUserPlus className="text-purple-500 text-sm shrink-0" />
//                             Assign Lead
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               setSelectedLeadId(item.leadId);
//                               setIsReminderModalOpen(true);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaClock className="text-yellow-500 text-sm shrink-0" />
//                             Set Reminder
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               setSelectedLeadId(item.leadId);
//                               setIsTaskModalOpen(true);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaTasks className="text-blue-700 text-sm shrink-0" />
//                             Create Task
//                           </button>
//                           {!item.isConvertedLead && (
//                             <button
//                               type="button"
//                               onClick={() => {
//                                 handleConvertToCustomerClick(item);
//                                 setActiveActionMenu(null);
//                               }}
//                               className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                             >
//                               <FaUserCheck className="text-orange-500 text-sm shrink-0" />
//                               Convert to Customer
//                             </button>
//                           )}

//                           <div className="border-t border-gray-100 dark:border-gray-700 my-1" />

//                           <button
//                             type="button"
//                             onClick={() => {
//                               setSelectedLeadName(item.name);
//                               setSelectedLeadPhone(item.phone);
//                               fetchLeadHistory(item);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
//                           >
//                             <FaHistory className="text-gray-500 text-sm shrink-0" />
//                             Lead History
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => {
//                               setDeleteLeadId(item.leadId);
//                               setDeleteModalOpen(true);
//                               setActiveActionMenu(null);
//                             }}
//                             className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
//                           >
//                             <FaBan className="text-red-500 text-sm shrink-0" />
//                             Block Lead
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//                 {expandedRows.includes(item.leadId) && (
//                   <tr className="bg-gray-50 dark:bg-gray-800">
//                     <td colSpan="12" className="p-4">
//                       <div className="grid grid-cols-1 md:w-[85vw] w-[70vw]  md:grid-cols-3 lg:grid-cols-3 gap-6">
//                         {/* Basic Info Card */}
//                         <div className="bg-white  dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
//                           <h3 className="md:text-lg text-base font-semibold text-blue-600 mb-2">
//                             Basic Info
//                           </h3>
//                           <p>
//                             <span className="font-medium">Name:</span>{" "}
//                             {item.name}
//                           </p>
//                           <p>
//                             <span className="font-medium">Email:</span>{" "}
//                             {item.email}
//                           </p>
//                           <p>
//                             <span className="font-medium">Phone:</span>{" "}
//                             <td className="p-1 flex items-center gap-2">
//                               {/* Phone Call Icon */}
//                               {item.phone && (
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     handlePhoneCall(item);
//                                   }}
//                                   className="relative flex items-center justify-center w-5 h-5 rounded-full bg-green-500 text-white hover:bg-green-600"
//                                   title="Click to Call"
//                                 >
//                                   {/* Ping animation */}
//                                   <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
//                                   <FaPhone className="relative z-10 text-[10px] -scale-x-100 transform" />                                </button>
//                               )}

//                               {/* Phone Number */}
//                               {item.phone && (
//                                 <a
//                                   href={`tel:${item.phone}`}
//                                   onClick={(e) => e.stopPropagation()}
//                                   className="text-[#673AB7] hover:underline truncate max-w-[120px]"
//                                   title={item.phone}
//                                 >
//                                   {item.phone}
//                                 </a>
//                               )}
//                             </td>
//                           </p>
//                           <p>
//                             <span className="font-medium">Company:</span>{" "}
//                             {item.companyName || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                         </div>

//                         {/* Lead Details Card */}
//                         <div className="bg-white dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
//                           <h3 className="md:text-lg text-base font-semibold text-green-600 mb-2">
//                             Lead Details
//                           </h3>
//                           <p>
//                             <span className="font-medium">Status: </span>{" "}
//                             {item.statusName}
//                           </p>
//                           <p>
//                             <span className="font-medium">Source: </span>{" "}
//                             {item.sourceName || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                           <p>
//                             <span className="font-medium">Assigned To:</span>{" "}
//                             {item.assignedToName || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>

//                           <p>
//                             <span className="font-medium">Created:</span>{" "}
//                             {(() => {
//                               const d = new Date(item.createdAt);
//                               const day = String(d.getDate()).padStart(2, "0");
//                               const month = String(d.getMonth() + 1).padStart(
//                                 2,
//                                 "0",
//                               );
//                               const year = d.getFullYear();

//                               let hours = d.getHours();
//                               const minutes = String(d.getMinutes()).padStart(
//                                 2,
//                                 "0",
//                               );
//                               const ampm = hours >= 12 ? "PM" : "AM";
//                               hours = hours % 12;
//                               hours = hours ? hours : 12; // the hour '0' should be '12'
//                               const strHours = String(hours).padStart(2, "0");

//                               return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//                             })()}
//                           </p>
//                         </div>

//                         {/* Additional Info Card */}
//                         <div className="bg-white dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
//                           <h3 className=" md:text-lg text-base font-semibold text-purple-600 mb-2">
//                             Additional Info
//                           </h3>
//                           <p>
//                             <span className="font-medium">Address:</span>{" "}
//                             {item.address || (
//                               <span className="text-gray-400">_blank</span>
//                             )}
//                           </p>
//                           {/* Add City and State here */}
//                           <p>
//                             <span className="font-medium">City:</span>{" "}
//                             {item.city || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                           <p>
//                             <span className="font-medium">State:</span>{" "}
//                             {item.state || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                           {/* End of added fields */}
//                           <p>
//                             <span className="font-medium">
//                               Other Contact No.:
//                             </span>{" "}
//                             {item.otherContactNo || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                           <p>
//                             <span className="font-medium">Blacklisted:</span>{" "}
//                             {item.isBlackListed ? "Yes" : "No"}
//                           </p>
//                           <p>
//                             <span className="font-medium">Created By:</span>{" "}
//                             {item.createdByName || (
//                               <span className="text-gray-400">_</span>
//                             )}
//                           </p>
//                         </div>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </React.Fragment>
//             ))}
//             {data?.length === 0 && (
//               <tr>
//                 <td colSpan="9" className="text-center  p-4">
//                   {isSearching ? "Searching..." : "Loading..."}
//                 </td>
//               </tr>
//             )}


//           </tbody>
//         </table>
//       </div>
//       {/* Pagination - normal (non-search) listing. Still page-number based; unrelated
//           backend endpoint, unchanged. */}
//       {!isSearchMode && totalPages > 0 && (
//         <div className="mt-4 flex flex-wrap justify-center items-center gap-2 sm:gap-3">
//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               setPageNumber(0);
//               fetchPage(0);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={pageNumber === 0}
//           >
//             First
//           </button>

//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               const newPage = Math.max(pageNumber - 1, 0);
//               setPageNumber(newPage);
//               fetchPage(newPage);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={pageNumber === 0}
//           >
//             Prev
//           </button>

//           <span className="text-xs sm:text-sm font-medium whitespace-nowrap">
//             Page {pageNumber + 1} of {totalPages}
//           </span>

//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               const newPage = Math.min(pageNumber + 1, totalPages - 1);
//               setPageNumber(newPage);
//               fetchPage(newPage);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={pageNumber >= totalPages - 1}
//           >
//             Next
//           </button>

//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               setPageNumber(totalPages - 1);
//               fetchPage(totalPages - 1);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={pageNumber >= totalPages - 1}
//           >
//             Last
//           </button>
//         </div>
//       )}

//       {/* Pagination - search results. Cursor-based: no total page count is available (or
//           computed) anymore, so there's no "of N" text and no "Last" button - only
//           Prev/Next/First, driven by goToSearchPage. */}
//       {isSearchMode && (data?.length > 0 || searchPageIndex > 0) && (
//         <div className="mt-4 flex flex-wrap justify-center items-center gap-2 sm:gap-3">
//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               goToSearchPage(0);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={searchPageIndex === 0}
//           >
//             First
//           </button>

//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               goToSearchPage(searchPageIndex - 1);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={searchPageIndex === 0}
//           >
//             Prev
//           </button>

//           <span className="text-xs sm:text-sm font-medium whitespace-nowrap">
//             Page {searchPageIndex + 1}
//           </span>

//           <button
//             onClick={(e) => {
//               e.preventDefault();
//               goToSearchPage(searchPageIndex + 1);
//             }}
//             className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
//             disabled={!searchHasMore}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       <DownloadReportModal
//         isDownloadModalOpen={isDownloadModalOpen}
//         setIsDownloadModalOpen={setIsDownloadModalOpen}
//         downloadParams={downloadParams}
//         setDownloadParams={setDownloadParams}
//         users={users}
//         labels={labels}
//         statuses={statuses}
//         sourceOptions={sourceOptions}
//         handleDownloadReport={handleDownloadReport}
//       />

//       {/* Assign Leads Modal */}
//       {isAssignModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-bold mb-4">Assign Leads</h2>
//             <select
//               className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
//               onChange={(e) => setAssignToUserId(e.target.value)}
//             >
//               <option value="">Select User</option>
//               {users.map((user) => (
//                 <option key={user.id} value={user.id}>
//                   {user.fname} {user.lname}
//                 </option>
//               ))}
//             </select>
//             <div className="flex justify-end space-x-2 mt-4">
//               <button
//                 className="bg-gray-300 px-4 py-2 rounded"
//                 onClick={() => setIsAssignModalOpen(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
//                 onClick={handleAssignLeads}
//               >
//                 Assign
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Lead Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//           <div className="relative w-full max-w-lg md:max-w-3xl lg:max-w-4xl bg-white dark:bg-gray-800 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto">
//             {/* Sticky Header with Close Button */}
//             <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 flex justify-between items-center border-b border-gray-200 dark:border-gray-700 px-4 py-3">
//               <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
//                 Update Lead
//               </h2>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="text-red-500 text-lg md:text-xl hover:text-red-600"
//                 aria-label="Close Modal"
//               >
//                 ✖
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="px-4 py-4">
//               {/* <LeadForm
//                 leadId={selectedLeadId}
//                 updatedFormData={formData}
//                 setIsFormUpdated={setIsFormUpdated}
//                 closeModal={() => setIsModalOpen(false)}
//               /> */}

//               <LeadForm
//                 leadId={selectedLeadId}
//                 updatedFormData={formData}
//                 setIsFormUpdated={setIsFormUpdated}
//                 closeModal={(updatedLead) => {
//                   setIsModalOpen(false);

//                   // ✅ update only edited lead in table
//                   if (updatedLead) {
//                     updateLeadInTable(selectedLeadId, updatedLead);
//                   }
//                 }}
//               />



//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Lead Modal */}
//       {deleteModalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
//             <h2 className="text-xl font-bold mb-4">Block Lead</h2>
//             <p className="mb-2">Please enter a reason for block:</p>
//             <input
//               type="text"
//               className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
//               placeholder="Enter reason..."
//               value={deleteReason}
//               onChange={(e) => setDeleteReason(e.target.value)}
//             />
//             <div className="flex justify-end space-x-2 mt-4">
//               <button
//                 className="bg-gray-300 px-4 py-2 rounded"
//                 onClick={() => setDeleteModalOpen(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="bg-red-500 text-white px-4 py-2 rounded"
//                 onClick={handleDeleteConfirm}
//                 disabled={!deleteReason.trim()}
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Label Modal */}
//       {isLabelModalOpen && (
//         <LabelModal
//           isOpen={isLabelModalOpen}
//           onClose={() => setIsLabelModalOpen(false)}
//           labels={labels}
//           selectedProjectId={selectedProjectId}
//           setSelectedProjectId={setSelectedProjectId}
//           onLabelSelect={handleLabelSelect}
//         />
//       )}

//       {/* Convert to Customer Modal */}
//       <ConvertModal />
//       <EmailModal
//         isEmailModalOpen={isEmailModalOpen}
//         templates={templates}
//         selectedLeadForEmail={selectedLeadForEmail}
//         setSelectedLeadForEmail={setSelectedLeadForEmail}
//         selectedTemplate={selectedTemplate}
//         setSelectedTemplate={setSelectedTemplate}
//         templateVariables={templateVariables}
//         setTemplateVariables={setTemplateVariables}
//         selectedTemplateData={selectedTemplateData}
//         setSelectedTemplateData={setSelectedTemplateData}
//         isSending={isSending}
//         setIsSending={setIsSending}
//         user={user}
//         fetchData={fetchData}
//         onClose={() => {
//           setIsEmailModalOpen(false);
//           setSelectedTemplate("");
//           setSelectedLeadForEmail("");
//           setTemplateVariables({});
//           setSelectedTemplateData(null);
//         }}
//       />

//       {/* ── NEW: Call History popup - same /call-recordings API as Card view ── */}
//       <CallHistoryModal
//         open={showCallHistoryModal}
//         lead={callHistoryLead}
//         data={callHistoryData}
//         loading={callHistoryLoading}
//         onClose={() => setShowCallHistoryModal(false)}
//       />

//       {showHistoryModal && (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-3 sm:px-4 py-3">
//           <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-5 sm:p-6 relative dark:bg-gray-700 dark:text-white">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center pb-3 dark:bg-gray-700 dark:text-white">
//               <h2 className="text-lg sm:text-xl font-semibold cfg-heading dark:text-white">
//                 Lead History
//               </h2>

//               <button
//                 onClick={() => setShowHistoryModal(false)}
//                 className="text-gray-600 hover:text-red-500 text-xl font-bold transition"
//                 aria-label="Close"
//               >
//                 &times;
//               </button>
//             </div>
//             <div className=" mb-1 ">
//               <div className="flex items-center text-sm gap-1">
//                 <span className="font-medium   ">Lead Name :</span>
//                 <span className="text-[#673AB7]   capitalize   dark:text-[#8B5CF6]">
//                   {selectedLeadName}
//                 </span>
//               </div>
//               <div className="flex items-center text-sm  gap-1">
//                 <span className="font-medium">Phone:</span>
//                 <span className="text-green-600 dark:text-green-300">
//                   {selectedLeadPhone}
//                 </span>
//               </div>
//             </div>
//             {/* Modal Content */}
//             <div className="mt-4 max-h-[65vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:bg-gray-700 dark:text-white">
//               {historyData && historyData.length > 0 ? (
//                 [...historyData]
//                   .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//                   .map((item, index) => (
//                     <div
//                       key={item.historyId || index}
//                       className="border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50 hover:shadow-sm transition dark:bg-gray-700 dark:text-white"
//                     >
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700 mb-2 dark:bg-gray-700 dark:text-white">
//                         <div>
//                           <span className="text-gray-500 dark:text-white">
//                             Changed By:
//                           </span>{" "}
//                           {item.changedByName}
//                         </div>
//                         {/* <div>
//                           <span className="text-gray-500 dark:text-white">
//                             Change Type:
//                           </span>{" "}
//                           {item.changeType}
//                         </div> */}

//                         <div className="">
//                           {/* Changed By */}
//                           <div className="flex items-center mb-3">
//                             <div className="w-8 h-8 bg-[#F3E8FF] dark:bg-blue-900 rounded-full flex items-center justify-center mr-2">
//                               <span className="text-[#673AB7] dark:text-[#8B5CF6] font-medium text-sm">
//                                 {item.changedByName?.charAt(0) || "U"}
//                               </span>
//                             </div>
//                             <div>
//                               <div className="text-sm font-medium text-gray-800 dark:text-white">
//                                 {item.changedByName || "Unknown User"}
//                               </div>
//                               <div className="text-xs text-gray-500 dark:text-gray-400">
//                                 {/* {new Date(item.createdAt).toLocaleString()} */}

//                                 {(() => {
//                                   const d = new Date(item.createdAt);
//                                   const day = String(d.getDate()).padStart(
//                                     2,
//                                     "0",
//                                   );
//                                   const month = String(
//                                     d.getMonth() + 1,
//                                   ).padStart(2, "0");
//                                   const year = d.getFullYear();

//                                   let hours = d.getHours();
//                                   const minutes = String(
//                                     d.getMinutes(),
//                                   ).padStart(2, "0");
//                                   const ampm = hours >= 12 ? "PM" : "AM";
//                                   hours = hours % 12;
//                                   hours = hours ? hours : 12; // convert 0 hour to 12
//                                   const strHours = String(hours).padStart(
//                                     2,
//                                     "0",
//                                   );

//                                   return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//                                 })()}
//                               </div>
//                             </div>
//                           </div>

//                           {/* Change Type Container */}
//                           <div className="border-l-2 border-[#8B5CF6] pl-4 ml-3">
//                             {/* Change Type Header */}
//                             <div className="mb-2">
//                               <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
//                                 {item.changeType.includes("UPDATED_FIELDS")
//                                   ? "Fields Updated"
//                                   : item.changeType}
//                               </span>
//                             </div>

//                             {/* Changes Content */}
//                             <div className="space-y-2">
//                               {(() => {
//                                 if (item.changeType === "lead created") {
//                                   return (
//                                     <div className="flex items-start">
//                                       <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-green-500 rounded-full flex-shrink-0"></span>
//                                       <span className="text-sm text-green-600 dark:text-green-400 font-medium">
//                                         Lead was created successfully
//                                       </span>
//                                     </div>
//                                   );
//                                 }

//                                 // Parse UPDATED_FIELDS
//                                 if (
//                                   item.changeType.includes("UPDATED_FIELDS")
//                                 ) {
//                                   const changeText = item.changeType.replace(
//                                     "UPDATED_FIELDS: ",
//                                     "",
//                                   );
//                                   const changes = [];

//                                   // Parse each field change but EXCLUDE Status Color
//                                   const fieldRegex =
//                                     /([^:]+?)\s*\[From:\s*([^,]+),\s*To:\s*([^\]]+)\]/g;
//                                   let match;

//                                   while (
//                                     (match = fieldRegex.exec(changeText)) !==
//                                     null
//                                   ) {
//                                     const field = match[1].trim();
//                                     const from = match[2].trim() || "Empty";
//                                     const to = match[3].trim();

//                                     // SKIP Status Color
//                                     if (
//                                       field
//                                         .toLowerCase()
//                                         .includes("status color") ||
//                                       field.toLowerCase().includes("color")
//                                     ) {
//                                       continue;
//                                     }

//                                     changes.push({ field, from, to });
//                                   }

//                                   // If no changes after filtering (or regex fails)
//                                   if (changes.length === 0) {
//                                     // Filter out Status Color lines manually
//                                     const filteredLines = changeText
//                                       .split(",")
//                                       .filter(
//                                         (line) =>
//                                           !line
//                                             .toLowerCase()
//                                             .includes("status color") &&
//                                           !line.toLowerCase().includes("color"),
//                                       );

//                                     return filteredLines.map((line, index) => (
//                                       <div
//                                         key={index}
//                                         className="flex items-start"
//                                       >
//                                         <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-[#8B5CF6] rounded-full flex-shrink-0"></span>
//                                         <span className="text-sm text-gray-700 dark:text-gray-300">
//                                           {line.trim()}
//                                         </span>
//                                       </div>
//                                     ));
//                                   }

//                                   // Render parsed changes (Status Color already filtered out)
//                                   return changes.map((change, index) => (
//                                     <div
//                                       key={index}
//                                       className="flex items-start"
//                                     >
//                                       <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-[#8B5CF6] rounded-full flex-shrink-0"></span>
//                                       <div className="flex-1">
//                                         <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                                           {change.field}
//                                         </div>
//                                         <div className="flex items-center text-sm space-x-2">
//                                           <div className="flex items-center">
//                                             <span className="text-gray-500 dark:text-gray-400 text-xs mr-1">
//                                               From:
//                                             </span>
//                                             <span className="px-2 py-0.5 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded text-xs">
//                                               {change.from}
//                                             </span>
//                                           </div>
//                                           <span className="text-gray-400">
//                                             →
//                                           </span>
//                                           <div className="flex items-center">
//                                             <span className="text-gray-500 dark:text-gray-400 text-xs mr-1">
//                                               To:
//                                             </span>
//                                             <span className="px-2 py-0.5 bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 rounded text-xs">
//                                               {change.to}
//                                             </span>
//                                           </div>
//                                         </div>
//                                       </div>
//                                     </div>
//                                   ));
//                                 }

//                                 // Fallback for other change types
//                                 return (
//                                   <div className="flex items-start">
//                                     <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-gray-400 rounded-full flex-shrink-0"></span>
//                                     <span className="text-sm text-gray-700 dark:text-gray-300">
//                                       {item.changeType}
//                                     </span>
//                                   </div>
//                                 );
//                               })()}
//                             </div>
//                           </div>
//                         </div>

//                         <div className="sm:col-span-2">
//                           <span className="text-gray-500 dark:text-white">
//                             Time:
//                           </span>{" "}
//                           {(() => {
//                             const d = new Date(item.createdAt);
//                             const day = String(d.getDate()).padStart(2, "0");
//                             const month = String(d.getMonth() + 1).padStart(
//                               2,
//                               "0",
//                             );
//                             const year = d.getFullYear();

//                             let hours = d.getHours();
//                             const minutes = String(d.getMinutes()).padStart(
//                               2,
//                               "0",
//                             );
//                             const ampm = hours >= 12 ? "PM" : "AM";
//                             hours = hours % 12;
//                             hours = hours ? hours : 12; // convert 0 hour to 12
//                             const strHours = String(hours).padStart(2, "0");

//                             return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//                           })()}
//                         </div>
//                       </div>

//                       {item.oldValues && item.newValues && (
//                         <div className="border-t border-gray-200 pt-2 mt-2 dark:bg-gray-700 dark:text-white">
//                           <p className="text-gray-600 text-sm font-medium mb-1">
//                             Changes
//                           </p>
//                           <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
//                             {Object.entries(item.oldValues).map(
//                               ([key, oldVal]) => (
//                                 <li key={key}>
//                                   <span className="font-medium">{key}:</span>{" "}
//                                   <span className="text-red-500 line-through">
//                                     {JSON.stringify(oldVal)}
//                                   </span>{" "}
//                                   <span className="text-green-600">
//                                     → {JSON.stringify(item.newValues[key])}
//                                   </span>
//                                 </li>
//                               ),
//                             )}
//                           </ul>
//                         </div>
//                       )}
//                     </div>
//                   ))
//               ) : (
//                 <p className="text-center text-sm text-gray-500 mt-4 dark:bg-gray-700 dark:text-white">
//                   No history available for this lead.
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//       {isReminderModalOpen && (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-start overflow-y-auto py-10">
//           {/* Prevent body scroll while modal is open */}
//           <style>{`body { overflow: hidden; }`}</style>

//           <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
//             {/* Scrollable Content */}
//             <div className="max-h-[80vh] overflow-y-auto p-4 sm:p-6 md:p-8">
//               {/* Close Button */}
//               <button
//                 className="absolute top-3 right-3 text-3xl text-gray-600 dark:text-white hover:text-red-500 focus:outline-none"
//                 onClick={() => {
//                   setIsReminderModalOpen(false);
//                   document.body.style.overflow = "auto"; // Restore scroll
//                 }}
//               >
//                 &times;
//               </button>

//               {/* Reminder Form */}
//               <ReminderForm
//                 onSubmit={(formValues) => {
//                   const payload = {
//                     ...formValues,
//                     leadId: selectedLeadId,
//                   };
//                   console.log("Reminder form submitted:", payload);
//                   handleReminderFormSubmit(payload);
//                   setIsReminderModalOpen(false);
//                   document.body.style.overflow = "auto";
//                 }}
//                 onClose={() => {
//                   setIsReminderModalOpen(false);
//                   document.body.style.overflow = "auto";
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {isWhatsappModelOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 transition-opacity duration-300 p-2 sm:p-4">
//           <div className="bg-white dark:bg-gray-900 p-4 sm:p-6 rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto relative animate-fadeIn">
//             {/* Header */}
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-lg font-semibold text-green-600">
//                 Send WhatsApp Message
//               </h2>
//               <button
//                 onClick={() => {
//                   setIsWhatsappModelOpen(false);
//                   setSelectedWhatsappTemplate("");
//                   setSelectedWhatsappTemplateBody("");
//                   setWhatsappVariableValues({});
//                 }}
//                 className="text-gray-500 hover:text-red-500 text-xl"
//               >
//                 ✕
//               </button>
//             </div>

//             <form onSubmit={handleSendWhatsapp} className="space-y-4">
//               {/* Dropdown */}
//               <div>
//                 <label className="block mb-1 font-medium text-sm">
//                   Select Template
//                 </label>
//                 <select
//                   className="w-full border rounded p-2 text-sm dark:bg-gray-800 dark:text-white"
//                   value={selectedWhatsappTemplate}
//                   onChange={(e) => handleTemplateChange(e.target.value)}
//                 >
//                   <option value="">-- Select Template --</option>
//                   {template.map((tpl) => (
//                     <option key={tpl.id || tpl.name} value={tpl.name}>
//                       {tpl.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Template Preview with responsive design for long text */}
//               {selectedWhatsappTemplateBody && (
//                 <div className="p-3 border rounded bg-gray-50 dark:bg-gray-800 text-sm">
//                   <span className="font-semibold text-green-600 block mb-2">
//                     Preview:
//                   </span>
//                   <div className="max-h-40 overflow-y-auto p-2 bg-white dark:bg-gray-700 rounded border">
//                     <p className="text-gray-700 dark:text-gray-200 break-words whitespace-pre-wrap">
//                       {getWhatsappPreviewText(selectedWhatsappTemplateBody)}
//                     </p>
//                   </div>
//                 </div>
//               )}

//               {/* ✅ ADD ONLY – DO NOT REMOVE ANYTHING: Fill Variables (Var 1, Var 2, ...) */}
//               {selectedWhatsappTemplateBody &&
//                 extractWhatsappVariables(selectedWhatsappTemplateBody).length >
//                 0 && (
//                   <div className="border-t pt-3 dark:border-gray-700">
//                     <label className="block text-gray-700 font-medium mb-2 text-sm dark:text-white">
//                       Fill Variables:
//                     </label>
//                     <div className="space-y-2">
//                       {extractWhatsappVariables(
//                         selectedWhatsappTemplateBody,
//                       ).map((v) => (
//                         <div
//                           key={v}
//                           className="flex items-center gap-2"
//                         >
//                           <span className="text-xs font-bold text-gray-500 dark:text-gray-300 min-w-[45px]">
//                             Var {v}:
//                           </span>
//                           <input
//                             type="text"
//                             className="w-full p-2 border rounded text-sm dark:bg-gray-700 dark:text-white"
//                             placeholder={`Value for {{${v}}}`}
//                             value={whatsappVariableValues[v] || ""}
//                             onChange={(e) =>
//                               handleWhatsappVariableChange(v, e.target.value)
//                             }
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//               {/* Action Buttons */}
//               <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 pt-2">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setIsWhatsappModelOpen(false);
//                     setSelectedWhatsappTemplate("");
//                     setSelectedWhatsappTemplateBody("");
//                     setWhatsappVariableValues({});
//                   }}
//                   className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 text-sm order-2 sm:order-1"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={!selectedWhatsappTemplate}
//                   className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 text-sm order-1 sm:order-2 disabled:opacity-50"
//                 >
//                   Send
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {isTaskModalOpen && (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-start overflow-y-auto py-10">
//           {/* Prevent body scroll while modal is open */}
//           <style>{`body { overflow: hidden; }`}</style>

//           <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
//             {/* Scrollable Content */}
//             <div className="max-h-[80vh] overflow-y-auto p-4 sm:p-6 md:p-8">
//               <h2 className="text-xl font-bold">Create Task</h2>
//               {/* Close Button */}
//               <button
//                 className="absolute top-3 right-3 text-3xl text-gray-600 dark:text-white hover:text-red-500 focus:outline-none"
//                 onClick={() => {
//                   setIsTaskModalOpen(false);
//                   document.body.style.overflow = "auto"; // Restore scroll
//                 }}
//               >
//                 &times;
//               </button>

//               {/* Reminder Form */}
//               <TaskForm
//                 leadId={selectedLeadId}
//                 onSubmit={(formValues) => {
//                   const payload = {
//                     ...formValues,
//                     leadId: selectedLeadId,
//                   };
//                   console.log("Reminder form submitted:", payload);
//                   handleTaskSubmit(payload);
//                   setIsTaskModalOpen(false);
//                   document.body.style.overflow = "auto";
//                 }}
//                 onClose={() => {
//                   setIsTaskModalOpen(false);
//                   document.body.style.overflow = "auto";
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       )}
//       {isFollowUpModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
//           <div className="bg-white dark:bg-gray-700 dark:text-white w-full max-w-md rounded-lg shadow-lg flex flex-col max-h-[90vh]">
//             {/* Header (fixed) */}
//             <div className="p-4 border-b dark:border-gray-600 flex justify-between items-center">
//               <h2 className="text-lg font-semibold cfg-heading">Lead Follow Up</h2>

//               <button
//                 onClick={() => fetchFollowUpHistory(selectedLeadId)}
//                 className="flex items-center text-[#673AB7] hover:text-[#5E35A6] text-sm"
//               >
//                 <FaHistory className="mr-1" />
//                 History
//               </button>
//             </div>

//             {/* Scrollable Content */}
//             <div className="flex-1 overflow-y-auto px-4 py-3 space-y-4 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
//               {/* Lead Info */}
//               <div className="space-y-1 text-sm">
//                 <div className="flex gap-1">
//                   <span className="font-medium">Lead Name:</span>
//                   <span className="text-[#673AB7] dark:text-[#8B5CF6] capitalize">
//                     {selectedLeadName}
//                   </span>
//                 </div>
//                 <div className="flex gap-1">
//                   <span className="font-medium">Phone:</span>
//                   <span className="text-green-600 dark:text-green-300">
//                     {selectedLeadPhone}
//                   </span>
//                 </div>
//               </div>

//               {/* Notes */}
//               <div className="flex flex-col space-y-1">
//                 <label className="text-sm font-medium">Notes</label>
//                 <textarea
//                   rows={3}
//                   className="w-full p-2 border rounded dark:bg-gray-700"
//                   placeholder="Enter notes"
//                   value={followUpData.notes}
//                   onChange={(e) =>
//                     setFollowUpData({ ...followUpData, notes: e.target.value })
//                   }
//                 />
//               </div>

//               {/* Date */}
//               <div className="flex flex-col space-y-1">
//                 <label className="text-sm font-medium">
//                   Next Follow-up Date
//                 </label>
//                 <input
//                   type="date"
//                   className="w-full p-2 border rounded dark:bg-gray-700"
//                   value={followUpData.nextFollowUpDate}
//                   min={new Date().toISOString().split("T")[0]}
//                   onChange={(e) =>
//                     setFollowUpData({
//                       ...followUpData,
//                       nextFollowUpDate: e.target.value,
//                     })
//                   }
//                 />
//               </div>

//               {/* Time */}
//               <div className="flex flex-col space-y-1">
//                 <label className="text-sm font-medium">
//                   Next Follow-up Time
//                 </label>
//                 <input
//                   type="time"
//                   className="w-full p-2 border rounded dark:bg-gray-700"
//                   value={followUpData.nextFollowUpTime}
//                   onChange={(e) =>
//                     setFollowUpData({
//                       ...followUpData,
//                       nextFollowUpTime: e.target.value,
//                     })
//                   }
//                 />
//               </div>

//               {/* Followed By */}
//               <div className="flex flex-col space-y-1">
//                 <label className="text-sm font-medium">Followed By</label>
//                 <Select
//                   placeholder="Select User"
//                   value={followUpData.followedById || undefined}
//                   options={users.map((u) => ({
//                     value: u.id,
//                     label: `${u.fname} ${u.lname}`,
//                   }))}
//                   onChange={(value) => {
//                     const user = users.find((u) => u.id === value);
//                     setFollowUpData((prev) => ({
//                       ...prev,
//                       followedById: value,
//                       followedByName: user ? `${user.fname} ${user.lname}` : "",
//                     }));
//                   }}
//                 />
//               </div>

//               {/* Status */}
//               <div className="p-2 border rounded bg-gray-50 dark:bg-gray-800">
//                 <label className="text-sm font-medium mb-1 block">
//                   Update Status
//                 </label>
//                 <select
//                   className="w-full p-2 border rounded text-sm dark:bg-gray-700"
//                   value={followUpData.selectedStatus || ""}
//                   onChange={(e) => {
//                     const status = statuses.find(
//                       (s) => s.name === e.target.value,
//                     );
//                     if (status) {
//                       setSelectedStatus(status);
//                       setShowModal(true);
//                       setFollowUpData((prev) => ({
//                         ...prev,
//                         selectedStatus: e.target.value,
//                       }));
//                     }
//                   }}
//                 >
//                   <option value="">-- Select Status --</option>
//                   {statuses
//                     .filter((s) => s.active)
//                     .map((s) => (
//                       <option key={s.name} value={s.name}>
//                         {s.name}
//                       </option>
//                     ))}
//                 </select>
//               </div>
//             </div>

//             {/* Footer (fixed) */}
//             <div className="p-4 border-t dark:border-gray-600 flex justify-end gap-2">
//               <button
//                 onClick={() => setFollowUpModalOpen(false)}
//                 className="px-4 py-2 bg-gray-200 rounded text-sm"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleFollowUpSubmit}
//                 className="px-4 py-2 bg-teal-500 text-white rounded text-sm"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showFollowUpHistoryModal && (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-3 sm:px-4 py-4">
//           <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-5 sm:p-6 relative dark:bg-gray-700 dark:text-white">
//             {/* Modal Header */}
//             <div className="flex justify-between items-center pb-3 border-gray-200 dark:bg-gray-700 dark:text-white">
//               <h2 className="text-lg sm:text-xl font-semibold cfg-heading dark:text-white">
//                 Follow-up History
//               </h2>
//               <button
//                 onClick={() => setShowFollowUpHistoryModal(false)}
//                 className="text-gray-600 hover:text-red-500 text-xl font-bold transition"
//                 aria-label="Close"
//               >
//                 &times;
//               </button>
//             </div>
//             <div className=" mb-1 ">
//               <div className="flex items-center text-sm gap-1">
//                 <span className="font-medium   ">Lead Name :</span>
//                 <span className="text-[#673AB7]   capitalize   dark:text-[#8B5CF6]">
//                   {selectedLeadName}
//                 </span>
//               </div>
//               <div className="flex items-center text-sm   gap-1">
//                 <span className="font-medium">Phone:</span>
//                 <span className="text-green-600 dark:text-green-300">
//                   {selectedLeadPhone}
//                 </span>
//               </div>
//             </div>
//             {/* Modal Content */}
//             <div className="mt-4 max-h-[65vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:bg-gray-700 dark:text-white">
//               {followUpHistory.length > 0 ? (
//                 // Sort follow-ups by date (newest first) and map through them
//                 [...followUpHistory]
//                   .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//                   .map((item, index) => (
//                     <div
//                       key={item.id || index}
//                       className="border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50 hover:shadow-sm transition dark:bg-gray-700 dark:text-white"
//                     >
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700 mb-2 dark:bg-gray-700 dark:text-white">
//                         <div>
//                           <span className="text-gray-500 dark:text-white">
//                             Followed By:
//                           </span>{" "}
//                           {item.followedByName}
//                         </div>
//                         <div>
//                           <span className="text-gray-500 dark:text-white">
//                             Created By:
//                           </span>{" "}
//                           {item.createdByName}
//                         </div>

//                         <div className="sm:col-span-2">
//                           <span className="text-gray-500 dark:text-white">
//                             Created At:
//                           </span>{" "}
//                           {(() => {
//                             const d = new Date(item.createdAt);
//                             const day = String(d.getDate()).padStart(2, "0");
//                             const month = String(d.getMonth() + 1).padStart(
//                               2,
//                               "0",
//                             );
//                             const year = d.getFullYear();

//                             let hours = d.getHours();
//                             const minutes = String(d.getMinutes()).padStart(
//                               2,
//                               "0",
//                             );
//                             const ampm = hours >= 12 ? "PM" : "AM";
//                             hours = hours % 12;
//                             hours = hours ? hours : 12; // convert 0 hour to 12
//                             const strHours = String(hours).padStart(2, "0");

//                             return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//                           })()}
//                         </div>
//                       </div>

//                       <div className="border-t border-gray-200 pt-2 mt-2 dark:bg-gray-700 dark:text-white">
//                         <div className="mb-2">
//                           <span className="text-gray-500 dark:text-white">
//                             Notes:
//                           </span>{" "}
//                           <p className="text-gray-700 dark:text-white">
//                             {item.notes || "No notes provided"}
//                           </p>
//                         </div>
//                         <div>
//                           <span className="text-gray-700 dark:text-white">
//                             Next Follow-up:
//                           </span>{" "}
//                           {item.nextFollowUpDate && item.nextFollowUpTime ? (
//                             <>
//                               {/* {item.nextFollowUpDate} at {item.nextFollowUpTime} */}

//                               {(() => {
//                                 const d = new Date(
//                                   `${item.nextFollowUpDate} ${item.nextFollowUpTime}`,
//                                 );

//                                 const day = String(d.getDate()).padStart(
//                                   2,
//                                   "0",
//                                 );
//                                 const month = String(d.getMonth() + 1).padStart(
//                                   2,
//                                   "0",
//                                 );
//                                 const year = d.getFullYear();

//                                 let hours = d.getHours();
//                                 const minutes = String(d.getMinutes()).padStart(
//                                   2,
//                                   "0",
//                                 );
//                                 const ampm = hours >= 12 ? "PM" : "AM";
//                                 hours = hours % 12;
//                                 hours = hours ? hours : 12;
//                                 const strHours = String(hours).padStart(2, "0");

//                                 return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
//                               })()}
//                             </>
//                           ) : (
//                             "Not scheduled"
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   ))
//               ) : (
//                 <p className="text-center text-sm text-gray-500 mt-4 dark:bg-gray-700 dark:text-white">
//                   No follow-up history available for this lead.
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Status Reason Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50">
//           <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg w-full max-w-md">
//             <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
//               Change Lead Status
//             </h2>
//             <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
//               Reason for changing status:
//             </label>
//             <textarea
//               rows={3}
//               className="w-full border border-gray-300 p-2 rounded-md dark:bg-gray-700 dark:text-white"
//               placeholder="Enter your reason"
//               value={reason}
//               onChange={(e) => setReason(e.target.value)}
//             />

//             <div className="mt-4 flex justify-end gap-3">
//               <button
//                 onClick={() => {
//                   setShowModal(false);
//                   setReason("");
//                 }}
//                 className="px-4 py-2 bg-gray-300 dark:bg-gray-600 rounded hover:bg-gray-400 dark:hover:bg-gray-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleModalSubmit}
//                 className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6]"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isSmsModalOpen && (
//         <SmsModal
//           isSmsModalOpen={isSmsModalOpen}
//           smsTemplates={smsTemplates}
//           selectedLeadForSms={selectedLeadForSms}
//           setSelectedLeadForSms={setSelectedLeadForSms}
//           selectedTemplate={selectedTemplate}
//           setSelectedTemplate={setSelectedTemplate}
//           templateVariables={templateVariables}
//           setTemplateVariables={setTemplateVariables}
//           selectedTemplateData={selectedTemplateData}
//           setSelectedTemplateData={setSelectedTemplateData}
//           isSending={isSending}
//           setIsSending={setIsSending}
//           user={user}
//           fetchData={fetchData}
//           onClose={() => {
//             setIsSmsModalOpen(false);
//             setSelectedTemplate("");
//             setSelectedLeadForSms("");
//             setTemplateVariables({});
//             setSelectedTemplateData(null);
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default TableView;





import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import axios from "axios";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeadForm from "../Lead Page/LeadForm";
import { useNavigate } from "react-router-dom";
import {
  FaEdit,
  FaTag,
  FaUserPlus,
  FaClock,
  FaTasks,
  FaUserCheck,
  FaUserClock,
  FaEnvelope,
  FaHistory,
  FaSearch,
  FaTimes,
  FaSms,
  FaBan,
  FaPhone,
  FaFileDownload,
  FaWhatsapp,
  FaEllipsisV,
} from "react-icons/fa";
import { PhoneCall, X } from "lucide-react";
import ReminderForm from "../Reminder Page/ReminderForm";
import TaskForm from "../Task page/TaskForm";
import { Select } from "antd";
import { jwtDecode } from "jwt-decode";
// import { useWebRTC } from '../context/WebRTCContext';

// ── Small date/duration helpers used by the Call History popup (same
// formatting used on the Card/Kanban view) ─────────────────────────────────
function formatCallDateTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function formatCallDuration(seconds) {
  if (seconds === undefined || seconds === null) return "—";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
}

// ── Call History popup - same /call-recordings API and same UI as the
// Card/Kanban view's Call History modal ────────────────────────────────────
function CallHistoryModal({ open, lead, data, loading, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg max-h-[85vh] overflow-y-auto">
        <div className="sticky top-0 bg-white dark:bg-gray-800 p-4 border-b dark:border-gray-700 flex justify-between items-center">
          <h3 className="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2">
            <PhoneCall className="w-4 h-4 text-[#673AB7]" /> Call History
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {lead && (
          <div className="flex items-center gap-3 px-4 py-3 border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
            <div className="w-9 h-9 rounded-full bg-[#F3E8FF] text-[#673AB7] flex items-center justify-center font-bold text-sm">
              {(lead.name || "?").charAt(0).toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-800 dark:text-white truncate">{lead.name}</p>
              {lead.phone && <p className="text-xs text-gray-500 dark:text-gray-300">📞 {lead.phone}</p>}
            </div>
          </div>
        )}

        <div className="p-4 space-y-3">
          {loading ? (
            <div className="flex justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-[#673AB7]"></div>
            </div>
          ) : !data || data.length === 0 ? (
            <p className="text-center text-sm text-gray-400 py-6">No call recordings found.</p>
          ) : (
            data.map((item, idx) => (
              <div
                key={item.callSessionId || idx}
                className="border border-gray-200 dark:border-gray-600 rounded-lg p-3 bg-gray-50 dark:bg-gray-700"
              >
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <p className="text-xs font-semibold text-gray-700 dark:text-gray-200">
                      Session: {item.callSessionId}
                    </p>
                    <p className="text-[11px] text-gray-500 dark:text-gray-400">
                      {formatCallDateTime(item.startTime)}
                    </p>
                  </div>
                  <span
                    className="text-white text-[11px] font-semibold px-2 py-0.5 rounded-full"
                    style={{ backgroundColor: item.status === "answered" ? "#16a34a" : "#F46653" }}
                  >
                    {item.status}
                  </span>
                </div>
                <p className="text-xs text-gray-600 dark:text-gray-300">
                  Duration: <b>{formatCallDuration(item.callDuration)}</b>
                </p>
                {item.resourceURL && (
                  <audio src={item.resourceURL} controls className="w-full h-9 mt-2" />
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

const EmailModal = ({
  isEmailModalOpen,
  templates,
  selectedLeadForEmail,
  setSelectedLeadForEmail,
  selectedTemplate,
  setSelectedTemplate,
  templateVariables,
  setTemplateVariables,
  selectedTemplateData,
  setSelectedTemplateData,
  isSending,
  setIsSending,
  user,
  fetchData,
  onClose,
}) => {
  const navigate = useNavigate();
  const handleEmailChange = (e) => {
    setSelectedLeadForEmail(e.target.value);
  };

  const handleTemplateChange = async (e) => {
    const templateId = e.target.value;
    setSelectedTemplate(templateId);
    const template = templates.find((t) => t.emailTemplateId === templateId);
    setSelectedTemplateData(template);

    if (template) {
      const variables = {};
      const varRegex = /\{\{(\w+)\}\}/g;
      let match;
      while ((match = varRegex.exec(template.body)) !== null) {
        variables[match[1]] = "";
      }
      setTemplateVariables(variables);
    } else {
      setTemplateVariables({});
    }
  };

  const handleVariableChange = (varName, value) => {
    setTemplateVariables((prev) => ({
      ...prev,
      [varName]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!selectedTemplate) return toast.error("Please select a template");
    if (!selectedLeadForEmail) return toast.error("Please enter an email");

    const emptyVars = Object.entries(templateVariables)
      .filter(([_, val]) => !val.trim())
      .map(([key]) => key);

    if (emptyVars.length > 0) {
      toast.error(`Please fill all variables: ${emptyVars.join(", ")}`);
      return;
    }

    setIsSending(true);
    try {
      const companyId =
        user?.accountType === "COMPANY" ? user?.id : user?.companyId;

      const response = await fetch(
        `${API_URL}/api/leads/${selectedTemplate}/sendEmail/${companyId}/${user?.id}/${selectedLeadForEmail}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(Object.values(templateVariables)),
        },
      );

      if (response.ok) {
        const contentType = response.headers.get("content-type");
        let data = contentType?.includes("application/json")
          ? await response.json()
          : await response.text();

        if (
          data === "Email sent successfully" ||
          data?.message === "Email sent successfully"
        ) {
          toast.success("Email sent successfully");
          onClose();
          fetchData();
        } else {
          toast.error("Failed to send email");
        }
      } else {
        toast.error("Failed to send email. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  const renderDynamicPreview = (template) => {
    if (!template?.body) return "";
    let updated = template.body;
    Object.entries(templateVariables).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
      updated = updated.replace(regex, value || `{{${key}}}`);
    });
    return updated;
  };

  if (!isEmailModalOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-5xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-6 dark:text-white">Send Email</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Section */}
          <div>
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                To:
              </label>
              <input
                type="email"
                value={selectedLeadForEmail || ""}
                onChange={handleEmailChange}
                className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
                required
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                Select Template:
              </label>
              <select
                value={selectedTemplate || ""}
                onChange={handleTemplateChange}
                className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
              >
                <option value="">-- Select Template --</option>
                {templates.map((t) => (
                  <option key={t.emailTemplateId} value={t.emailTemplateId}>
                    {t.title} - {t.subject}
                  </option>
                ))}
              </select>
            </div>

            {Object.keys(templateVariables).length > 0 && (
              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2 dark:text-white">
                  Fill Template Variables:
                </label>
                <div className="space-y-3">
                  {Object.entries(templateVariables).map(([key, val]) => (
                    <div key={key}>
                      <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">
                        {key}:
                      </label>
                      <input
                        type="text"
                        className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
                        value={val}
                        onChange={(e) =>
                          handleVariableChange(key, e.target.value)
                        }
                        placeholder={`Enter ${key}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right Section - Live Preview */}
          <div>
            {selectedTemplateData && (
              <div className="mb-4">
                <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                  Template Live Preview:
                </label>
                <div className="p-4 border rounded bg-gray-50 dark:bg-gray-900 text-sm overflow-auto min-h-[200px] whitespace-pre-wrap">
                  <h3 className="font-bold mb-2">
                    {selectedTemplateData.subject}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderDynamicPreview(selectedTemplateData),
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm"
            disabled={isSending}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm disabled:opacity-50"
            disabled={!selectedTemplate || !selectedLeadForEmail || isSending}
          >
            {isSending ? "Sending..." : "Send Email"}
          </button>
        </div>

        {templates.length === 0 && (
          <div className="mt-6 text-center">
            <button
              onClick={() => {
                onClose();
                navigate("/emailTemplates");
              }}
              className="text-[#673AB7] underline"
            >
              Go to Templates
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const SmsModal = ({
  isSmsModalOpen,
  smsTemplates,
  selectedLeadForSms,
  setSelectedLeadForSms,
  selectedTemplate,
  setSelectedTemplate,
  templateVariables,
  setTemplateVariables,
  selectedTemplateData,
  setSelectedTemplateData,
  isSending,
  setIsSending,
  user,
  fetchData,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleSmsChange = (e) => {
    setSelectedLeadForSms(e.target.value);
  };

  const handleTemplateChange = async (e) => {
    const messageId = e.target.value;
    setSelectedTemplate(messageId);
    const template = smsTemplates.find((t) => t.messageId === messageId);
    setSelectedTemplateData(template);

    if (template) {
      const variables = {};
      const varRegex = /\{\{(\w+)\}\}/g;
      let match;
      while ((match = varRegex.exec(template.templateText)) !== null) {
        variables[match[1]] = "";
      }
      setTemplateVariables(variables);
    } else {
      setTemplateVariables({});
    }
  };

  const handleVariableChange = (varName, value) => {
    setTemplateVariables((prev) => ({
      ...prev,
      [varName]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!selectedTemplate) return toast.error("Please select a template");
    if (!selectedLeadForSms) return toast.error("Please enter a phone number");

    const emptyVars = Object.entries(templateVariables)
      .filter(([_, val]) => !val.trim())
      .map(([key]) => key);

    if (emptyVars.length > 0) {
      toast.error(`Please fill all variables: ${emptyVars.join(", ")}`);
      return;
    }

    setIsSending(true);
    try {
      const companyId =
        user?.accountType === "COMPANY" ? user?.id : user?.companyId;

      const response = await fetch(
        `${API_URL}/api/smsConfig/send/${companyId}?createdById=${user?.id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            clientNumber: [selectedLeadForSms],
            messageId: selectedTemplate,
            variables: Object.values(templateVariables),
          }),
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.message === "SMS sent successfully") {
          toast.success("SMS sent successfully");
          onClose();
          fetchData();
        } else {
          toast.error(data.message || "Failed to send SMS");
        }
      } else {
        const errorData = await response.json();
        toast.error(
          errorData.message || "Failed to send SMS. Please try again.",
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  const renderDynamicPreview = (template) => {
    if (!template?.templateText) return "";
    let updated = template.templateText;
    Object.entries(templateVariables).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
      updated = updated.replace(regex, value || `{{${key}}}`);
    });
    return updated;
  };

  if (!isSmsModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-5xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-6 dark:text-white">Send SMS</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Section */}
          <div>
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                Phone Number:
              </label>
              <input
                type="tel"
                value={selectedLeadForSms || ""}
                onChange={handleSmsChange}
                className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
                required
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                Select Template:
              </label>
              <select
                value={selectedTemplate || ""}
                onChange={handleTemplateChange}
                className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
              >
                <option value="">-- Select Template --</option>
                {smsTemplates.map((t) => (
                  <option key={t.messageId} value={t.messageId}>
                    {t.templateType}
                  </option>
                ))}
              </select>
            </div>

            {Object.keys(templateVariables).length > 0 && (
              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2 dark:text-white">
                  Fill Template Variables:
                </label>
                <div className="space-y-3">
                  {Object.entries(templateVariables).map(([key, val]) => (
                    <div key={key}>
                      <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">
                        {key}:
                      </label>
                      <input
                        type="text"
                        className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
                        value={val}
                        onChange={(e) =>
                          handleVariableChange(key, e.target.value)
                        }
                        placeholder={`Enter ${key}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right Section - Live Preview */}
          <div>
            {selectedTemplateData && (
              <div className="mb-4">
                <label className="block mb-1 font-medium text-gray-700 dark:text-white">
                  Template Preview:
                </label>
                <div className="p-4 border rounded bg-gray-50 dark:bg-gray-900 text-sm overflow-auto min-h-[200px] whitespace-pre-wrap dark:text-white">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: renderDynamicPreview(selectedTemplateData),
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm dark:text-white"
            disabled={isSending}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm disabled:opacity-50"
            disabled={!selectedTemplate || !selectedLeadForSms || isSending}
          >
            {isSending ? "Sending..." : "Send SMS"}
          </button>
        </div>

        {smsTemplates.length === 0 && (
          <div className="mt-6 text-center">
            <button
              onClick={() => {
                onClose();
                navigate("/smsTemplates");
              }}
              className="text-[#673AB7] underline"
            >
              Go to Templates
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const LabelModal = ({
  isOpen,
  onClose,
  labels,
  selectedProjectId,
  setSelectedProjectId,
  onLabelSelect,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
        <h2 className="text-xl font-bold mb-4">Project Name</h2>

        {/* Dropdown with colored options */}
        <select
          className="w-full p-2 border rounded bg-white text-black dark:bg-gray-800 dark:text-white dark:border-gray-600"
          value={selectedProjectId}
          onChange={(e) => setSelectedProjectId(e.target.value)}
        >
          <option value="">Select a project</option>
          {labels.map((label) => (
            <option
              key={label.id}
              value={label.id}
              style={{
                backgroundColor: label.color,
                color: "#fff", // ensure text is visible
              }}
            >
              {label.name}
            </option>
          ))}
        </select>

        <div className="flex justify-end space-x-2 mt-4">
          <button
            className="bg-gray-300 px-4 py-2 rounded dark:bg-gray-600 dark:text-white"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
            onClick={() => {
              if (selectedProjectId) {
                onLabelSelect(selectedProjectId);
              } else {
                toast.error("Please select a label.");
              }
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const DownloadReportModal = ({
  isDownloadModalOpen,
  setIsDownloadModalOpen,
  downloadParams,
  setDownloadParams,
  users,
  labels,
  statuses,
  sourceOptions,
  handleDownloadReport,
}) => {
  if (!isDownloadModalOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-[95%] max-w-2xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-6 dark:text-white">
          Download Report
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              Created By
            </label>
            <Select
              allowClear
              placeholder="Select user"
              value={downloadParams.createdById || undefined}
              onChange={(value) =>
                setDownloadParams((prev) => ({ ...prev, createdById: value }))
              }
              options={users.map((user) => ({
                value: user.id,
                label: `${user.fname} ${user.lname}`,
              }))}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              Assigned To
            </label>
            <Select
              allowClear
              placeholder="Select user"
              value={downloadParams.assignedToId || undefined}
              onChange={(value) =>
                setDownloadParams((prev) => ({ ...prev, assignedToId: value }))
              }
              options={users.map((user) => ({
                value: user.id,
                label: `${user.fname} ${user.lname}`,
              }))}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              Project Name
            </label>
            <Select
              allowClear
              placeholder="Select project"
              value={downloadParams.projectName || undefined}
              onChange={(value) =>
                setDownloadParams((prev) => ({ ...prev, projectName: value }))
              }
              options={labels.map((label) => ({
                value: label.name,
                label: label.name,
              }))}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              Status
            </label>
            <Select
              allowClear
              placeholder="Select status"
              value={downloadParams.statusName || undefined}
              onChange={(value) =>
                setDownloadParams((prev) => ({ ...prev, statusName: value }))
              }
              options={statuses
                .filter((status) => status.active === true)
                .map((status) => ({
                  value: status.name,
                  label: status.name,
                }))}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              Source
            </label>
            <Select
              allowClear
              placeholder="Select source"
              value={downloadParams.sourceName || undefined}
              onChange={(value) =>
                setDownloadParams((prev) => ({ ...prev, sourceName: value }))
              }
              options={sourceOptions
                .filter((source) => source.active === true) // ✅ Only show active sources
                .map((source) => ({
                  value: source.name,
                  label: source.name,
                }))}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              From Date
            </label>
            <input
              type="date"
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
              value={downloadParams.fromDate}
              onChange={(e) =>
                setDownloadParams((prev) => ({
                  ...prev,
                  fromDate: e.target.value,
                }))
              }
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700 dark:text-white">
              To Date
            </label>
            <input
              type="date"
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
              value={downloadParams.toDate}
              onChange={(e) =>
                setDownloadParams((prev) => ({
                  ...prev,
                  toDate: e.target.value,
                }))
              }
            />
          </div>

        </div>

        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={() => setIsDownloadModalOpen(false)}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={handleDownloadReport}
            className="px-4 py-2 rounded bg-[#673AB7] hover:bg-[#5E35A6] text-white text-sm"
          >
            Download Report
          </button>
        </div>
      </div>
    </div>
  );
};

const TableView = ({ refreshTrigger }) => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [assignToUserId, setAssignToUserId] = useState("");
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormUpdated, setIsFormUpdated] = useState(false);
  const [formData, setFormData] = useState({});
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const [selectedLeadName, setSelectedLeadName] = useState("");
  const [selectedLeadPhone, setSelectedLeadPhone] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [deleteLeadId, setDeleteLeadId] = useState(null);
  const [labels, setLabels] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);
  const [selectedLabelLeadId, setSelectedLabelLeadId] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const [leadToConvert, setLeadToConvert] = useState(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [selectedLeadForEmail, setSelectedLeadForEmail] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [totalPages, setTotalPages] = useState(0);
  const [searchParams, setSearchParams] = useState({
    labelName: "",
    sourceName: "",
    targetUserId: "",
    statusName: "",
    startDate: "",
    endDate: "",
    city: "",
    state: "",
    nextFollowUpDate: "",
    createdAt: "",
    searchType: "phone",
    searchKeyword: "",
  });
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);

  // Search results now come from a cursor-paginated endpoint (no more totalPages/skip).
  // searchPageCursors[i] is the cursor used to fetch search-results page i (0-based);
  // index 0 is always null (first page has no cursor). Going "Prev" re-fetches using the
  // cursor already recorded for that page instead of walking backwards - keyset pagination
  // only ever moves forward against the API, so the frontend keeps its own trail of cursors
  // to make "Prev" possible.
  const [searchPageCursors, setSearchPageCursors] = useState([null]);
  const [searchPageIndex, setSearchPageIndex] = useState(0);
  const [searchHasMore, setSearchHasMore] = useState(false);

  const [statuses, setStatuses] = useState([]);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [reason, setReason] = useState("");
  const [isFollowUpModalOpen, setFollowUpModalOpen] = useState(false);
  const [followUpData, setFollowUpData] = useState({
    notes: "",
    nextFollowUpDate: "",
    nextFollowUpTime: "",
    followedById: "",
    followedByName: "",
    createdById: user?.id,
    createdByName: user?.name,
    companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
  });
  const [templateVariables, setTemplateVariables] = useState({});
  const [selectedTemplateData, setSelectedTemplateData] = useState(null);
  const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);
  const [selectedLeadForSms, setSelectedLeadForSms] = useState("");
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [followUpHistory, setFollowUpHistory] = useState([]);
  const [showFollowUpHistoryModal, setShowFollowUpHistoryModal] =
    useState(false);
  const [loginMobileNo, setLoginMobileNo] = useState("");
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [downloadParams, setDownloadParams] = useState({
    companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
    createdById: "",
    assignedToId: "",
    projectName: "",
    statusName: "",
    sourceName: "",
    fromDate: "",
    toDate: "",
  });
  const [isWhatsappModelOpen, setIsWhatsappModelOpen] = useState(false);
  const [template, setTemplate] = useState([]);
  const [selectedWhatsappTemplate, setSelectedWhatsappTemplate] = useState("");
  const [selectedWhatsappTemplateBody, setSelectedWhatsappTemplateBody] =
    useState("");
  const [whatsappVariableValues, setWhatsappVariableValues] = useState({});
  const [waApiKey, setWaApiKey] = useState("");
  const companyId = user?.accountType === "COMPANY" ? user.id : user?.companyId;
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [activeActionMenu, setActiveActionMenu] = useState(null);
  const actionMenuRef = useRef(null);

  // ── Call History popup state (same API/logic as the Card/Kanban view) ───
  const [showCallHistoryModal, setShowCallHistoryModal] = useState(false);
  const [callHistoryLead, setCallHistoryLead] = useState(null);
  const [callHistoryData, setCallHistoryData] = useState([]);
  const [callHistoryLoading, setCallHistoryLoading] = useState(false);

  // ✅ FIX: Changed 'mousedown' to 'click' to fix the double click/toggle bug 
  // with the 3 dots button conflicting events.
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setActiveActionMenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // ✅ ADDED: Auto-scroll to show the popup fully if it opens near the bottom
  useEffect(() => {
    if (activeActionMenu && actionMenuRef.current) {
      // Scrolls the menu into view smoothly
      actionMenuRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [activeActionMenu]);

  const updateLeadInTable = (leadId, updatedFields) => {
    setData((prev) =>
      prev.map((lead) =>
        lead.leadId === leadId
          ? { ...lead, ...updatedFields }
          : lead
      )
    );
  };

  useEffect(() => {
    async function fetchStates() {
      try {
        const res = await fetch(`${API_URL}/api/india/states`);
        const data = await res.json();
        let states = [];
        if (Array.isArray(data?.data)) {
          states = data.data;
        } else if (Array.isArray(data?.data?.states)) {
          states = data.data.states.map((s) => s.name);
        } else if (Array.isArray(data?.states)) {
          states = data.states;
        }

        setStateList(states);
      } catch (err) {
        console.error("Error fetching states:", err);
      }
    }

    fetchStates();
  }, []);

  useEffect(() => {
    async function fetchCities() {
      if (!searchParams.state) return;

      try {
        const res = await fetch(
          `${API_URL}/api/india/cities?state=${encodeURIComponent(
            searchParams.state,
          )}`,
        );
        const data = await res.json();
        if (Array.isArray(data.data)) {
          setCityList(data.data);
        } else {
          setCityList([]);
        }
      } catch (err) {
        console.error("Error fetching cities:", err);
      }
    }

    fetchCities();
  }, [searchParams.state]);

  const fetchWaApiKey = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/whatsappConfig/${companyId}`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.data && res.data.status === "success" && res.data.data?.apiKey) {
        setWaApiKey(res.data.data.apiKey);
        return res.data.data.apiKey;
      }
      return "";
    } catch (error) {
      console.warn("WhatsApp config not found or error fetching:", error?.message);
      return "";
    }
  };

  const handleWhatsappClick = async (item) => {
    setIsWhatsappModelOpen(true);
    setSelectedLeadId(item.phone);
    setSelectedWhatsappTemplate("");
    setSelectedWhatsappTemplateBody("");
    setWhatsappVariableValues({});
    try {
      let apiKey = waApiKey;
      if (!apiKey) {
        apiKey = await fetchWaApiKey();
      }

      if (!apiKey) {
        toast.error("WhatsApp API Key is not configured for this company.");
        setTemplate([]);
        return;
      }

      const res = await axios.get(
        `https://waapi.deetyasoft.com/api/lms/whatsapp-config/getTemplate?apiKey=${apiKey}`,
      );
      setTemplate(res.data?.templates || res.data?.data || res.data || []);
    } catch (error) {
      console.error("Error fetching Templates:", error);
      toast.error("Failed to load WhatsApp templates.");
      setTemplate([]);
    }
  };

  const handleTemplateChange = (templateName) => {
    setSelectedWhatsappTemplate(templateName);
    const tpl = template.find((t) => t.name === templateName);

    if (tpl) {
      const body =
        tpl.components?.find((c) => c.type === "BODY")?.text ||
        tpl.body ||
        tpl.templateText ||
        tpl.content ||
        "";

      setSelectedWhatsappTemplateBody(body);
      setWhatsappVariableValues({});
    } else {
      setSelectedWhatsappTemplateBody("");
      setWhatsappVariableValues({});
    }
  };

  const extractWhatsappVariables = (text) => {
    if (!text) return [];
    const matches = text.match(/{{(\d+)}}/g);
    return matches
      ? [...new Set(matches.map((m) => m.match(/\d+/)[0]))].sort(
        (a, b) => parseInt(a) - parseInt(b),
      )
      : [];
  };

  const getWhatsappPreviewText = (text) => {
    if (!text) return "";
    let updated = text;
    Object.keys(whatsappVariableValues).forEach((key) => {
      const regex = new RegExp(`{{${key}}}`, "g");
      updated = updated.replace(regex, whatsappVariableValues[key] || `{{${key}}}`);
    });
    return updated;
  };

  const handleWhatsappVariableChange = (key, value) => {
    setWhatsappVariableValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSendWhatsapp = async (e, item) => {
    e.preventDefault();
    if (!selectedWhatsappTemplate) return;

    if (!waApiKey) {
      toast.error("WhatsApp API Key is missing!");
      return;
    }

    const formatPhoneNumber = (phone) => {
      const cleaned = phone.replace(/\D/g, "");

      if (cleaned.startsWith("91") && cleaned.length === 12) {
        return cleaned;
      }

      if (cleaned.length === 10) {
        return `91${cleaned}`;
      }

      return cleaned;
    };

    try {
      const formattedPhone = formatPhoneNumber(selectedLeadId);

      const formData = new FormData();
      formData.append("apiKey", waApiKey);
      formData.append("templateName", selectedWhatsappTemplate);
      formData.append("to", formattedPhone);

      const varKeys = Object.keys(whatsappVariableValues).sort(
        (a, b) => parseInt(a) - parseInt(b),
      );
      if (varKeys.length > 0) {
        const manualVars = varKeys
          .map((key) => whatsappVariableValues[key] || "")
          .join(",");
        formData.append("manualVars", manualVars);
      }

      await axios.post(
        `https://waapi.deetyasoft.com/api/lms/whatsapp-config/sendVerifiedTemplates`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("WhatsApp message sent successfully!");
      setIsWhatsappModelOpen(false);
      setSelectedWhatsappTemplate("");
      setSelectedWhatsappTemplateBody("");
      setWhatsappVariableValues({});
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send WhatsApp message");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      const token = localStorage.getItem("token");
      if (!token) return;

      const apiCalls = [
        axios
          .get(`${API_URL}/api/leadStatus/company/${companyId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            setStatuses(response.data || []);
          })
          .catch((error) => {
            console.error("Error fetching lead statuses:", error);
            setStatuses([]);
          }),

        axios
          .post(
            `${API_URL}/api/ivr/sync-call-records/${companyId}`,
            {},
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          )
          .catch((error) => {
            console.error("Error syncing call records:", error);
          }),

        axios
          .post(
            `${API_URL}/api/publicLeads/fetch-leads/${companyId}`,
            {},
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          )
          .then((response) => {
            console.log("Public leads fetched successfully");
          })
          .catch((error) => {
            console.error("Error fetching public leads:", error);
          }),
      ];

      await Promise.allSettled(apiCalls);
    };

    fetchData();
  }, [user?.id, user?.accountType, user?.companyId, refreshTrigger]);

  const openStatusModal = (leadId, statusName) => {
    const selected = statuses.find((s) => s.name === statusName);
    if (!selected) return;
    setSelectedLeadId(leadId);
    setSelectedStatus(selected);
    setShowModal(true);
  };

  const toggleRowExpand = (leadId) => {
    setExpandedRows((prev) =>
      prev.includes(leadId)
        ? prev.filter((id) => id !== leadId)
        : [...prev, leadId],
    );
  };

  useEffect(() => {
    async function fetchSource() {
      if (!user) return;

      const companyId =
        user.accountType === "COMPANY" ? user.id : user.companyId;

      try {
        const response = await axios.get(
          `${API_URL}/api/leadSource/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        setSourceOptions(response.data || []);
      } catch (error) {
        console.error("Error fetching source:", error);
      }
    }

    fetchSource();
  }, [user]);

  const handleAssignMultipleLeads = (leadIds) => {
    setSelectedLeads(leadIds);
    setIsAssignModalOpen(true);
  };

  const handleModalSubmit = async () => {
    if (!selectedLeadId || !selectedStatus || !reason.trim()) {
      toast.error("Please provide a reason");
      return;
    }

    const token = user?.token || localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${API_URL}/api/leads/update/${selectedLeadId}/changedBy/${user?.id}`,
        {
          statusName: selectedStatus.name,
          statusColor: selectedStatus.color,
          reason: reason.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );


      if (response.data.status === "Successful") {
        toast.success(response.data.message);

        updateLeadInTable(selectedLeadId, {
          statusName: selectedStatus.name,
          statusColor: selectedStatus.color,
        });
        setShowModal(false);

        setReason("");
        setSelectedStatus(null);
      } else {
        throw new Error(response.data.message || "Failed to update status");
      }
    } catch (err) {
      console.error("Error updating lead status:", err);
      toast.error(err.response?.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Builds the query params for one call to the cursor-paginated search endpoint.
  // `cursor` is either null (first page) or one of the entries in searchPageCursors -
  // an object shaped like { cursorStatusWeight, cursorNextFollowUpDate, cursorCreatedAt,
  // cursorLeadId }. These are opaque bookmarks from a previous response - we just echo
  // them back verbatim, never construct or interpret them ourselves. cursorNextFollowUpDate
  // can legitimately be null (a lead with no follow-up date), so it's dropped from the
  // request entirely rather than sent as the literal string "null".
  const buildSearchApiParams = (cursor) => {
    const base = {
      limit: pageSize,
    };

    Object.entries(searchParams).forEach(([key, value]) => {
      if (value !== "" && key !== "searchType" && key !== "searchKeyword" && key !== "phone") {
        base[key] = value;
      }
    });

    if (searchParams.searchKeyword && searchParams.searchKeyword.trim() !== "") {
      base[searchParams.searchType] = searchParams.searchKeyword.trim();
    }

    if (!cursor) {
      return base;
    }

    const cursorParams = Object.fromEntries(
      Object.entries(cursor).filter(
        ([_, value]) => value !== null && value !== undefined,
      ),
    );

    return { ...base, ...cursorParams };
  };

  // Pulls the "next cursor" bundle out of a search response, ready to be passed straight
  // back into buildSearchApiParams on the following call.
  const cursorFromSearchResponse = (payload) => ({
    cursorStatusWeight: payload?.nextCursorStatusWeight,
    cursorNextFollowUpDate: payload?.nextCursorNextFollowUpDate,
    cursorCreatedAt: payload?.nextCursorCreatedAt,
    cursorLeadId: payload?.nextCursorLeadId,
  });

  const runLeadSearch = useCallback(
    async (cursor) => {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return null;

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found");
        return null;
      }

      const response = await axios.get(
        `${API_URL}/api/leads/search/${companyId}/${user?.id}`,
        {
          params: buildSearchApiParams(cursor),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    },
    [user, pageSize, searchParams],
  );

  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    // Validation Check
    const keyword = searchParams.searchKeyword?.trim();
    if (keyword) {
      const hasLetters = /[a-zA-Z]/.test(keyword);
      const isMostlyNumbers = /^\d+$/.test(keyword.replace(/[\s\+\-\(\)]/g, ""));

      if (searchParams.searchType === "phone" && hasLetters) {
        toast.error("No leads found matching the search criteria");
        return;
      }
      if (searchParams.searchType === "name" && isMostlyNumbers) {
        toast.error("No leads found matching the search criteria");
        return;
      }
    }

    setIsSearching(true);
    setIsSearchMode(true);
    setSearchPageIndex(0);
    setSearchPageCursors([null]);
    setSearchHasMore(false);

    try {
      const data = await runLeadSearch(null);
      if (!data) return;

      setData(data.leads || []);
      setSearchHasMore(!!data.hasMore);
      if (data.hasMore) {
        setSearchPageCursors([null, cursorFromSearchResponse(data)]);
      }
      toast.success(`Found ${data.leads?.length || 0} results`);
    } catch (error) {
      console.error("Search failed:", error);
      toast.error(
        error.response?.data?.message || "Search failed. Please try again.",
      );
      setData([]);
      setSearchHasMore(false);
    } finally {
      setIsSearching(false);
    }
  };

  // Re-fetches a page of search results using the cursor already recorded for it in
  // searchPageCursors (index 0's cursor is always null, i.e. the first page). If this is
  // the furthest page reached so far and there's more to load, records the cursor for the
  // page after it so a later "Next" click doesn't need to re-derive anything.
  const goToSearchPage = async (index) => {
    if (index < 0 || index >= searchPageCursors.length) return;

    try {
      const cursor = searchPageCursors[index];
      const data = await runLeadSearch(cursor);
      if (!data) return;

      setData(data.leads || []);
      setSearchPageIndex(index);
      setSearchHasMore(!!data.hasMore);

      if (data.hasMore && index === searchPageCursors.length - 1) {
        setSearchPageCursors((prev) => [...prev, cursorFromSearchResponse(data)]);
      }
    } catch (error) {
      console.error("Error fetching search page:", error);
      toast.error(error.response?.data?.message || "Failed to load page");
    }
  };

  const handleClearSearch = async () => {
    setSearchParams({
      labelName: "",
      targetUserId: "",
      sourceName: "",
      createdAt: "",
      startDate: "",
      endDate: "",
      city: "",
      state: "",
      nextFollowUpDate: "",
      searchType: "phone",
      searchKeyword: "",
    });
    setIsSearchMode(false);
    setSearchPageCursors([null]);
    setSearchPageIndex(0);
    setSearchHasMore(false);
    setPageNumber(0);
    await fetchData(0);
    toast.success("Search cleared");
  };

  const fetchLeadHistory = async (lead) => {
    try {
      setSelectedLeadId(lead.leadId);

      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_URL}/api/leadHistory/${lead.leadId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setHistoryData(res.data.content);
      setShowHistoryModal(true);
    } catch (err) {
      console.error("Error fetching lead history", err);
      toast.error("Failed to fetch lead history");
    }
  };

  // ── Call History popup - same /call-recordings API and logic as Card view ─
  const handleOpenCallHistory = async (lead) => {
    if (!lead?.leadId) return;
    setCallHistoryLead(lead);
    setCallHistoryLoading(true);
    setShowCallHistoryModal(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/leads/${lead.leadId}/call-recordings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setCallHistoryData(response.data || []);
    } catch (err) {
      console.error("Error fetching call history:", err);
      toast.error("Failed to fetch call history");
      setCallHistoryData([]);
    } finally {
      setCallHistoryLoading(false);
    }
  };

  const fetchEmailTemplates = useCallback(async () => {
    try {
      const companyId =
        user?.accountType === "COMPANY" ? user?.id : user?.companyId;
      const response = await axios.get(
        `${API_URL}/api/emailTemplates/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setTemplates(response.data.emailTemplates || []);
    } catch (error) {
      console.error("Error fetching email templates:", error);
      toast.error("Failed to load email templates");
    }
  }, [user]);

  useEffect(() => {
    if (isEmailModalOpen) {
      fetchEmailTemplates();
    }
  }, [isEmailModalOpen, fetchEmailTemplates]);

  const handleEmailClick = (lead) => {
    setSelectedLeadForEmail(lead.email);
    setIsEmailModalOpen(true);
  };

  const handleSmsClick = (lead) => {
    setSelectedLeadForSms(lead.phone);
    setIsSmsModalOpen(true);
  };

  const fetchSmsTemplates = useCallback(async () => {
    try {
      const companyId =
        user?.accountType === "COMPANY" ? user?.id : user?.companyId;
      const response = await axios.get(
        `${API_URL}/api/smsTemplates/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      setSmsTemplates(response.data.smsTemplates || []);
    } catch (error) {
      console.error("Failed to fetch SMS templates:", error);
      setSmsTemplates([]);
    }
  }, [user]);

  useEffect(() => {
    if (isSmsModalOpen) {
      fetchSmsTemplates();
    }
  }, [isSmsModalOpen, fetchSmsTemplates]);

  const fetchData = useCallback(
    async (page = pageNumber) => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token not found");
          return;
        }

        const url =
          user.accountType === "COMPANY"
            ? `${API_URL}/api/leads/company/${user.id}`
            : `${API_URL}/api/leads/assigned/${user.id}`;

        const response = await axios.get(url, {
          params: {
            pageNumber: page,
            pageSize: pageSize,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const leadsData = response.data?.leads || response.data?.content || [];
        const total = response.data?.totalPages || 1;

        setData(leadsData);
        setTotalPages(total);
        setPageNumber(page);
      } catch (error) {
        console.error("Error fetching data", error);
        setData([]);
        setTotalPages(0);
      }
    },
    [user, pageSize, refreshTrigger],
  );

  useEffect(() => {
    const handleLeadCreated = () => {
      fetchData();
    };

    window.addEventListener("leadCreated", handleLeadCreated);

    return () => {
      window.removeEventListener("leadCreated", handleLeadCreated);
    };
  }, []);

  const fetchUsers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users", error);
    }
  }, [user]);

  const fetchLabels = useCallback(async () => {
    const companyId = user.accountType === "COMPANY" ? user.id : user.companyId;
    try {
      const response = await axios.get(
        `${API_URL}/api/projectName/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setLabels(response.data);
    } catch (error) {
      console.error("Error fetching labels", error);
    }
  }, [user]);

  useEffect(() => {
    if (user?.id) {
      fetchData();
      fetchUsers();
      fetchLabels();
    }
  }, [user?.id, isFormUpdated, fetchData, fetchLabels, fetchUsers]);

  const handleCheckboxChange = (leadId) => {
    setSelectedLeads((prevSelectedLeads) =>
      prevSelectedLeads.includes(leadId)
        ? prevSelectedLeads.filter((id) => id !== leadId)
        : [...prevSelectedLeads, leadId],
    );
  };

  const handleAssignLeadIconClick = (leadId) => {
    setSelectedLeads([leadId]);
    setIsAssignModalOpen(true);
  };

  const handleAssignLeads = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${API_URL}/api/leads/assign/${assignToUserId}/${user?.id}`,
        selectedLeads,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      if (response.data.status === "Successful") {
        toast.success(response.data.message);
        setIsAssignModalOpen(false);
        setSelectedLeads([]);
        fetchData();
      } else {
        toast.error(response.data.message || "Failed to assign leads.");
      }
    } catch (error) {
      console.error("Error assigning leads:", error);
      toast.error(error.response?.data.message);
    }
  };

  const handleEdit = (id) => {
    const lead = data.find((lead) => lead.leadId === id);
    if (lead) {
      setSelectedLeadId(id);
      setFormData(lead);
      setIsModalOpen(true);
    }
  };

  const handleDeleteConfirm = async (event) => {
    event?.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/api/blacklist`,
        {
          createdByName: user?.name,
          createdById: user?.id,
          leadId: deleteLeadId,
          reason: deleteReason,
          companyId:
            user?.accountType === "COMPANY" ? user?.id : user?.companyId,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      fetchData();
      setDeleteModalOpen(false);
      setDeleteReason("");
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error deleting lead", error);
      toast.error(error.response?.data.message);
    }
  };

  const handleLabelIconClick = (leadId) => {
    setSelectedLabelLeadId([leadId]);
    setIsLabelModalOpen(true);
  };

  const handleLabelSelect = async (labelId) => {
    try {
      const response = await axios.put(
        `${API_URL}/api/leads/assignProjectName/${labelId}/${user?.id}`,
        selectedLabelLeadId,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      if (response.data.status === "Successful") {
        toast.success(response.data.message);
        setIsLabelModalOpen(false);
        fetchData();
      } else {
        toast.error(response.data.message || "Failed to assign label.");
      }
    } catch (error) {
      console.error("Error assigning label:", error);
      toast.error(error.response?.data.message);
    }
  };

  const handleConvertToCustomerClick = (lead) => {
    setLeadToConvert(lead);
    setIsConvertModalOpen(true);
  };

  const handleConfirmConversion = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/api/convertedLeads`,
        {
          leadId: leadToConvert.leadId,
          name: leadToConvert.name,
          email: leadToConvert.email,
          otherContactNo: leadToConvert.otherContactNo,
          companyName: leadToConvert.companyName,
          companyId:
            user?.accountType === "COMPANY" ? user?.id : user?.companyId,
          phone: leadToConvert.phone,
          convertedById: user?.id,
          convertedByName: user?.name,
          tag: leadToConvert.tag || "",
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );

      if (response.data.status === "Successful") {
        toast.success(response.data.message);
        setIsConvertModalOpen(false);
        fetchData();
      } else {
        toast.error(response.data.message || "Failed to convert lead.");
      }
    } catch (error) {
      console.error("Error converting lead:", error);
      toast.error(error.response?.data.message);
    }
  };


  // Handles normal (non-search) listing pagination only - still page-number/skip based,
  // since that's a different backend endpoint we haven't changed. Search-mode pagination
  // is handled separately by goToSearchPage, which drives the cursor-based search endpoint.
  const fetchPage = useCallback(
    async (page) => {
      try {
        if (!user?.id || !user?.accountType) return;

        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token not found");
          return;
        }

        const url =
          user.accountType === "COMPANY"
            ? `${API_URL}/api/leads/company/${user.id}?pageNumber=${page}&pageSize=${pageSize}`
            : `${API_URL}/api/leads/assigned/${user.id}?pageNumber=${page}&pageSize=${pageSize}`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const leadsData = response.data?.leads || response.data || [];
        const total = response.data?.totalPages || 1;

        setData(leadsData);
        setTotalPages(total);
      } catch (error) {
        console.error("Error fetching page data:", error);
        toast.error(error.response?.data.message);
        setData([]);
      }
    },
    [user?.id, user?.accountType, pageSize],
  );

  useEffect(() => {
    if (!isSearchMode) {
      fetchPage(pageNumber);
    }
  }, [pageNumber, fetchPage, isSearchMode]);

  const handleReminderFormSubmit = async (formData) => {
    try {
      const response = await axios.post(`${API_URL}/api/reminders`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      toast.success(response.data.message);
    } catch (error) {
      console.error("Failed to submit reminder form:", error);
    }
  };

  const handleTaskSubmit = async (formData) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/api/tasks`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === "Successful") {
        toast.success(response.data.message);
        setIsTaskModalOpen(false);
        fetchData();
      } else {
        throw new Error(response.data.message || "Failed to create task");
      }
    } catch (error) {
      console.error("Error creating task:", error);
      toast.error(error.response?.data.message);
    }
  };

  const handleFollowUpSubmit = async () => {
    try {
      const followUpPayload = {
        ...followUpData,
        createdById: user?.id,
        createdByName: user?.name,
        companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
      };

      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/api/leads/${selectedLeadId}/followups`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(followUpPayload),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message);
      }

      setFollowUpModalOpen(false);
      setFollowUpData({
        notes: "",
        nextFollowUpDate: "",
        nextFollowUpTime: "",
        followedById: "",
        followedByName: "",
        createdById: user?.id,
        createdByName: user?.name,
        companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
      });

      toast.success(result.message);
      fetchData();
    } catch (error) {
      console.error("Error submitting follow-up:", error);
      toast.error(error.message || error.response?.data?.message);
    }
  };

  const fetchFollowUpHistory = async (leadId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/leads/${leadId}/followups`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setFollowUpHistory(response.data || []);
      setShowFollowUpHistoryModal(true);
    } catch (error) {
      console.error("Error fetching follow-up history:", error);
      toast.error("Failed to fetch follow-up history");
    }
  };

  const getLatestFollowUpDate = (followUps) => {
    if (!followUps || followUps.length === 0) return null;

    const sortedFollowUps = [...followUps].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    );

    return sortedFollowUps[0];
  };

  const formatFollowUpDateTime = (date, time) => {
    if (!date) return "";

    const dateObj = new Date(`${date}T${time || "00:00:00"}`);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    const formattedTime = time ? time.substring(0, 5) : "";

    return formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
  };

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;

      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }

    fetchUsers();
  }, [user]);

  useEffect(() => {
    async function fetchLoginUserMobile() {
      if (!user?.id || !user?.accountType) return;

      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const users = response.data;

        const currentUser = users.find((u) => u.id === user.id);
        if (currentUser) {
          setLoginMobileNo(currentUser.mobileNumber);
        }
      } catch (error) {
        console.error("Error fetching users for mobile number:", error);
      }
    }

    fetchLoginUserMobile();
  }, [user]);

  const fetchApiKey = async () => {
    const token = localStorage.getItem("token");
    const companyId =
      user?.accountType === "COMPANY" ? user?.id : user?.companyId;
    const res = await axios.get(`${API_URL}/api/call-api-key/${companyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.callApiKey;
  };

  const handlePhoneCall = async (lead) => {
    if (!lead?.leadId) return;

    try {
      const token = localStorage.getItem("token");
      let loginEmail = user?.email || "";
      let loginAccountType = user?.accountType || "";

      if (token) {
        try {
          const payload = jwtDecode(token);
          loginEmail = payload.email || payload.sub || "";
          loginAccountType = payload.accountType || "";
        } catch (err) {
          console.error("Token decoding error:", err);
        }
      }

      await axios.post(
        `${API_URL}/api/leads/${lead.leadId}/click-to-call`,
        {
          loginAccountType: loginAccountType,
          loginEmail: loginEmail,
          loginMobileNo: loginMobileNo,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Call initiated successfully!");
    } catch (error) {
      console.error("❌ Click to call Error:", error);
      toast.error("Failed to initiate call. Please try again.");
    }
  };

  const handleDownloadReport = async () => {
    try {
      const params = {
        ...Object.fromEntries(
          Object.entries(downloadParams).filter(([_, value]) => value !== ""),
        ),
      };

      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/api/leads/download-report`,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "leads-report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Report downloaded successfully");
      setIsDownloadModalOpen(false);
    } catch (error) {
      console.error("Error downloading report:", error);
      toast.error(error.response?.data?.message || "Failed to download report");
    }
  };

  const [showSearchFields, setShowSearchFields] = useState(
    () => window.innerWidth >= 768,
  );

  useEffect(() => {
    const handleResize = () => {
      setShowSearchFields(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const [canEdit, setCanEdit] = useState(false);
  const [canDownload, setCanDownload] = useState(false);

  useEffect(() => {
    checkEditPermission();
  }, []);

  const checkEditPermission = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setCanEdit(false);
        setCanDownload(false);
        return;
      }

      const decoded = jwtDecode(token);
      const accountType = decoded.accountType;
      const userId = decoded.id;

      console.log("User Account Type:", accountType);
      console.log("User ID:", userId);

      const alwaysAllowed = [
        "SUPER_SUPER_ADMIN",
        "COMPANY",
        "SUPER_ADMIN",
        "RESELLER",
      ];

      if (alwaysAllowed.includes(accountType)) {
        console.log("Always allowed user type");
        setCanEdit(true);
        setCanDownload(true);
        return;
      }

      const hierarchicalTypes = [
        "VICE_PRESIDENT",
        "MANAGER",
        "TEAM_LEAD",
        "HR",
        "EXECUTIVE",
      ];

      if (hierarchicalTypes.includes(accountType)) {
        console.log("Checking API for hierarchical user...");

        try {
          const response = await fetch(
            `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${userId}&accountType=${accountType}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.ok) {
            const data = await response.json();
            console.log("API Response:", data);

            if (Array.isArray(data) && data.length > 0) {
              const userData = data[0];
              if (
                userData.permission &&
                userData.permission.some((p) => p.leadEdit === true)
              ) {
                console.log("Found leadEdit: true");
                setCanEdit(true);
                setCanDownload(true);
                return;
              }
            }
          }
        } catch (apiError) {
          console.error("API Error:", apiError);
        }
      }

      setCanEdit(false);
      setCanDownload(false);
    } catch (error) {
      console.error("Permission check failed:", error);
      setCanEdit(false);
      setCanDownload(false);
    }
  };

  const ConvertModal = () => {
    if (!isConvertModalOpen) return null;
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
          <h2 className="text-xl font-bold mb-4">Convert to Customer</h2>
          <p className="mb-4">
            Are you sure you want to convert this lead to a customer?
          </p>
          <div className="flex justify-end space-x-2 mt-4">
            <button
              className="bg-gray-300 px-4 py-2 rounded"
              onClick={() => setIsConvertModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
              onClick={handleConfirmConversion}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="cfg-font">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>

      <div className="flex items-center justify-between mb-1">
        <h2 className="text-lg font-bold cfg-heading dark:text-white">
          Table View
        </h2>
        <div className="flex items-center gap-1">
          <Select
            defaultValue="100"
            style={{ width: 70 }}
            onChange={(value) => setPageSize(Number(value))}
            options={[
              { value: "5", label: "5" },
              { value: "10", label: "10" },
              { value: "20", label: "20" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
          />

          <button
            type="button"
            onClick={() => setShowSearchFields(!showSearchFields)}
            className="flex items-center gap-1 px-1.5 py-0.5 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] text-xs"
          >
            <FaSearch className="text-xs" />
            {showSearchFields ? "Hide Search" : "Search"}
          </button>

          <FaUserPlus
            title="Assign selected leads"
            className={`cursor-pointer text-[#673AB7] text-lg ${selectedLeads.length === 0
              ? "opacity-50 cursor-not-allowed"
              : "hover:text-[#5E35A6]"
              }`}
            onClick={() => {
              if (selectedLeads.length > 0) {
                handleAssignMultipleLeads(selectedLeads);
              }
            }}
          />

          {canDownload && (
            <FaFileDownload
              title="Download Report"
              className="cursor-pointer text-green-600 text-lg hover:text-green-800"
              onClick={() => setIsDownloadModalOpen(true)}
            />
          )}
        </div>
      </div>

      {showSearchFields && (
        <form
          onSubmit={handleSearchSubmit}
          className="p-1 bg-white dark:bg-gray-800 shadow rounded-md mb-3 text-xs"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 items-end ">
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                User
              </label>
              <Select
                showSearch
                allowClear
                placeholder="Select user"
                name="targetUserId"
                value={searchParams.targetUserId || undefined}
                onChange={(value) =>
                  setSearchParams((prev) => ({ ...prev, targetUserId: value }))
                }
                options={users.map((user) => ({
                  value: user.id,
                  label: `${user.fname} ${user.lname}`,
                }))}
                className="w-full"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Project Name
              </label>
              <Select
                showSearch
                allowClear
                placeholder="Select label"
                name="projectName"
                value={searchParams.projectName || undefined}
                onChange={(value) =>
                  setSearchParams((prev) => ({ ...prev, projectName: value }))
                }
                options={labels.map((label) => ({
                  value: label.name,
                  label: (
                    <div className="flex items-center">
                      <div
                        className="w-2.5 h-2.5 rounded-full mr-1"
                        style={{ backgroundColor: label.color }}
                      />
                      {label.name}
                    </div>
                  ),
                }))}
                className="w-full"
                filterOption={(input, option) =>
                  option.value.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Source Name
              </label>
              <Select
                showSearch
                allowClear
                placeholder="Select Source"
                name="sourceName"
                value={searchParams.sourceName || undefined}
                onChange={(value) =>
                  setSearchParams((prev) => ({ ...prev, sourceName: value }))
                }
                options={sourceOptions
                  .filter((source) => source.active === true)
                  .map((source) => ({
                    value: source.name,
                    label: (
                      <div className="flex items-center">
                        <div className="w-2.5 h-2.5 rounded-full mr-1" />
                        {source.name}
                      </div>
                    ),
                  }))}
                className="w-full"
                filterOption={(input, option) =>
                  option.value.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Status Name
              </label>
              <Select
                showSearch
                allowClear
                placeholder="Select Status"
                name="statusName"
                value={searchParams.statusName || undefined}
                onChange={(value) =>
                  setSearchParams((prev) => ({ ...prev, statusName: value }))
                }
                options={statuses
                  .filter((status) => status.active === true)
                  .map((status) => ({
                    value: status.name,
                    label: (
                      <div className="flex items-center">
                        <div
                          className="w-2.5 h-2.5 rounded-full mr-1"
                          style={{ backgroundColor: status.color }}
                        />
                        {status.name}
                      </div>
                    ),
                  }))}
                className="w-full"
                filterOption={(input, option) =>
                  option.value.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                State
              </label>
              <select
                name="state"
                value={searchParams.state}
                onChange={handleChange}
                className="w-full p-2 border rounded disabled:bg-gray-200 dark:disabled:bg-gray-600"
              >
                <option value="">Select State</option>
                {stateList.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                City
              </label>

              <input
                list="city-list"
                name="city"
                value={searchParams.city}
                onChange={handleChange}
                placeholder={
                  !searchParams.state
                    ? "Select state first"
                    : "Type or select city"
                }
                className="w-full p-2 border rounded disabled:bg-gray-200 dark:disabled:bg-gray-600"
              />

              <datalist id="city-list">
                {cityList
                  .slice()
                  .sort()
                  .map((city) => (
                    <option key={city} value={city} />
                  ))}
              </datalist>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                From Date
              </label>

              <input
                type="date"
                name="startDate"
                value={searchParams.startDate}
                onChange={handleChange}
                className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                To Date
              </label>
              <input
                type="date"
                name="endDate"
                value={searchParams.endDate}
                onChange={handleChange}
                className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Created At
              </label>
              <input
                type="date"
                name="createdAt"
                value={searchParams.createdAt}
                onChange={handleChange}
                className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Next Follow Up
              </label>
              <input
                type="date"
                name="nextFollowUpDate"
                value={searchParams.nextFollowUpDate}
                onChange={handleChange}
                className="w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs"
              />
            </div>

            {/* ✅ NEW DYNAMIC SEARCH FIELD */}
            <div className="col-span-1 sm:col-span-2 xl:col-span-2">
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-0.5">
                Search Lead By
              </label>
              <div className="flex w-full items-center">
                <select
                  name="searchType"
                  value={searchParams.searchType || "phone"}
                  onChange={handleChange}
                  className="p-1 text-xs outline-none border-none bg-transparent dark:bg-gray-800 dark:text-white cursor-pointer w-[90px] sm:w-[100px]"
                >
                  <option value="phone">Phone No</option>
                  <option value="name">Name</option>
                </select>
                <input
                  type={searchParams.searchType === "phone" ? "tel" : "text"}
                  inputMode={searchParams.searchType === "phone" ? "numeric" : undefined}
                  name="searchKeyword"
                  placeholder={searchParams.searchType === "phone" ? "Phone no..." : "Name..."}
                  value={searchParams.searchKeyword || ""}
                  onChange={handleChange}
                  className="flex-1 w-full p-0.5 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white text-xs outline-none focus:border-[#673AB7]"
                />
              </div>
            </div>

          </div>

          <div className="flex justify-end space-x-1 mt-1">
            <button
              type="submit"
              className={`px-1.5 py-0.5 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center text-xs ${isSearching ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={isSearching}
            >
              {isSearching ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-1 h-3 w-3 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Searching...
                </>
              ) : (
                <>
                  <FaSearch className="mr-1 text-xs" />
                  Search
                </>
              )}
            </button>
            <button
              type="button"
              onClick={handleClearSearch}
              className="px-1.5 py-0.5 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 flex items-center text-xs"
            >
              <FaTimes className="mr-1 text-xs" />
              Clear
            </button>
          </div>
        </form>
      )}
      <div className={`${activeActionMenu ? "!overflow-visible" : "overflow-x-auto"} [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}>
        <table className="w-full min-w-max border-collapse border border-gray-300 text-xs">
          <thead>
            <tr className="bg-gray-100 dark:bg-gray-900 dark:text-white text-xs">
              <th className="p-1">
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setSelectedLeads(
                      e.target.checked ? data.map((c) => c.leadId) : [],
                    )
                  }
                  className="scale-75"
                />
              </th>
              <th className="p-1 ">S No.</th>
              <th className="p-1  text-left ">Name</th>
              <th className="p-1 ">Mobile</th>
              <th className="p-1 ">Source Name</th>
              <th className="p-1 ">Assign To</th>
              <th className="p-1 ">Assign By</th>
              <th className="p-1 "> Date</th>
              <th className="p-1 ">Last Follow Up</th>
              <th className="p-1">Next Follow Up </th>
              <th className="p-1 ">Status</th>
              <th className="p-1 ">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <React.Fragment key={item.leadId}>
                <tr className="border-t text-xs">
                  <td className="p-1">
                    <input
                      type="checkbox"
                      checked={selectedLeads.includes(item.leadId)}
                      onChange={() => handleCheckboxChange(item.leadId)}
                      className="scale-75"
                    />
                  </td>
                  <td className="p-1">
                    {(isSearchMode ? searchPageIndex : pageNumber) * pageSize +
                      index +
                      1}{" "}
                    <button
                      onClick={() => toggleRowExpand(item.leadId)}
                      className="text-[#673AB7] font-bold text-xs"
                    >
                      {expandedRows.includes(item.leadId) ? "▼" : "▶"}
                    </button>{" "}
                  </td>
                  <td className="p-1 max-w-[150px] truncate">
                    <span title={item.name} className="cursor-pointer">
                      {item.name.split(" ").slice(0, 2).join(" ")}
                    </span>
                  </td>

                  <td className="p-1 flex items-center gap-2">
                    {item.phone && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePhoneCall(item);
                        }}
                        className="relative flex items-center justify-center w-6 h-6 rounded-full bg-green-500 text-white hover:bg-green-600"
                        title="Click to Call"
                      >
                        <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
                        <FaPhone className="relative z-10 text-xs -scale-x-100 transform" />                      </button>
                    )}

                    {item.phone && (
                      <a
                        href={`tel:${item.phone}`}
                        onClick={(e) => e.stopPropagation()}
                        className="text-[#673AB7] hover:underline truncate max-w-[120px]"
                        title={item.phone}
                      >
                        {item.phone}
                      </a>
                    )}
                  </td>

                  <td className="p-1">
                    <span
                      className="inline-block px-2 py-1 rounded-full text-white"
                      style={{
                        backgroundColor: item.projectNameColor || "#6b7280",
                      }}
                    >
                      {item?.sourceName || "source"}
                    </span>
                  </td>
                  <td className="p-1">{item.assignedToName}</td>
                  <td className="p-1">{item.createdByName}</td>

                  <td className="p-1">
                    {new Date(item.leadDate)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, "-")}
                  </td>

                  <td className="p-1 text-center">
                    {(() => {
                      const latestFollowUp = getLatestFollowUpDate(
                        item.followUps,
                      );

                      if (!latestFollowUp || !latestFollowUp.lastFollowUpDate) {
                        return (
                          <span className="text-gray-400 text-xs">--</span>
                        );
                      }

                      return (
                        <span className="text-xs whitespace-nowrap">
                          {new Date(latestFollowUp.lastFollowUpDate)
                            .toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric", // yyyy
                            })
                            .replace(/\//g, "-")}
                        </span>
                      );
                    })()}
                  </td>

                  <td className="p-1 text-center">
                    {(() => {
                      const latestFollowUp = getLatestFollowUpDate(
                        item.followUps,
                      );

                      const formatDateTime = (dateString, timeString) => {
                        if (!dateString) return "----";

                        const dateOnly = new Date(dateString);
                        if (isNaN(dateOnly.getTime())) return "----";

                        const day = String(dateOnly.getDate()).padStart(2, "0");
                        const month = String(dateOnly.getMonth() + 1).padStart(
                          2,
                          "0",
                        ); // DD-MM-YYYY
                        const year = dateOnly.getFullYear();

                        if (timeString) {
                          const fullDateTime = new Date(
                            `${dateString}T${timeString}`,
                          );
                          if (!isNaN(fullDateTime.getTime())) {
                            const hours = String(
                              fullDateTime.getHours(),
                            ).padStart(2, "0");
                            const minutes = String(
                              fullDateTime.getMinutes(),
                            ).padStart(2, "0");
                            return `${day}-${month}-${year} ${hours}:${minutes}`;
                          }
                        }

                        return `${day}-${month}-${year}`;
                      };

                      if (latestFollowUp && latestFollowUp.nextFollowUpDate) {
                        const formattedDate = formatDateTime(
                          latestFollowUp.nextFollowUpDate,
                          latestFollowUp.nextFollowUpTime,
                        );

                        if (formattedDate === "----") {
                          return <span className="text-gray-500">----</span>;
                        }

                        return (
                          <button
                            onClick={() => fetchFollowUpHistory(item.leadId)}
                            className="text-[#673AB7] underline hover:text-[#5E35A6] cursor-pointer text-xs whitespace-nowrap"
                            title="Click to view follow-up history"
                          >
                            {formattedDate}
                          </button>
                        );
                      } else {
                        return (
                          <span className="text-gray-400 text-xs">--</span>
                        );
                      }
                    })()}
                  </td>

                  <td className="p-1">
                    <select
                      className="border p-1 rounded dark:bg-gray-900 dark:text-white"
                      style={{ backgroundColor: item.statusColor || "#ffffff" }}
                      value={item.statusName}
                      onChange={(e) =>
                        openStatusModal(item.leadId, e.target.value)
                      }
                    >
                      {statuses
                        .filter((status) => status.active === true)
                        .map((status) => (
                          <option
                            key={status.name}
                            value={status.name}
                            style={{
                              backgroundColor: status.color,
                              color: "black",
                            }}
                          >
                            {status.name}
                          </option>
                        ))}
                    </select>
                  </td>
                  <td className="p-1">
                    <div className="flex items-center justify-center gap-1 relative">
                      {canEdit && (
                        <button
                          type="button"
                          title="Edit Lead"
                          onClick={() => handleEdit(item.leadId)}
                          className="w-7 h-7 flex items-center justify-center rounded-md text-[#8B5CF6] hover:bg-[#F3E8FF] dark:hover:bg-blue-900/30 transition-colors"
                        >
                          <FaEdit className="text-sm" />
                        </button>
                      )}

                      <button
                        type="button"
                        title="Lead Follow Up"
                        onClick={() => {
                          setSelectedLeadName(item.name);
                          setSelectedLeadPhone(item.phone);
                          setSelectedLeadId(item.leadId);
                          setFollowUpModalOpen(true);
                        }}
                        className="w-7 h-7 flex items-center justify-center rounded-md text-teal-600 hover:bg-teal-50 dark:hover:bg-teal-900/30 transition-colors"
                      >
                        {/* Replaced <FaRedo className="text-sm" /> with the new icon */}
                        <FaUserClock className="text-sm" />
                      </button>

                      <button
                        type="button"
                        title="More Actions"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveActionMenu(
                            activeActionMenu === item.leadId ? null : item.leadId,
                          );
                        }}
                        className={`w-7 h-7 flex items-center justify-center rounded-md transition-colors ${activeActionMenu === item.leadId
                          ? "bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-white"
                          : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                          }`}
                      >
                        <FaEllipsisV className="text-sm" />
                      </button>

                      {activeActionMenu === item.leadId && (
                        <div
                          ref={actionMenuRef}
                          className="absolute right-0 top-8 z-50 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl py-1.5 text-left"
                        >
                          <div className="px-3 pt-1 pb-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                            Communicate
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              handleEmailClick(item);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaEnvelope className="text-red-500 text-sm shrink-0" />
                            Send Email
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleSmsClick(item);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaSms className="text-green-600 text-sm shrink-0" />
                            Send SMS
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleWhatsappClick(item);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaWhatsapp className="text-green-500 text-sm shrink-0" />
                            WhatsApp Message
                          </button>

                          {/* ── NEW: Call History (3rd position) - same popup/API as Card view ── */}
                          <button
                            type="button"
                            onClick={() => {
                              handleOpenCallHistory(item);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <PhoneCall className="w-3.5 h-3.5 text-purple-500 shrink-0" />
                            Call History
                          </button>

                          <div className="border-t border-gray-100 dark:border-gray-700 my-1" />

                          <div className="px-3 pt-1 pb-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                            Manage Lead
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              handleLabelIconClick(item.leadId);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaTag className="text-green-500 text-sm shrink-0" />
                            Add Project
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              handleAssignLeadIconClick(item.leadId);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaUserPlus className="text-purple-500 text-sm shrink-0" />
                            Assign Lead
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedLeadId(item.leadId);
                              setIsReminderModalOpen(true);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaClock className="text-yellow-500 text-sm shrink-0" />
                            Set Reminder
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedLeadId(item.leadId);
                              setIsTaskModalOpen(true);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaTasks className="text-blue-700 text-sm shrink-0" />
                            Create Task
                          </button>
                          {!item.isConvertedLead && (
                            <button
                              type="button"
                              onClick={() => {
                                handleConvertToCustomerClick(item);
                                setActiveActionMenu(null);
                              }}
                              className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                            >
                              <FaUserCheck className="text-orange-500 text-sm shrink-0" />
                              Convert to Customer
                            </button>
                          )}

                          <div className="border-t border-gray-100 dark:border-gray-700 my-1" />

                          <button
                            type="button"
                            onClick={() => {
                              setSelectedLeadName(item.name);
                              setSelectedLeadPhone(item.phone);
                              fetchLeadHistory(item);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                          >
                            <FaHistory className="text-gray-500 text-sm shrink-0" />
                            Lead History
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setDeleteLeadId(item.leadId);
                              setDeleteModalOpen(true);
                              setActiveActionMenu(null);
                            }}
                            className="w-full flex items-center gap-2.5 px-3 py-1.5 text-xs text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
                          >
                            <FaBan className="text-red-500 text-sm shrink-0" />
                            Block Lead
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
                {expandedRows.includes(item.leadId) && (
                  <tr className="bg-gray-50 dark:bg-gray-800">
                    <td colSpan="12" className="p-4">
                      <div className="grid grid-cols-1 md:w-[85vw] w-[70vw]  md:grid-cols-3 lg:grid-cols-3 gap-6">
                        {/* Basic Info Card */}
                        <div className="bg-white  dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
                          <h3 className="md:text-lg text-base font-semibold text-blue-600 mb-2">
                            Basic Info
                          </h3>
                          <p>
                            <span className="font-medium">Name:</span>{" "}
                            {item.name}
                          </p>
                          <p>
                            <span className="font-medium">Email:</span>{" "}
                            {item.email}
                          </p>
                          <p>
                            <span className="font-medium">Phone:</span>{" "}
                            <td className="p-1 flex items-center gap-2">
                              {/* Phone Call Icon */}
                              {item.phone && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePhoneCall(item);
                                  }}
                                  className="relative flex items-center justify-center w-5 h-5 rounded-full bg-green-500 text-white hover:bg-green-600"
                                  title="Click to Call"
                                >
                                  {/* Ping animation */}
                                  <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
                                  <FaPhone className="relative z-10 text-[10px] -scale-x-100 transform" />                                </button>
                              )}

                              {/* Phone Number */}
                              {item.phone && (
                                <a
                                  href={`tel:${item.phone}`}
                                  onClick={(e) => e.stopPropagation()}
                                  className="text-[#673AB7] hover:underline truncate max-w-[120px]"
                                  title={item.phone}
                                >
                                  {item.phone}
                                </a>
                              )}
                            </td>
                          </p>
                          <p>
                            <span className="font-medium">Company:</span>{" "}
                            {item.companyName || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                        </div>

                        {/* Lead Details Card */}
                        <div className="bg-white dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
                          <h3 className="md:text-lg text-base font-semibold text-green-600 mb-2">
                            Lead Details
                          </h3>
                          <p>
                            <span className="font-medium">Status: </span>{" "}
                            {item.statusName}
                          </p>
                          <p>
                            <span className="font-medium">Source: </span>{" "}
                            {item.sourceName || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                          <p>
                            <span className="font-medium">Assigned To:</span>{" "}
                            {item.assignedToName || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>

                          <p>
                            <span className="font-medium">Created:</span>{" "}
                            {(() => {
                              const d = new Date(item.createdAt);
                              const day = String(d.getDate()).padStart(2, "0");
                              const month = String(d.getMonth() + 1).padStart(
                                2,
                                "0",
                              );
                              const year = d.getFullYear();

                              let hours = d.getHours();
                              const minutes = String(d.getMinutes()).padStart(
                                2,
                                "0",
                              );
                              const ampm = hours >= 12 ? "PM" : "AM";
                              hours = hours % 12;
                              hours = hours ? hours : 12; // the hour '0' should be '12'
                              const strHours = String(hours).padStart(2, "0");

                              return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
                            })()}
                          </p>
                        </div>

                        {/* Additional Info Card */}
                        <div className="bg-white dark:bg-gray-900 p-4 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
                          <h3 className=" md:text-lg text-base font-semibold text-purple-600 mb-2">
                            Additional Info
                          </h3>
                          <p>
                            <span className="font-medium">Address:</span>{" "}
                            {item.address || (
                              <span className="text-gray-400">_blank</span>
                            )}
                          </p>
                          {/* Add City and State here */}
                          <p>
                            <span className="font-medium">City:</span>{" "}
                            {item.city || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                          <p>
                            <span className="font-medium">State:</span>{" "}
                            {item.state || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                          {/* End of added fields */}
                          <p>
                            <span className="font-medium">
                              Other Contact No.:
                            </span>{" "}
                            {item.otherContactNo || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                          <p>
                            <span className="font-medium">Blacklisted:</span>{" "}
                            {item.isBlackListed ? "Yes" : "No"}
                          </p>
                          <p>
                            <span className="font-medium">Created By:</span>{" "}
                            {item.createdByName || (
                              <span className="text-gray-400">_</span>
                            )}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
            {data?.length === 0 && (
              <tr>
                <td colSpan="9" className="text-center  p-4">
                  {isSearching ? "Searching..." : "Loading..."}
                </td>
              </tr>
            )}


          </tbody>
        </table>
      </div>
      {/* Pagination - normal (non-search) listing. Still page-number based; unrelated
          backend endpoint, unchanged. */}
      {!isSearchMode && totalPages > 0 && (
        <div className="mt-4 flex flex-wrap justify-center items-center gap-2 sm:gap-3">
          <button
            onClick={(e) => {
              e.preventDefault();
              setPageNumber(0);
              fetchPage(0);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={pageNumber === 0}
          >
            First
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              const newPage = Math.max(pageNumber - 1, 0);
              setPageNumber(newPage);
              fetchPage(newPage);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={pageNumber === 0}
          >
            Prev
          </button>

          <span className="text-xs sm:text-sm font-medium whitespace-nowrap">
            Page {pageNumber + 1} of {totalPages}
          </span>

          <button
            onClick={(e) => {
              e.preventDefault();
              const newPage = Math.min(pageNumber + 1, totalPages - 1);
              setPageNumber(newPage);
              fetchPage(newPage);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={pageNumber >= totalPages - 1}
          >
            Next
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              setPageNumber(totalPages - 1);
              fetchPage(totalPages - 1);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={pageNumber >= totalPages - 1}
          >
            Last
          </button>
        </div>
      )}

      {/* Pagination - search results. Cursor-based: no total page count is available (or
          computed) anymore, so there's no "of N" text and no "Last" button - only
          Prev/Next/First, driven by goToSearchPage. */}
      {isSearchMode && (data?.length > 0 || searchPageIndex > 0) && (
        <div className="mt-4 flex flex-wrap justify-center items-center gap-2 sm:gap-3">
          <button
            onClick={(e) => {
              e.preventDefault();
              goToSearchPage(0);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={searchPageIndex === 0}
          >
            First
          </button>

          <button
            onClick={(e) => {
              e.preventDefault();
              goToSearchPage(searchPageIndex - 1);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={searchPageIndex === 0}
          >
            Prev
          </button>

          <span className="text-xs sm:text-sm font-medium whitespace-nowrap">
            Page {searchPageIndex + 1}
          </span>

          <button
            onClick={(e) => {
              e.preventDefault();
              goToSearchPage(searchPageIndex + 1);
            }}
            className="px-3 py-1 sm:px-4 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-xs sm:text-sm text-[#673AB7] rounded disabled:opacity-50"
            disabled={!searchHasMore}
          >
            Next
          </button>
        </div>
      )}

      <DownloadReportModal
        isDownloadModalOpen={isDownloadModalOpen}
        setIsDownloadModalOpen={setIsDownloadModalOpen}
        downloadParams={downloadParams}
        setDownloadParams={setDownloadParams}
        users={users}
        labels={labels}
        statuses={statuses}
        sourceOptions={sourceOptions}
        handleDownloadReport={handleDownloadReport}
      />

      {/* Assign Leads Modal */}
      {isAssignModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-bold mb-4">Assign Leads</h2>
            <select
              className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
              onChange={(e) => setAssignToUserId(e.target.value)}
            >
              <option value="">Select User</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.fname} {user.lname}
                </option>
              ))}
            </select>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setIsAssignModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
                onClick={handleAssignLeads}
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Lead Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-lg md:max-w-3xl lg:max-w-4xl bg-white dark:bg-gray-800 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto">
            {/* Sticky Header with Close Button */}
            <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 flex justify-between items-center border-b border-gray-200 dark:border-gray-700 px-4 py-3">
              <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                Update Lead
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-red-500 text-lg md:text-xl hover:text-red-600"
                aria-label="Close Modal"
              >
                ✖
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-4 py-4">
              {/* <LeadForm
                leadId={selectedLeadId}
                updatedFormData={formData}
                setIsFormUpdated={setIsFormUpdated}
                closeModal={() => setIsModalOpen(false)}
              /> */}

              <LeadForm
                leadId={selectedLeadId}
                updatedFormData={formData}
                setIsFormUpdated={setIsFormUpdated}
                closeModal={(updatedLead) => {
                  setIsModalOpen(false);

                  // ✅ update only edited lead in table
                  if (updatedLead) {
                    updateLeadInTable(selectedLeadId, updatedLead);
                  }
                }}
              />



            </div>
          </div>
        </div>
      )}

      {/* Delete Lead Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 dark:bg-gray-700 dark:text-white">
            <h2 className="text-xl font-bold mb-4">Block Lead</h2>
            <p className="mb-2">Please enter a reason for block:</p>
            <input
              type="text"
              className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
              placeholder="Enter reason..."
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
            />
            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setDeleteModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={handleDeleteConfirm}
                disabled={!deleteReason.trim()}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Label Modal */}
      {isLabelModalOpen && (
        <LabelModal
          isOpen={isLabelModalOpen}
          onClose={() => setIsLabelModalOpen(false)}
          labels={labels}
          selectedProjectId={selectedProjectId}
          setSelectedProjectId={setSelectedProjectId}
          onLabelSelect={handleLabelSelect}
        />
      )}

      {/* Convert to Customer Modal */}
      <ConvertModal />
      <EmailModal
        isEmailModalOpen={isEmailModalOpen}
        templates={templates}
        selectedLeadForEmail={selectedLeadForEmail}
        setSelectedLeadForEmail={setSelectedLeadForEmail}
        selectedTemplate={selectedTemplate}
        setSelectedTemplate={setSelectedTemplate}
        templateVariables={templateVariables}
        setTemplateVariables={setTemplateVariables}
        selectedTemplateData={selectedTemplateData}
        setSelectedTemplateData={setSelectedTemplateData}
        isSending={isSending}
        setIsSending={setIsSending}
        user={user}
        fetchData={fetchData}
        onClose={() => {
          setIsEmailModalOpen(false);
          setSelectedTemplate("");
          setSelectedLeadForEmail("");
          setTemplateVariables({});
          setSelectedTemplateData(null);
        }}
      />

      {/* ── NEW: Call History popup - same /call-recordings API as Card view ── */}
      <CallHistoryModal
        open={showCallHistoryModal}
        lead={callHistoryLead}
        data={callHistoryData}
        loading={callHistoryLoading}
        onClose={() => setShowCallHistoryModal(false)}
      />

      {showHistoryModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-3 sm:px-4 py-3">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-5 sm:p-6 relative dark:bg-gray-700 dark:text-white">
            {/* Modal Header */}
            <div className="flex justify-between items-center pb-3 dark:bg-gray-700 dark:text-white">
              <h2 className="text-lg sm:text-xl font-semibold cfg-heading dark:text-white">
                Lead History
              </h2>

              <button
                onClick={() => setShowHistoryModal(false)}
                className="text-gray-600 hover:text-red-500 text-xl font-bold transition"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div className=" mb-1 ">
              <div className="flex items-center text-sm gap-1">
                <span className="font-medium   ">Lead Name :</span>
                <span className="text-[#673AB7]   capitalize   dark:text-[#8B5CF6]">
                  {selectedLeadName}
                </span>
              </div>
              <div className="flex items-center text-sm  gap-1">
                <span className="font-medium">Phone:</span>
                <span className="text-green-600 dark:text-green-300">
                  {selectedLeadPhone}
                </span>
              </div>
            </div>
            {/* Modal Content */}
            <div className="mt-4 max-h-[65vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:bg-gray-700 dark:text-white">
              {historyData && historyData.length > 0 ? (
                [...historyData]
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .map((item, index) => (
                    <div
                      key={item.historyId || index}
                      className="border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50 hover:shadow-sm transition dark:bg-gray-700 dark:text-white"
                    >
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700 mb-2 dark:bg-gray-700 dark:text-white">
                        <div>
                          <span className="text-gray-500 dark:text-white">
                            Changed By:
                          </span>{" "}
                          {item.changedByName}
                        </div>
                        {/* <div>
                          <span className="text-gray-500 dark:text-white">
                            Change Type:
                          </span>{" "}
                          {item.changeType}
                        </div> */}

                        <div className="">
                          {/* Changed By */}
                          <div className="flex items-center mb-3">
                            <div className="w-8 h-8 bg-[#F3E8FF] dark:bg-blue-900 rounded-full flex items-center justify-center mr-2">
                              <span className="text-[#673AB7] dark:text-[#8B5CF6] font-medium text-sm">
                                {item.changedByName?.charAt(0) || "U"}
                              </span>
                            </div>
                            <div>
                              <div className="text-sm font-medium text-gray-800 dark:text-white">
                                {item.changedByName || "Unknown User"}
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                {/* {new Date(item.createdAt).toLocaleString()} */}

                                {(() => {
                                  const d = new Date(item.createdAt);
                                  const day = String(d.getDate()).padStart(
                                    2,
                                    "0",
                                  );
                                  const month = String(
                                    d.getMonth() + 1,
                                  ).padStart(2, "0");
                                  const year = d.getFullYear();

                                  let hours = d.getHours();
                                  const minutes = String(
                                    d.getMinutes(),
                                  ).padStart(2, "0");
                                  const ampm = hours >= 12 ? "PM" : "AM";
                                  hours = hours % 12;
                                  hours = hours ? hours : 12; // convert 0 hour to 12
                                  const strHours = String(hours).padStart(
                                    2,
                                    "0",
                                  );

                                  return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
                                })()}
                              </div>
                            </div>
                          </div>

                          {/* Change Type Container */}
                          <div className="border-l-2 border-[#8B5CF6] pl-4 ml-3">
                            {/* Change Type Header */}
                            <div className="mb-2">
                              <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                {item.changeType.includes("UPDATED_FIELDS")
                                  ? "Fields Updated"
                                  : item.changeType}
                              </span>
                            </div>

                            {/* Changes Content */}
                            <div className="space-y-2">
                              {(() => {
                                if (item.changeType === "lead created") {
                                  return (
                                    <div className="flex items-start">
                                      <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-green-500 rounded-full flex-shrink-0"></span>
                                      <span className="text-sm text-green-600 dark:text-green-400 font-medium">
                                        Lead was created successfully
                                      </span>
                                    </div>
                                  );
                                }

                                // Parse UPDATED_FIELDS
                                if (
                                  item.changeType.includes("UPDATED_FIELDS")
                                ) {
                                  const changeText = item.changeType.replace(
                                    "UPDATED_FIELDS: ",
                                    "",
                                  );
                                  const changes = [];

                                  // Parse each field change but EXCLUDE Status Color
                                  const fieldRegex =
                                    /([^:]+?)\s*\[From:\s*([^,]+),\s*To:\s*([^\]]+)\]/g;
                                  let match;

                                  while (
                                    (match = fieldRegex.exec(changeText)) !==
                                    null
                                  ) {
                                    const field = match[1].trim();
                                    const from = match[2].trim() || "Empty";
                                    const to = match[3].trim();

                                    // SKIP Status Color
                                    if (
                                      field
                                        .toLowerCase()
                                        .includes("status color") ||
                                      field.toLowerCase().includes("color")
                                    ) {
                                      continue;
                                    }

                                    changes.push({ field, from, to });
                                  }

                                  // If no changes after filtering (or regex fails)
                                  if (changes.length === 0) {
                                    // Filter out Status Color lines manually
                                    const filteredLines = changeText
                                      .split(",")
                                      .filter(
                                        (line) =>
                                          !line
                                            .toLowerCase()
                                            .includes("status color") &&
                                          !line.toLowerCase().includes("color"),
                                      );

                                    return filteredLines.map((line, index) => (
                                      <div
                                        key={index}
                                        className="flex items-start"
                                      >
                                        <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-[#8B5CF6] rounded-full flex-shrink-0"></span>
                                        <span className="text-sm text-gray-700 dark:text-gray-300">
                                          {line.trim()}
                                        </span>
                                      </div>
                                    ));
                                  }

                                  // Render parsed changes (Status Color already filtered out)
                                  return changes.map((change, index) => (
                                    <div
                                      key={index}
                                      className="flex items-start"
                                    >
                                      <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-[#8B5CF6] rounded-full flex-shrink-0"></span>
                                      <div className="flex-1">
                                        <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                          {change.field}
                                        </div>
                                        <div className="flex items-center text-sm space-x-2">
                                          <div className="flex items-center">
                                            <span className="text-gray-500 dark:text-gray-400 text-xs mr-1">
                                              From:
                                            </span>
                                            <span className="px-2 py-0.5 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded text-xs">
                                              {change.from}
                                            </span>
                                          </div>
                                          <span className="text-gray-400">
                                            →
                                          </span>
                                          <div className="flex items-center">
                                            <span className="text-gray-500 dark:text-gray-400 text-xs mr-1">
                                              To:
                                            </span>
                                            <span className="px-2 py-0.5 bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 rounded text-xs">
                                              {change.to}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ));
                                }

                                // Fallback for other change types
                                return (
                                  <div className="flex items-start">
                                    <span className="inline-block w-2 h-2 mt-1.5 mr-2 bg-gray-400 rounded-full flex-shrink-0"></span>
                                    <span className="text-sm text-gray-700 dark:text-gray-300">
                                      {item.changeType}
                                    </span>
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                        </div>

                        <div className="sm:col-span-2">
                          <span className="text-gray-500 dark:text-white">
                            Time:
                          </span>{" "}
                          {(() => {
                            const d = new Date(item.createdAt);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = String(d.getMonth() + 1).padStart(
                              2,
                              "0",
                            );
                            const year = d.getFullYear();

                            let hours = d.getHours();
                            const minutes = String(d.getMinutes()).padStart(
                              2,
                              "0",
                            );
                            const ampm = hours >= 12 ? "PM" : "AM";
                            hours = hours % 12;
                            hours = hours ? hours : 12; // convert 0 hour to 12
                            const strHours = String(hours).padStart(2, "0");

                            return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
                          })()}
                        </div>
                      </div>

                      {item.oldValues && item.newValues && (
                        <div className="border-t border-gray-200 pt-2 mt-2 dark:bg-gray-700 dark:text-white">
                          <p className="text-gray-600 text-sm font-medium mb-1">
                            Changes
                          </p>
                          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
                            {Object.entries(item.oldValues).map(
                              ([key, oldVal]) => (
                                <li key={key}>
                                  <span className="font-medium">{key}:</span>{" "}
                                  <span className="text-red-500 line-through">
                                    {JSON.stringify(oldVal)}
                                  </span>{" "}
                                  <span className="text-green-600">
                                    → {JSON.stringify(item.newValues[key])}
                                  </span>
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))
              ) : (
                <p className="text-center text-sm text-gray-500 mt-4 dark:bg-gray-700 dark:text-white">
                  No history available for this lead.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      {isReminderModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-start overflow-y-auto py-10">
          {/* Prevent body scroll while modal is open */}
          <style>{`body { overflow: hidden; }`}</style>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
            {/* Scrollable Content */}
            <div className="max-h-[80vh] overflow-y-auto p-4 sm:p-6 md:p-8">
              {/* Close Button */}
              <button
                className="absolute top-3 right-3 text-3xl text-gray-600 dark:text-white hover:text-red-500 focus:outline-none"
                onClick={() => {
                  setIsReminderModalOpen(false);
                  document.body.style.overflow = "auto"; // Restore scroll
                }}
              >
                &times;
              </button>

              {/* Reminder Form */}
              <ReminderForm
                onSubmit={(formValues) => {
                  const payload = {
                    ...formValues,
                    leadId: selectedLeadId,
                  };
                  console.log("Reminder form submitted:", payload);
                  handleReminderFormSubmit(payload);
                  setIsReminderModalOpen(false);
                  document.body.style.overflow = "auto";
                }}
                onClose={() => {
                  setIsReminderModalOpen(false);
                  document.body.style.overflow = "auto";
                }}
              />
            </div>
          </div>
        </div>
      )}

      {isWhatsappModelOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 transition-opacity duration-300 p-2 sm:p-4">
          <div className="bg-white dark:bg-gray-900 p-4 sm:p-6 rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto relative animate-fadeIn">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-green-600">
                Send WhatsApp Message
              </h2>
              <button
                onClick={() => {
                  setIsWhatsappModelOpen(false);
                  setSelectedWhatsappTemplate("");
                  setSelectedWhatsappTemplateBody("");
                  setWhatsappVariableValues({});
                }}
                className="text-gray-500 hover:text-red-500 text-xl"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSendWhatsapp} className="space-y-4">
              {/* Dropdown */}
              <div>
                <label className="block mb-1 font-medium text-sm">
                  Select Template
                </label>
                <select
                  className="w-full border rounded p-2 text-sm dark:bg-gray-800 dark:text-white"
                  value={selectedWhatsappTemplate}
                  onChange={(e) => handleTemplateChange(e.target.value)}
                >
                  <option value="">-- Select Template --</option>
                  {template.map((tpl) => (
                    <option key={tpl.id || tpl.name} value={tpl.name}>
                      {tpl.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Template Preview with responsive design for long text */}
              {selectedWhatsappTemplateBody && (
                <div className="p-3 border rounded bg-gray-50 dark:bg-gray-800 text-sm">
                  <span className="font-semibold text-green-600 block mb-2">
                    Preview:
                  </span>
                  <div className="max-h-40 overflow-y-auto p-2 bg-white dark:bg-gray-700 rounded border">
                    <p className="text-gray-700 dark:text-gray-200 break-words whitespace-pre-wrap">
                      {getWhatsappPreviewText(selectedWhatsappTemplateBody)}
                    </p>
                  </div>
                </div>
              )}

              {/* ✅ ADD ONLY – DO NOT REMOVE ANYTHING: Fill Variables (Var 1, Var 2, ...) */}
              {selectedWhatsappTemplateBody &&
                extractWhatsappVariables(selectedWhatsappTemplateBody).length >
                0 && (
                  <div className="border-t pt-3 dark:border-gray-700">
                    <label className="block text-gray-700 font-medium mb-2 text-sm dark:text-white">
                      Fill Variables:
                    </label>
                    <div className="space-y-2">
                      {extractWhatsappVariables(
                        selectedWhatsappTemplateBody,
                      ).map((v) => (
                        <div
                          key={v}
                          className="flex items-center gap-2"
                        >
                          <span className="text-xs font-bold text-gray-500 dark:text-gray-300 min-w-[45px]">
                            Var {v}:
                          </span>
                          <input
                            type="text"
                            className="w-full p-2 border rounded text-sm dark:bg-gray-700 dark:text-white"
                            placeholder={`Value for {{${v}}}`}
                            value={whatsappVariableValues[v] || ""}
                            onChange={(e) =>
                              handleWhatsappVariableChange(v, e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => {
                    setIsWhatsappModelOpen(false);
                    setSelectedWhatsappTemplate("");
                    setSelectedWhatsappTemplateBody("");
                    setWhatsappVariableValues({});
                  }}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 text-sm order-2 sm:order-1"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={!selectedWhatsappTemplate}
                  className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 text-sm order-1 sm:order-2 disabled:opacity-50"
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isTaskModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-start overflow-y-auto py-10">
          {/* Prevent body scroll while modal is open */}
          <style>{`body { overflow: hidden; }`}</style>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl mx-4 relative">
            {/* Scrollable Content */}
            <div className="max-h-[80vh] overflow-y-auto p-4 sm:p-6 md:p-8">
              <h2 className="text-xl font-bold">Create Task</h2>
              {/* Close Button */}
              <button
                className="absolute top-3 right-3 text-3xl text-gray-600 dark:text-white hover:text-red-500 focus:outline-none"
                onClick={() => {
                  setIsTaskModalOpen(false);
                  document.body.style.overflow = "auto"; // Restore scroll
                }}
              >
                &times;
              </button>

              {/* Reminder Form */}
              <TaskForm
                leadId={selectedLeadId}
                onSubmit={(formValues) => {
                  const payload = {
                    ...formValues,
                    leadId: selectedLeadId,
                  };
                  console.log("Reminder form submitted:", payload);
                  handleTaskSubmit(payload);
                  setIsTaskModalOpen(false);
                  document.body.style.overflow = "auto";
                }}
                onClose={() => {
                  setIsTaskModalOpen(false);
                  document.body.style.overflow = "auto";
                }}
              />
            </div>
          </div>
        </div>
      )}
      {isFollowUpModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-700 dark:text-white w-full max-w-md rounded-lg shadow-lg flex flex-col max-h-[90vh]">
            {/* Header (fixed) */}
            <div className="p-4 border-b dark:border-gray-600 flex justify-between items-center">
              <h2 className="text-lg font-semibold cfg-heading">Lead Follow Up</h2>

              <button
                onClick={() => fetchFollowUpHistory(selectedLeadId)}
                className="flex items-center text-[#673AB7] hover:text-[#5E35A6] text-sm"
              >
                <FaHistory className="mr-1" />
                History
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-4 py-3 space-y-4 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
              {/* Lead Info */}
              <div className="space-y-1 text-sm">
                <div className="flex gap-1">
                  <span className="font-medium">Lead Name:</span>
                  <span className="text-[#673AB7] dark:text-[#8B5CF6] capitalize">
                    {selectedLeadName}
                  </span>
                </div>
                <div className="flex gap-1">
                  <span className="font-medium">Phone:</span>
                  <span className="text-green-600 dark:text-green-300">
                    {selectedLeadPhone}
                  </span>
                </div>
              </div>

              {/* Notes */}
              <div className="flex flex-col space-y-1">
                <label className="text-sm font-medium">Notes</label>
                <textarea
                  rows={3}
                  className="w-full p-2 border rounded dark:bg-gray-700"
                  placeholder="Enter notes"
                  value={followUpData.notes}
                  onChange={(e) =>
                    setFollowUpData({ ...followUpData, notes: e.target.value })
                  }
                />
              </div>

              {/* Date */}
              <div className="flex flex-col space-y-1">
                <label className="text-sm font-medium">
                  Next Follow-up Date
                </label>
                <input
                  type="date"
                  className="w-full p-2 border rounded dark:bg-gray-700"
                  value={followUpData.nextFollowUpDate}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(e) =>
                    setFollowUpData({
                      ...followUpData,
                      nextFollowUpDate: e.target.value,
                    })
                  }
                />
              </div>

              {/* Time */}
              <div className="flex flex-col space-y-1">
                <label className="text-sm font-medium">
                  Next Follow-up Time
                </label>
                <input
                  type="time"
                  className="w-full p-2 border rounded dark:bg-gray-700"
                  value={followUpData.nextFollowUpTime}
                  onChange={(e) =>
                    setFollowUpData({
                      ...followUpData,
                      nextFollowUpTime: e.target.value,
                    })
                  }
                />
              </div>

              {/* Followed By */}
              <div className="flex flex-col space-y-1">
                <label className="text-sm font-medium">Followed By</label>
                <Select
                  placeholder="Select User"
                  value={followUpData.followedById || undefined}
                  options={users.map((u) => ({
                    value: u.id,
                    label: `${u.fname} ${u.lname}`,
                  }))}
                  onChange={(value) => {
                    const user = users.find((u) => u.id === value);
                    setFollowUpData((prev) => ({
                      ...prev,
                      followedById: value,
                      followedByName: user ? `${user.fname} ${user.lname}` : "",
                    }));
                  }}
                />
              </div>

              {/* Status */}
              <div className="p-2 border rounded bg-gray-50 dark:bg-gray-800">
                <label className="text-sm font-medium mb-1 block">
                  Update Status
                </label>
                <select
                  className="w-full p-2 border rounded text-sm dark:bg-gray-700"
                  value={followUpData.selectedStatus || ""}
                  onChange={(e) => {
                    const status = statuses.find(
                      (s) => s.name === e.target.value,
                    );
                    if (status) {
                      setSelectedStatus(status);
                      setShowModal(true);
                      setFollowUpData((prev) => ({
                        ...prev,
                        selectedStatus: e.target.value,
                      }));
                    }
                  }}
                >
                  <option value="">-- Select Status --</option>
                  {statuses
                    .filter((s) => s.active)
                    .map((s) => (
                      <option key={s.name} value={s.name}>
                        {s.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* Footer (fixed) */}
            <div className="p-4 border-t dark:border-gray-600 flex justify-end gap-2">
              <button
                onClick={() => setFollowUpModalOpen(false)}
                className="px-4 py-2 bg-gray-200 rounded text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleFollowUpSubmit}
                className="px-4 py-2 bg-teal-500 text-white rounded text-sm"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showFollowUpHistoryModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-3 sm:px-4 py-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-5 sm:p-6 relative dark:bg-gray-700 dark:text-white">
            {/* Modal Header */}
            <div className="flex justify-between items-center pb-3 border-gray-200 dark:bg-gray-700 dark:text-white">
              <h2 className="text-lg sm:text-xl font-semibold cfg-heading dark:text-white">
                Follow-up History
              </h2>
              <button
                onClick={() => setShowFollowUpHistoryModal(false)}
                className="text-gray-600 hover:text-red-500 text-xl font-bold transition"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div className=" mb-1 ">
              <div className="flex items-center text-sm gap-1">
                <span className="font-medium   ">Lead Name :</span>
                <span className="text-[#673AB7]   capitalize   dark:text-[#8B5CF6]">
                  {selectedLeadName}
                </span>
              </div>
              <div className="flex items-center text-sm  gap-1">
                <span className="font-medium">Phone:</span>
                <span className="text-green-600 dark:text-green-300">
                  {selectedLeadPhone}
                </span>
              </div>
            </div>
            {/* Modal Content */}
            <div className="mt-4 max-h-[65vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent dark:bg-gray-700 dark:text-white">
              {followUpHistory.length > 0 ? (
                // Sort follow-ups by date (newest first) and map through them
                [...followUpHistory]
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .map((item, index) => (
                    <div
                      key={item.id || index}
                      className="border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50 hover:shadow-sm transition dark:bg-gray-700 dark:text-white"
                    >
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700 mb-2 dark:bg-gray-700 dark:text-white">
                        <div>
                          <span className="text-gray-500 dark:text-white">
                            Followed By:
                          </span>{" "}
                          {item.followedByName}
                        </div>
                        <div>
                          <span className="text-gray-500 dark:text-white">
                            Created By:
                          </span>{" "}
                          {item.createdByName}
                        </div>

                        <div className="sm:col-span-2">
                          <span className="text-gray-500 dark:text-white">
                            Created At:
                          </span>{" "}
                          {(() => {
                            const d = new Date(item.createdAt);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = String(d.getMonth() + 1).padStart(
                              2,
                              "0",
                            );
                            const year = d.getFullYear();

                            let hours = d.getHours();
                            const minutes = String(d.getMinutes()).padStart(
                              2,
                              "0",
                            );
                            const ampm = hours >= 12 ? "PM" : "AM";
                            hours = hours % 12;
                            hours = hours ? hours : 12; // convert 0 hour to 12
                            const strHours = String(hours).padStart(2, "0");

                            return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
                          })()}
                        </div>
                      </div>

                      <div className="border-t border-gray-200 pt-2 mt-2 dark:bg-gray-700 dark:text-white">
                        <div className="mb-2">
                          <span className="text-gray-500 dark:text-white">
                            Notes:
                          </span>{" "}
                          <p className="text-gray-700 dark:text-white">
                            {item.notes || "No notes provided"}
                          </p>
                        </div>
                        <div>
                          <span className="text-gray-700 dark:text-white">
                            Next Follow-up:
                          </span>{" "}
                          {item.nextFollowUpDate && item.nextFollowUpTime ? (
                            <>
                              {/* {item.nextFollowUpDate} at {item.nextFollowUpTime} */}

                              {(() => {
                                const d = new Date(
                                  `${item.nextFollowUpDate} ${item.nextFollowUpTime}`,
                                );

                                const day = String(d.getDate()).padStart(
                                  2,
                                  "0",
                                );
                                const month = String(d.getMonth() + 1).padStart(
                                  2,
                                  "0",
                                );
                                const year = d.getFullYear();

                                let hours = d.getHours();
                                const minutes = String(d.getMinutes()).padStart(
                                  2,
                                  "0",
                                );
                                const ampm = hours >= 12 ? "PM" : "AM";
                                hours = hours % 12;
                                hours = hours ? hours : 12;
                                const strHours = String(hours).padStart(2, "0");

                                return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
                              })()}
                            </>
                          ) : (
                            "Not scheduled"
                          )}
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <p className="text-center text-sm text-gray-500 mt-4 dark:bg-gray-700 dark:text-white">
                  No follow-up history available for this lead.
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Status Reason Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
              Change Lead Status
            </h2>
            <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Reason for changing status:
            </label>
            <textarea
              rows={3}
              className="w-full border border-gray-300 p-2 rounded-md dark:bg-gray-700 dark:text-white"
              placeholder="Enter your reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />

            <div className="mt-4 flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowModal(false);
                  setReason("");
                }}
                className="px-4 py-2 bg-gray-300 dark:bg-gray-600 rounded hover:bg-gray-400 dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleModalSubmit}
                className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6]"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {isSmsModalOpen && (
        <SmsModal
          isSmsModalOpen={isSmsModalOpen}
          smsTemplates={smsTemplates}
          selectedLeadForSms={selectedLeadForSms}
          setSelectedLeadForSms={setSelectedLeadForSms}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          templateVariables={templateVariables}
          setTemplateVariables={setTemplateVariables}
          selectedTemplateData={selectedTemplateData}
          setSelectedTemplateData={setSelectedTemplateData}
          isSending={isSending}
          setIsSending={setIsSending}
          user={user}
          fetchData={fetchData}
          onClose={() => {
            setIsSmsModalOpen(false);
            setSelectedTemplate("");
            setSelectedLeadForSms("");
            setTemplateVariables({});
            setSelectedTemplateData(null);
          }}
        />
      )}
    </div>
  );
};

export default TableView;